<template>
  <div class="main-content bg-pos">
    <!-- Navbar -->
    <NavbarPos :userLogin="userlogin" :shopSetting="shop_setting" :allowCoupon="this.main_allow_coupon && this.main_use_walletV2" />
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div id="el-banner"></div>
    <!-- Page content -->
    <div class="container-fluid pb-5 pos overflow-hidden">
      <slide-y-up-transition mode="out-in" origin="center top">
        <CheckPricePage v-if="posPage.step == getStepPage.STEP_PAGE_CHECKPRICE" :busy="busy"
          :tmpCheckPrice="tmpCheckPrice" :posPage="posPage" :listSize="listSize" :sameData="sameData"
          @clearDataTmpCheckPrice="clearDataTmpCheckPrice" @courierCheckPrice="courierCheckPrice" />
        <div class="row justify-content-center" v-if="posPage.step == getStepPage.STEP_PAGE_FIRST">
          <!-- box-รายการสินค้า -->
          <div :class="showCart === 'non-slide' ? '' : 'pr-0'" class="col-md col-xl smooth-trans">
            <CourierComponents @checkPriceFrom="changetmpCheckPrice" @openModalDraft="openModalFromKey"
              :showSuccessModal="showSuccessModal" @hasErrorRefMemId="hasErrorRefMemId" ref="tabCourier"
              :showCart="showCart" :shopDetail="shopDetail" :cart="cart" :zendai="zendai" :refMemberId="refMemberId"
              :insurance="insurance" :insuranceService="insuranceService" :addServiceNew="addServiceNew"
              :tmpService="tmpService" :busy="busy" :sender="sender" :draft_storage="draft_storage" :idorder="idorder"
              :shop_id="shop_id" :posPage="posPage" :couriers="couriers" :searchCourier="searchCourier"
              :permission="permission" :dropoffVRich="dropoffVRich" :dropoffPanPan="dropoffPanPan"
              :dropoffEasyShip="dropoffEasyShip" :dropoffQuick="dropoffQuick" :dropoffLine="dropoffLine" :cod="cod"
              :lockCardCourier="lockCardCourier" :courierDropoffVRich="courierDropoffVRich"
              :courierDropoffEasyShip="courierDropoffEasyShip" :courierDropoffQuick="courierDropoffQuick"
              :showCourier="showCourier" :listSize="listSize" :DROPOFF_SP="DROPOFF_SP" :KERRY_DROPOFF="KERRY_DROPOFF"
              :LAZADA_DROPOFF="LAZADA_DROPOFF" :ORANGE_DROPOFF="ORANGE_DROPOFF" :FLASH_DROPOFF="FLASH_DROPOFF"
              :courierModalTime="courierModalTime" :count="count" :openModal="openModal" :beforeGetShop="beforeGetShop"
              :openModalFromKey="openModalFromKey" :addToCart="addToCart" @openCartComponent="openCartComponent($event)"
              :addDraftStorage="addDraftStorage" :checkDisableCardCourier="checkDisableCardCourier"
              :openModalService="openModalService" />
          </div>
          <InterParcelService :setting="interParcelService" :confirmFunc="addOrderInterParcel" />

          <!-- box-ตารางสินค้า -->
          <div :class="showCart === 'non-slide'
            ? 'dialog col-md-6 col-xl-5 pos-r-lg-max'
            : 'dialog-reverse-pos col-md-1 col-xl-1 pl-0 max-width-fix'">
            <CartComponents :selectedCourier="selectedCourier" :label="label" :typeOfLabel="typeOfLabel"
              :showCart="showCart" :sender="sender" :idorder="idorder" :cart="cart" :search="search"
              :checkBill="checkBill" :labeltype="labeltype" :shippop="shippop" :labeltypeDropoff="labeltypeDropoff"
              :isLoadingNewBill="isLoadingNewBill" :total="total" :modalConfirmReset="modalConfirmReset"
              :checkThemeQuick="checkThemeQuick" :checkUntiKG="checkUntiKG" :cartShipping="cartShipping"
              :switchPrintLabel="switchPrintLabel" :editParcel="editParcel"
              :checkBeforeRemoveTotal="checkBeforeRemoveTotal" :reload="reload" :removeTotal="removeTotal"
              :cartDropoffShippop="cartDropoffShippop" :filterCheckLazadaDropoff="filterCheckLazadaDropoff"
              :filterCheckKerryDropoff="filterCheckKerryDropoff" :filterCheckOrderDetailId="filterCheckOrderDetailId"
              :filterCheckDropoffVRich="filterCheckDropoffVRich" :filterCheckDropoffPanPan="filterCheckDropoffPanPan"
              :filterCheckDropoffQuick="filterCheckDropoffQuick" :filterCheckDropoffLAO="filterCheckDropoffLAO"
              :filterCheckDropoffINTER="filterCheckDropoffINTER" :filterCheckFlashDropoff="filterCheckFlashDropoff"
              :beforeCheckbill="beforeCheckbill" @slideCart="slideDialog"
              @openCartComponent="openCartComponent($event)" />
          </div>
          <!-- modal เลือกขนส่ง cod -->
          <CodCourierList :cod="cod_details" :sender="sender" :checkVerifyMemberCod="checkVerifyMemberCod"
            :func="modalOrders"></CodCourierList>
          <!-- modal dropoff cod -->
          <DropoffShippop :dropoff="dropoffShippopDetails" :confirm="addDropoffShippopOrder"></DropoffShippop>
          <!-- modal kerry dropoff -->
          <KerryDropoff ref="kerryDropoff" :kerryDropoff="kerryDropoff" :count.sync="count" :addressFrom="from"
            :cartKerryDropoff="cartKerryDropoff" :listSize="listSize"
            @confirmCreateKerryDropoff="confirmCreateKerryDropoff($event)" :shopId="shop_id" />
          <!-- modal flash express dropoff -->
          <FlashDropoff ref="flashDropoff" :flashDropoff="flashDropoff" :count.sync="count" :addressFrom="from"
            :cartFlashDropoff="cartFlashDropoff" :listSize="listSize"
            @confirmCreateFlashDropoff="confirmCreateFlashDropoff($event)" :shopId="shop_id" />

          <LazadaDropoff ref="lazadaDropoff" :lazadaDropoff="lazadaDropoff" :count.sync="count" :addressFrom="from"
            :cartLazadaDropoff="cartLazadaDropoff" @confirmCreateLazadaDropoff="confirmCreateLazadaDropoff($event)"
            :shopId="shop_id" />

          <!-- modal เพิ่มรายการพัสดุ -->
          <TableAddOrders :orders="addMoreOrder" :func="{
            'createOrder': handleModalCreateOrder,
            'editOrder': editParcel,
            'closeModal': closeParcel,
            'confirmOrder': confirmShipping
          }" @editorder="editParcel">
          </TableAddOrders>
          <!-- <TableAddOrders :orders="addMoreOrder" @editParcel="editParcel()"
            :func="{ 'createOrder' : handleModalCreateOrder  }" >
          </TableAddOrders> -->
          <!-- Modal ประกันเสริม -->
          <ModalInsurance ref="insurance" :insuranceService="insuranceService" @addInsurance="addInsurance()"
            @clearInsurance="clearInsurance()" />
          <!-- Modal บริการเสริม -->
          <ModalService :fee="fee" @addService="addService()" />
          <!-- Modal พื้นที่ห่างไกล -->
          <ModalAlertRemoteArea :remoteArea="remote_area" :crossPrice="crossPrice" />

          <!-- Modal E-Voucher-->
          <ModalShabuEVoucher ref="shabu" :shabuEVoucher="shabuEVoucher" @addShabuEVoucher="addShabuEVoucher()"
            @clearShabuEVoucher="clearShabuEVoucher()" />

          <!-- Modal Zendai-->
          <ModalZendai ref="zendai" :zendai="zendai" :sender="sender" @addZendai="addZendai()" />

          <!-- Modal พัสดุ -->
          <b-modal centered no-close-on-backdrop no-close-on-esc ref="model-parcel" id="model-parcel" @close="closeParcel"
            size="lg" hide-footer :no-stacking="!noticeCodInfoModal.open && !codAgreementModal.open">
            <!-- :no-stacking="(checkThemeQuick()) ? false : true" -->
            <template slot="modal-title" class="w-100">
              <div slot="header" class="bg-white border-0" ref="model-parcel-header">
                <div class="row align-items-center">
                  <div class="col-6 d-flex align-items-center">
                    <h3 class="mb-0">
                      ข้อมูลการจัดส่ง
                      <span v-if="iconUrl.status == false">{{ iconUrl.courierName }}</span>
                    </h3>

                    <img v-if="iconUrl.status != false
                      && !checkDropoffVRich()
                      && !checkDropoffEasyShip()
                      && !checkDropoffQuick()
                      && !checkDropoffPanPan()" class="card-img-top img-mx-100 pl-3" :src="iconUrl.url"
                      img-alt="Image" />

                    <img v-if="checkDropoffVRich()" class="card-img-top img-mx-100 pl-3"
                      src="/img/courier_icons/vrich-logo.png" img-alt="ImageVRich" />

                    <img v-if="checkDropoffPanPan()" class="card-img-top img-mx-100 pl-3"
                      src="img/courier_icons/panpanworld-logo.png" img-alt="ImagePanPan" />

                    <img v-if="checkDropoffQuick()" class="card-img-top img-mx-100 pl-3"
                      src="/img/courier_icons/quick-logo.png" img-alt="ImageQuick" />

                    <img v-if="checkDropoffEasyShip()" class="card-img-top img-mx-100 pl-3"
                      src="/img/courier_icons/easyship-logo.png" img-alt="ImageEasyShip" />
                  </div>
                </div>
              </div>
            </template>
            <card shadow type="secondary" class="m--4">
              <template>
                <template v-if="selectedCourier.key == 'JNT'">
                  <h6 class="heading-small text-muted mb-4 ">ประเภทในการส่งพัสดุ</h6>
                  <div class="row mb-4">
                    <div class="col-12">
                      <RadioBox :pickup_type.sync="pickup_type" :data="{ 'courier': courier_allow, 'shop_id': shop_id }">
                      </RadioBox>
                    </div>
                  </div>
                </template>
                <template v-if="checkDropoffVRich()">
                  <SearchTracking :isLoading="isLoadingVRich" isPlaceholder="QFX900100000014" :isError="vRich"
                    :isTracking="dropoffVRich" @checkTracking="checkTrackingVRich()" />
                </template>
                <template v-if="checkDropoffPanPan()">
                  <SearchTracking :isLoading="isLoadingPanPan" isPlaceholder="QFX900100000014" :isError="dropoffPanPan"
                    :isTracking="dropoffPanPan" @checkTracking="checkTrackingPanPan()" />
                </template>
                <template v-if="checkDropoffEasyShip()">
                  <SearchTracking :isLoading="isLoadingEasyShip" isPlaceholder="KEX1000037945X" :isError="easyShip"
                    :isTracking="dropoffEasyShip" @checkTracking="checkTrackingEasyShip()" />
                </template>
                <template v-if="checkDropoffQuick()">
                  <SearchTracking :isLoading="isLoadingQuick" isPlaceholder="QFX900100000015" :isError="quick"
                    :isTracking="dropoffQuick" @checkTracking="checkTrackingQuick()" />
                </template>

                <div class="mb-3 w-100" v-if="cod_details.isCod && !isCodAgreementAgreed">
                  <NoticeCodAgreement
                    :memberServiceToken="memberService.memberServiceToken"
                    :openModal="codAgreementModal.open"
                    @onOpen="handleOpenCodAgreementModal"
                    @onClose="handleCloseCodAgreementModal"
                  />
                </div>

                <template v-if="!addMoreOrder.isActive">
                  <template v-if="!checkDropoffVRich()
                    && !checkDropoffQuick()
                    && !checkDropoffPanPan()">
                    <h6 class="heading-small text-muted mb-4 ">
                      <span v-if="from.source != 1">ต้นทางที่แสดงบนใบปะหน้า (เข้ารับพัสดุที่ร้าน)</span><span
                        v-else>ต้นทางที่เข้ารับพัสดุ</span>
                    </h6>
                    <div class="d-flex justify-content-between align-items-center mb-4">
                      <b-form-checkbox :disabled="!['FLE', 'FLEF', 'FLEB', 'FLEWP'].includes(selectedCourier.key)"
                        size="lg" v-model="from.source" value=1 unchecked-value=0>
                        <span>ใช้ต้นทางนี้เป็นที่อยู่ในการเข้ารับพัสดุ</span>
                      </b-form-checkbox>
                      <div class="switch-pos">
                        <!-- <div class="form-group"> -->
                        <div class="d-flex align-items-center">
                          <span>ที่อยู่ตามบัตรประชาชน</span>
                          <b-form-checkbox switch size="lg" v-model="isToggle" @input="sameSender"></b-form-checkbox>
                          <span>ที่อยู่ร้าน</span>
                        </div>
                        <!-- </div> -->
                      </div>
                    </div>
                  </template>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater><small class="text-danger">*</small> ชื่อ-นามสกุล</label>
                        <input :disabled="checkDisableInputDropoff()" type="text" placeholder class="form-control"
                          v-model="from.name" :class="{ 'is-invalid': submitAddShipping && $v.from.name.$error }" />
                        <div v-if="submitAddShipping && !$v.from.name.required" class="invalid-feedback">
                          กรุณากรอกชื่อ-นามสกุล</div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater><small class="text-danger">*</small> หมายเลขโทรศัพท์</label>

                        <AutocompletesOrigin :disableInput="checkDisableInputDropoff()" ref="fromTel"
                          :endpoint="'/origin/${param}/details'" :data="from.tel" @select:item="onSubmitOriginAutocomp"
                          @input="from.tel = $event.target.value"
                          :class="{ 'is-invalid': submitAddShipping && $v.from.tel.$error }">
                          <template slot="custom-items" slot-scope="props">
                            <h6>
                              ชื่อ:{{ props.data.name }} เบอร์:{{ props.data.tel }} ที่อยู่:{{ props.data.address }}
                              ตำบล:{{ props.data.district }}
                              อำเภอ:{{ props.data.state }}
                              จังหวัด:{{ props.data.province }}
                              รหัสปณ.:{{ props.data.postcode }}
                            </h6>
                          </template>
                        </AutocompletesOrigin>
                        <div v-if="submitAddShipping && !$v.from.tel.required" class="invalid-feedback d-block">
                          กรุณากรอกหมายเลขโทรศัพท์</div>
                        <div class="error invalid-feedback d-block" v-if="submitAddShipping && !$v.from.tel.minLength">
                          กรุณากรอก"หมายเลขโทรศัพท์"อย่างน้อย {{ $v.from.tel.$params.minLength.min }} หลัก</div>
                        <div class="error invalid-feedback d-block" v-if="submitAddShipping && !$v.from.tel.maxLength">
                          กรุณากรอก"หมายเลขโทรศัพท์"ไม่เกิน {{ $v.from.tel.$params.maxLength.max }} หลัก</div>
                        <div class="error invalid-feedback" v-if="submitAddShipping && !$v.from.tel.numeric">
                          กรุณากรอกเฉพาะตัวเลข</div>
                        <div class="error invalid-feedback" v-if="submitAddShipping && $v.from.tel.invalid">
                          กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater><small class="text-danger">*</small> ที่อยู่</label>

                        <input :disabled="checkDisableInputDropoff()" type="text" placeholder class="form-control"
                          v-model="from.address" :class="{ 'is-invalid': submitAddShipping && $v.from.address.$error }" />

                        <div v-if="submitAddShipping && !$v.from.address.required" class="invalid-feedback">
                          กรุณากรอกที่อยู่</div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6" v-if="checkThemeQuick()">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> รหัสไปรษณีย์
                        </label>
                        <AutocompletesAddress :disableInput="checkDisableInputDropoff()" :queryInput="from.postcode"
                          :adsTypes="'postcode'" :class="{
                            'is-invalid': submitAddShipping &&
                              $v.from.postcode.$error ||
                              validateAddress.from.postcode.status
                          }" @input="from.postcode = $event.target.value"
                          @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>
                        <div v-if="validateAddress.from.postcode.status" class="invalid-th-address">
                          {{ validateAddress.from.postcode.msg }}
                        </div>
                        <div v-if="submitAddShipping && !$v.from.postcode.required" class="invalid-th-address">
                          กรุณากรอกรหัสไปรษณีย์</div>
                        <div class="error invalid-th-address" v-if="submitAddShipping && !$v.from.postcode.minLength">
                          กรุณากรอก"รหัสไปรษณีย์" {{ $v.from.postcode.$params.minLength.min }} หลัก</div>
                        <div class="error invalid-th-address" v-if="submitAddShipping && !$v.from.postcode.maxLength">
                          กรุณากรอก"รหัสไปรษณีย์" {{ $v.from.postcode.$params.maxLength.max }} หลัก</div>
                        <div class="error invalid-th-address" v-if="submitAddShipping && !$v.from.postcode.numeric">
                          กรุณากรอกเฉพาะตัวเลข</div>
                      </div>
                      <!-- รหัสไปรษณีย์ -->
                    </div>
                    <div :class="['col-12 col-md-6', (checkThemeQuick()) ? 'col-lg-4' : 'col-lg-6']">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> ตำบล/แขวง
                        </label>
                        <AutocompletesAddress :disableInput="checkDisableInputDropoff()" :queryInput="from.state"
                          :adsTypes="'sub-district'" :class="{
                            'is-invalid':
                              submitAddShipping &&
                              $v.from.state.$error ||
                              validateAddress.from.state.status
                          }" @input="from.state = $event.target.value" @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>

                        <div v-if="validateAddress.from.state.status" class="invalid-th-address">
                          {{ validateAddress.from.state.msg }}
                        </div>
                        <div v-if="submitAddShipping && !$v.from.state.required" class="invalid-th-address">
                          กรุณากรอกตำบล/แขวง</div>
                      </div>
                      <!-- ตำบล/แขวง -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> อำเภอ/เขต
                        </label>
                        <AutocompletesAddress :disableInput="checkDisableInputDropoff()" :queryInput="from.district"
                          :adsTypes="'district'" :class="{
                            'is-invalid':
                              submitAddShipping &&
                              $v.from.district.$error ||
                              validateAddress.from.district.status
                          }" @input="from.district = $event.target.value"
                          @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>

                        <div v-if="validateAddress.from.district.status" class="invalid-th-address">
                          {{ validateAddress.from.district.msg }}
                        </div>
                        <div v-if="submitAddShipping && !$v.from.district.required" class="invalid-th-address">
                          กรุณากรอกอำเภอ/เขต</div>
                      </div>
                      <!-- อำเภอ/เขต -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> จังหวัด
                        </label>
                        <AutocompletesAddress :disableInput="checkDisableInputDropoff()" :queryInput="from.province"
                          :adsTypes="'province'" :class="{
                            'is-invalid':
                              submitAddShipping &&
                              $v.from.province.$error ||
                              validateAddress.from.province.status
                          }" @input="from.province = $event.target.value"
                          @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>
                        <div v-if="validateAddress.from.province.status" class="invalid-th-address">
                          {{ validateAddress.from.province.msg }}
                        </div>
                        <div v-if="submitAddShipping && !$v.from.province.required" class="invalid-th-address">
                          กรุณากรอกจังหวัด</div>
                      </div>
                      <!-- จังหวัด -->
                    </div>
                    <div class="col-lg-4 col-12 col-md-6" v-if="!checkThemeQuick()">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> รหัสไปรษณีย์
                        </label>
                        <AutocompletesAddress :disableInput="checkDropoffEasyShip()" :queryInput="from.postcode"
                          :adsTypes="'postcode'" :class="{
                            'is-invalid': submitAddShipping &&
                              $v.from.postcode.$error ||
                              validateAddress.from.postcode.status
                          }" @input="from.postcode = $event.target.value"
                          @select:item="onSubmitAddress($event, 'from')">
                        </AutocompletesAddress>
                        <div v-if="validateAddress.from.postcode.status" class="invalid-th-address">
                          {{ validateAddress.from.postcode.msg }}
                        </div>
                        <div v-if="submitAddShipping && !$v.from.postcode.required" class="invalid-th-address">
                          กรุณากรอกรหัสไปรษณีย์</div>
                        <div class="error invalid-th-address" v-if="submitAddShipping && !$v.from.postcode.minLength">
                          กรุณากรอก"รหัสไปรษณีย์" {{ $v.from.postcode.$params.minLength.min }} หลัก</div>
                        <div class="error invalid-th-address" v-if="submitAddShipping && !$v.from.postcode.maxLength">
                          กรุณากรอก"รหัสไปรษณีย์" {{ $v.from.postcode.$params.maxLength.max }} หลัก</div>
                        <div class="error invalid-th-address" v-if="submitAddShipping && !$v.from.postcode.numeric">
                          กรุณากรอกเฉพาะตัวเลข</div>
                      </div>
                      <!-- รหัสไปรษณีย์ -->
                    </div>
                  </div>
                  <hr class="my-4" />
                </template>
                <!-- Address -->
                <div class="d-flex justify-content-between mb-4" ref="model-parcel-destination">
                  <h6 class="heading-small text-muted">ปลายทาง</h6>
                  <div class="row mr-1">
                    <CreateOrderByExcel v-if="!checkDropoffVRich() && !checkDropoffEasyShip() && !checkDropoffPanPan()"
                      :courierKey="selectedCourier.key"
                      :isCod="cod_details.isCod"
                      :isCodAgreementAgreed="isCodAgreementAgreed"
                      @click.native="checkErrorCreateOrderByExcel = true"
                      @onSuccess="createOrderByExcel"
                      @onError="checkErrorCreateOrderByExcel = $event"
                    />
                  </div>
                </div>
                <b-alert :show="checkErrorCreateOrderByExcel.length > 0" variant="yellow-light" class="p-0">
                  <div class="row">
                    <div class="col-1 d-flex align-items-center m-1">
                      <i class="fas fa-exclamation-circle text-yellow display-3"></i>
                    </div>
                    <div class="col-10">
                      <div v-for="(error, i) in checkErrorCreateOrderByExcel" :key="i">
                        <h5>{{ error.header }}</h5>
                        <h6>{{ error.body }}</h6>
                      </div>
                    </div>
                  </div>
                </b-alert>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label floater><small class="text-danger">*</small> ชื่อ-นามสกุล</label>
                      <div class="test-error" :class="{ 'is-invalid': submitAddShipping && $v.to.name.$error }">
                        <autocomplete :disabled="checkDisableInputDropoff()" :search="searchRecipientDetails"
                          :get-result-value="getValueRecipientDetails" @submit="onSubmitRecipient"
                          v-on:input="to.name = $event.target.value" :value="to.name"
                          :class="[{ 'is-invalid': submitAddShipping && $v.to.name.$error }, { 'disabled-autocomplete': checkDisableInputDropoff() }]">
                          <template v-slot:result="{ result, props }">
                            <li v-bind="props">
                              <h6>
                                ชื่อ:{{ result.name }} เบอร์:{{ result.tel }} ที่อยู่:{{ result.address }}
                                ตำบล:{{ result.district }}
                                อำเภอ:{{ result.state }} จังหวัด:{{ result.province }}
                                รหัสปณ.:{{ result.postcode }}
                              </h6>
                            </li>
                          </template>

                        </autocomplete>

                        <div v-if="submitAddShipping && !$v.to.name.required" class="invalid-feedback">
                          กรุณากรอกชื่อ-นามสกุล</div>
                      </div>

                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label floater><small class="text-danger">*</small> หมายเลขโทรศัพท์</label>
                      <div class="test-error" :class="{ 'is-invalid': submitAddShipping && $v.to.tel.$error }">
                        <autocomplete :disabled="checkDisableInputDropoff()" :search="searchRecipientDetails"
                          :get-result-value="getValueRecipientDetails" @submit="onSubmitRecipient"
                          v-on:input="to.tel = $event.target.value" :value="to.tel" @blur="focusOutRecipientDetails"
                          :class="[{ 'is-invalid': submitAddShipping && $v.to.tel.$error }, { 'disabled-autocomplete': checkDisableInputDropoff() }]">
                          <template v-slot:result="{ result, props }">
                            <li v-bind="props">
                              <h6>
                                ชื่อ:{{ result.name }} เบอร์:{{ result.tel }} ที่อยู่:{{ result.address }}
                                ตำบล:{{ result.district }}
                                อำเภอ:{{ result.state }} จังหวัด:{{ result.province }}
                                รหัสปณ.:{{ result.postcode }}
                              </h6>
                            </li>
                          </template>
                        </autocomplete>
                        <div v-if="submitAddShipping && !$v.to.tel.required" class="invalid-feedback">
                          กรุณากรอกหมายเลขโทรศัพท์</div>
                        <div class="error invalid-feedback" v-if="submitAddShipping && $v.to.tel.minLength">
                          กรุณากรอก"หมายเลขโทรศัพท์"อย่างน้อย {{ $v.to.tel.$params.minLength.min }} หลัก</div>
                        <div class="error invalid-feedback" v-if="submitAddShipping && $v.to.tel.maxLength">
                          กรุณากรอก"หมายเลขโทรศัพท์"ไม่เกิน {{ $v.to.tel.$params.maxLength.max }} หลัก</div>
                        <!-- <div
                          class="error invalid-feedback"
                          v-if="submitAddShipping && !$v.to.tel.numeric"
                        >กรุณากรอกเฉพาะตัวเลข</div> -->
                        <div class="invalid-feedback" v-if="submitAddShipping && $v.to.tel.$invalid">
                          กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label floater><small class="text-danger">*</small> ที่อยู่</label>

                      <input :disabled="checkDisableInputDropoff()" type="text" placeholder class="form-control"
                        v-model="to.address" :class="{ 'is-invalid': submitAddShipping && $v.to.address.$error }" />

                      <div v-if="submitAddShipping && !$v.to.address.required" class="invalid-feedback">กรุณากรอกที่อยู่
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6" v-if="checkThemeQuick()">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> รหัสไปรษณีย์
                      </label>
                      <AutocompletesAddress :disableInput="checkDisableInputDropoff() && validate.checkInput.postcode"
                        :queryInput="to.postcode" :adsTypes="'postcode'" :class="{
                          'is-invalid':
                            submitAddShipping &&
                            $v.to.postcode.$error ||
                            validateAddress.to.postcode.status
                        }" @input="to.postcode = $event.target.value" @select:item="onSubmitAddress($event, 'to')"
                        maxlength="5">
                      </AutocompletesAddress>
                      <div v-if="submitAddShipping && !$v.to.postcode.required" class="invalid-th-address">
                        กรุณากรอกรหัสไปรษณีย์</div>
                      <div v-if="validateAddress.to.postcode.status" class="invalid-th-address">
                        {{ validateAddress.to.postcode.msg }}
                      </div>
                      <div class="error invalid-th-address" v-if="submitAddShipping && !$v.to.postcode.minLength">
                        กรุณากรอก"รหัสไปรษณีย์" {{ $v.to.postcode.$params.minLength.min }} หลัก</div>
                      <div class="error invalid-th-address" v-if="submitAddShipping && !$v.to.postcode.maxLength">
                        กรุณากรอก"รหัสไปรษณีย์" {{ $v.to.postcode.$params.maxLength.max }} หลัก</div>
                      <div class="error invalid-th-address" v-if="submitAddShipping && !$v.to.postcode.numeric">
                        กรุณากรอกเฉพาะตัวเลข</div>
                    </div>
                    <!-- รหัสไปรษณีย์ -->
                  </div>
                  <div :class="['col-12 col-md-6', (checkThemeQuick()) ? 'col-lg-4' : 'col-lg-6']">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> ตำบล/แขวง
                      </label>
                      <AutocompletesAddress :disableInput="checkDisableInputDropoff() && validate.checkInput.state"
                        :queryInput="to.state" :adsTypes="'sub-district'" :class="{
                          'is-invalid':
                            submitAddShipping &&
                            $v.to.state.$error ||
                            validateAddress.to.state.status
                        }" @input="to.state = $event.target.value" @select:item="onSubmitAddress($event, 'to')">
                      </AutocompletesAddress>
                      <div v-if="validateAddress.to.state.status" class="invalid-th-address">
                        {{ validateAddress.to.state.msg }}
                      </div>
                      <div v-if="submitAddShipping && !$v.to.state.required" class="invalid-th-address">
                        กรุณากรอกตำบล/แขวง</div>
                    </div>
                    <!-- ตำบล/แขวง -->
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> อำเภอ/เขต
                      </label>
                      <AutocompletesAddress :disableInput="checkDisableInputDropoff() && validate.checkInput.district"
                        :queryInput="to.district" :adsTypes="'district'" :class="{
                          'is-invalid':
                            submitAddShipping &&
                            $v.to.district.$error ||
                            validateAddress.to.district.status
                        }" @input="to.district = $event.target.value" @select:item="onSubmitAddress($event, 'to')">
                      </AutocompletesAddress>
                      <div v-if="submitAddShipping && !$v.to.district.required" class="invalid-th-address">
                        กรุณากรอกอำเภอ/เขต</div>
                      <div v-if="validateAddress.to.district.status" class="invalid-th-address">
                        {{ validateAddress.to.district.msg }}
                      </div>
                    </div>
                    <!-- อำเภอ/เขต -->
                  </div>
                  <div class="col-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> จังหวัด
                      </label>
                      <AutocompletesAddress :disableInput="checkDisableInputDropoff() && validate.checkInput.province"
                        :queryInput="to.province" :adsTypes="'province'" :class="{
                          'is-invalid':
                            submitAddShipping &&
                            $v.to.province.$error ||
                            validateAddress.to.province.status
                        }" @input="to.province = $event.target.value" @select:item="onSubmitAddress($event, 'to')">
                      </AutocompletesAddress>
                      <div v-if="submitAddShipping && !$v.to.province.required" class="invalid-th-address">
                        กรุณากรอกจังหวัด
                      </div>
                      <div v-if="validateAddress.to.province.status" class="invalid-th-address">
                        {{ validateAddress.to.province.msg }}
                      </div>
                    </div>
                    <!-- จังหวัด -->
                  </div>

                  <div class="col-lg-4" v-if="!checkThemeQuick()">
                    <div class="form-group">
                      <label floater>
                        <small class="text-danger">*</small> รหัสไปรษณีย์
                      </label>
                      <AutocompletesAddress :disableInput="checkDropoffEasyShip()" :queryInput="to.postcode"
                        :adsTypes="'postcode'" :class="{
                          'is-invalid':
                            submitAddShipping &&
                            $v.to.postcode.$error ||
                            validateAddress.to.postcode.status
                        }" @input="to.postcode = $event.target.value" @select:item="onSubmitAddress($event, 'to')"
                        maxlength="5">
                      </AutocompletesAddress>
                      <div v-if="submitAddShipping && !$v.to.postcode.required" class="invalid-th-address">
                        กรุณากรอกรหัสไปรษณีย์</div>
                      <div v-if="validateAddress.to.postcode.status" class="invalid-th-address">
                        {{ validateAddress.to.postcode.msg }}
                      </div>
                      <div class="error invalid-th-address" v-if="submitAddShipping && !$v.to.postcode.minLength">
                        กรุณากรอก"รหัสไปรษณีย์" {{ $v.to.postcode.$params.minLength.min }} หลัก</div>
                      <div class="error invalid-th-address" v-if="submitAddShipping && !$v.to.postcode.maxLength">
                        กรุณากรอก"รหัสไปรษณีย์" {{ $v.to.postcode.$params.maxLength.max }} หลัก</div>
                      <div class="error invalid-th-address" v-if="submitAddShipping && !$v.to.postcode.numeric">
                        กรุณากรอกเฉพาะตัวเลข</div>
                    </div>
                    <!-- รหัสไปรษณีย์ -->
                  </div>
                  <div v-if="remote_area.rate > 0 || remote_area.travel_surcharge > 0 || remote_area.island_surcharge"
                    class="col-12 notification-area">
                    <div class="background-notification py-2">
                      <ul class="m-0">
                        <li v-if="remote_area.rate > 0" class="text-specialArea text-sm">พื้นที่นี้มีค่าบริการพิเศษ {{
                          remote_area.rate }} บาท เนื่องจากจัดอยู่ในพื้นที่ห่างไกล</li>
                        <li v-if="remote_area.travel_surcharge > 0" class="text-specialArea text-sm">
                          พื้นที่นี้มีค่าบริการท่องเที่ยว {{ remote_area.travel_surcharge }} บาท
                          เนื่องจากจัดอยู่ในพื้นที่ท่องเที่ยว</li>
                        <li v-if="remote_area.island_surcharge > 0" class="text-specialArea text-sm">
                          พื้นที่นี้มีค่าพื้นที่หมู่เกาะ {{ remote_area.island_surcharge }} บาท
                          เนื่องจากจัดอยู่ในพื้นที่หมู่เกาะ</li>
                      </ul>
                    </div>
                    <div class="mt-3" v-if="(remote_area.rate > 0 || remote_area.travel_surcharge > 0 || remote_area.island_surcharge) && selectedCourier.key !=='EMST' && showThaipostRemote">
                      <div class="background-notification p-2" style="border:1px #ffeeba dashed;border-radius: 6px">
                        <div class="text-specialArea text-sm">
                          <div style="display: flex;align-items: center;justify-content: space-between">
                            <p class="text-sm mb-0">ปลายทางเป็นพื้นที่ห่างไกล เลือกขนส่งไปรษณีย์ไทย ประหยัดกว่า</p>
                            <div style="display: flex;align-items: center;justify-content: space-between;width:220px;">
                              <button class="btn btn-primary excel-download-button" @click="selectThaipost()">เลือกขนส่งไปรษณีย์ไทย</button>
                              <button class="btn p-0" @click="showThaipostRemote = false"><i class="fas fa-window-close" style="color: #999"></i></button>
                              <i class="fas fa-close"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Error Description -->
                <b-alert :show="errorAlertParcel.errorDestination.status" variant="yellow-light">
                  <h4 v-html="errorAlertParcel.errorDestination.msg"></h4>
                </b-alert>
                <!-- Error Service Area -->
                <template v-if="errorAlertParcel.errorServiceArea.status">
                  <h4 v-html="errorAlertParcel.errorServiceArea.msg"></h4>
                </template>

                <hr class="my-4" />
                <!-- Description -->
                <h6 class="heading-small text-muted">รายละเอียดเพิ่มเติม</h6>
                <!-- AutoBox -->
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label floater><small class="text-danger">*</small>
                        น้ำหนัก
                        <small>{{ checkUntiKG() ? '( กิโลกรัม )' : '( กรัม )' }}</small>
                      </label>
                      <input type="number" placeholder="น้ำหนัก" class="form-control" ref="focusWeightParcel"
                        @change="calDimensionSpecialArea()" v-model="$data[checkUntiKG() ? 'weightKG' : 'weight']"
                        v-on:keyup="itemPreRate()"
                        :onkeydown="checkUntiKG() ? 'return event.keyCode !== 69 && event.keyCode !== 189' : 'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                        :class="{ 'is-invalid': submitAddShipping && (checkUntiKG() ? $v.weightKG.$error : $v.weight.$error) || rateError || errorWeight || !validate.modalParcel.checkDimension.status }"
                        :disabled="lockWeight" />
                      <div v-if="submitAddShipping && (checkUntiKG() ? !$v.weightKG.required : !$v.weight.required)"
                        class="invalid-feedback">กรุณากรอกน้ำหนัก</div>

                      <div v-if="rateError && selectedCourier.key == 'SCG' && ['PM', 'PL', 'Envelop'].includes(keyBox)"
                        class="text-danger text-sm pt-2">
                        ไม่สามารถสร้างรายการได้ เนื่องจากขนาดพัสดุ Envelop/Polymer Bag ของ SCG
                        รองรับพัสดุได้สูงสุด {{ checkUntiKG() ? '1 กิโลกรัม' : '1,000 กรัม' }}
                        กรุณาเปลี่ยนพัสดุลงกล่อง และเลือกขนาดพัสดุใหม่
                      </div>
                      <div v-if="errorWeight
                        && (courierRules.hasOwnProperty(selectedCourier.key) && courierRules[selectedCourier.key].minWeight)
                        && (weight < courierRules[selectedCourier.key].minWeight)" class="text-danger  text-sm pt-2">
                        กรุณาใส่น้ำหนักมากกว่า {{ courierRules[selectedCourier.key].minWeight - 1 / (checkUntiKG() ?
                          1000 : 1)
                        }}
                      </div>
                      <div v-else-if="errorWeight && weight == 0" class="text-danger text-sm pt-2">กรุณาใส่น้ำหนักมากกว่า
                        0</div>
                      <div v-else-if="rateError" class="text-danger text-sm pt-2">
                        ไม่สามารถสร้างรายการได้ เนื่องจาก
                        <ul>
                          <li>ไม่พบเรทราคา</li>
                          <li>น้ำหนัก/ขนาดพัสดุ เกินที่ขนส่งกำหนด</li>
                          <li>ขนส่งไม่เปิดให้บริการในพื้นที่ต้นทาง/ปลายทาง</li>
                        </ul>
                      </div>
                      <div v-if="!validate.modalParcel.checkDimension.status" class="text-danger">{{
                        validate.modalParcel.checkDimension.msg
                      }} </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <AutoBox :listSize="listSize" :size="size" :weight.sync="weight" :weightKG.sync="weightKG"
                        :width.sync="width" :length.sync="length" :height.sync="height" :keyBox.sync="keyBox"
                        :calculateWeight.sync="calculateWeight" :courier_key="selectedCourier.key"
                        :favoriteDimension="favoriteDimension && !editorder" @itemPreRate="itemPreRate()" />
                      <!-- weightKG เฉพาะขนส่ง KERRY -->
                    </div>
                  </div>
                  <div class="col-lg-6" v-if="issetParcelInsurance && !checkDropoffVRich() && !checkDropoffPanPan()">
                    <label for="input-live"><small v-if="this.insurance.isCheck" class="text-danger">*</small>
                      เลือกประเภทสินค้า</label>
                    <InputParcelType ref="inputParcelType" :courier="selectedCourier" :data="insurance"
                      :error="checkErrorSeletedParcelInsurance" />
                  </div>
                  <div class="col-lg-6" v-if="cod_details.isCod && (checkDropoffVRich() || checkDropoffPanPan())">
                    <div class="form-group">
                      <label floater><small class="text-danger">*</small>
                        ยอดเก็บเงินปลายทาง <small>( บาท )</small>
                      </label>
                      <input disabled type="number" placeholder="จำนวนเงิน" class="form-control"
                        v-on:keyup="checkCodAmount()" v-model="codAmount"
                        :class="{ 'is-invalid': submitAddShipping && $v.codAmount.$error || errorCodAmount }" />
                      <div v-if="submitAddShipping && !$v.codAmount.required" class="invalid-feedback">
                        กรุณากรอกจำนวนเงิน
                      </div>
                      <small v-if="errorCodAmount" class="text-danger">ไม่สามารถสร้างรายการได้
                        เนื่องจากยอดเรียกเก็บปลายทางขั้นต่ำ {{ codCondition.min | numFormat('0,0') }} บาท และไม่เกิน
                        {{ codCondition.max | numFormat('0,0') }} บาทค่ะ</small>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div role="group">
                      <label for="input-live">ขนาดพัสดุ (เซนติเมตร)</label>
                      <div class="row">
                        <div class="col boxs">
                          <input type="number" min="1" placeholder="กว้าง" class="form-control" v-model="width"
                            :disabled="lockDimension || favoriteDimension && !editorder" v-on:keyup="itemPreRate()"
                            v-on:blur="itemPreRate()"
                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                            :class="{ 'is-invalid': validate.modalParcel.dimension.width.status == false }" />
                          <small v-if="validate.modalParcel.dimension.width.status == false" class="text-danger">{{
                            validate.modalParcel.dimension.width.msg
                          }}</small>
                        </div>
                        <div class="col boxs">
                          <input type="number" min="1" placeholder="ยาว" class="form-control" v-model="length"
                            :disabled="lockDimension || favoriteDimension && !editorder" v-on:keyup="itemPreRate()"
                            v-on:blur="itemPreRate()"
                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                            :class="{ 'is-invalid': validate.modalParcel.dimension.length.status == false }" />
                          <small v-if="validate.modalParcel.dimension.length.status == false" class="text-danger">{{
                            validate.modalParcel.dimension.length.msg
                          }}</small>
                        </div>
                        <div class="col">
                          <input type="number" min="1" placeholder="สูง" class="form-control"
                            :disabled="lockDimension || favoriteDimension && !editorder" v-model="height"
                            v-on:keyup="itemPreRate()" v-on:blur="itemPreRate()"
                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                            :class="{ 'is-invalid': validate.modalParcel.dimension.height.status == false }" />
                          <small v-if="validate.modalParcel.dimension.height.status == false" class="text-danger">{{
                            validate.modalParcel.dimension.height.msg
                          }}</small>
                        </div>
                        <div class="col-1 d-flex align-items-center pl-0" v-if="!editorder">
                          <span @click="lockDimensionParcel()">
                            <Icon :icon="(favoriteDimension) ? 'mdi-lock' : 'mdi-lock-open-variant'"
                              class="cursor-pointer lockDimension" />
                          </span>
                        </div>
                      </div>
                      <div class="text-yellow text-sm pt-2"
                        v-if="weight < calculateWeight && calculateWeight > 0 && courierRules[selectedCourier.key] && courierRules[selectedCourier.key].dimensionRatio || (courierRules[selectedCourier.key] && courierRules[selectedCourier.key].useDimensionWeightOnly)">
                        เนื่องจากน้ำหนักปริมาตรมากกว่าน้ำหนักจริงการคำนวณค่าขนส่งจะเปลี่ยนไปใช้น้ำหนักปริมาตรแทน<br />
                        • สูตรคำนวณน้ำหนักปริมาตร = (กว้าง x ยาว x สูง) / {{
                          courierRules[selectedCourier.key].dimensionRatio / (checkUntiKG() ? 1 : 1000) }} =
                        {{ calculateWeight | numFormat('0,0') }} {{ checkUntiKG() ? 'กิโลกรัม' : 'กรัม' }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6" v-if="checkDropoffVRich() || checkDropoffPanPan()">
                    <div class="form-group mb-0">
                      <div class="row">
                        <div class="col-1 pr-4">
                          <label>พื้นที่: </label>
                        </div>
                        <div class="col">
                          <span class="h4 text-yellow">
                            {{ courierRules.getZoneName(selectedCourier, type) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12" v-if="cod_details.isCod && !checkDropoffVRich() && !checkDropoffPanPan()">
                    <div class="form-group">
                      <label floater><small class="text-danger">*</small>
                        ยอดเก็บเงินปลายทาง <small>( บาท )</small> <small v-if="['shippop', 'postmanservice'].includes(this.$THEME.name)" class="text-primary cursor-pointer" @click="handleOpenNoticeCodInfo"> ดูเพิ่มเติม</small>
                      </label>
                      <input type="number" placeholder="จำนวนเงิน" class="form-control" v-on:keyup="checkCodAmount()"
                        v-model="codAmount" :disabled="checkDropoffEasyShip() || checkDropoffQuick()"
                        :class="{ 'is-invalid': submitAddShipping && $v.codAmount.$error || errorCodAmount }" />
                      <div v-if="submitAddShipping && !$v.codAmount.required" class="invalid-feedback">
                        กรุณากรอกจำนวนเงิน
                      </div>
                      <small v-if="errorCodAmount" class="text-danger">ไม่สามารถสร้างรายการได้
                        เนื่องจากยอดเรียกเก็บปลายทางขั้นต่ำ {{ codCondition.min | numFormat('0,0') }} บาท และไม่เกิน
                        {{ codCondition.max | numFormat('0,0') }} บาทค่ะ</small>
                    </div>

                    <CodProductList
                      :list="codProducts"
                      :courier="selectedCourier"
                      :error="errorCodProduct"
                      @onChangeCodProduct="updateCodProducts"
                    />
                  </div>
                  <!-- modal barcode -->
                  <div class="col-lg-6" v-if="this.selectedCourier.shippop == 0">
                    <div class="form-group mb-0">
                      <label>เลข Tracking</label>
                      <input type="text" v-model="tracking" placeholder="รหัส Barcode" @change="checkBarcode"
                        class="form-control" :class="{ 'is-invalid': errorBarcode || barcodeError }" />
                      <small v-if="errorBarcode" class="text-danger">กรุณากรอกรหัส Barcode ให้ถูกต้อง</small>
                      <small v-if="barcodeError" class="text-danger">รหัส Barcode ซ้ำ กรุณาใช้รหัส Barcode อื่น</small>
                      <small v-if="barcodeOk" class="text-success">สามารถใช้รหัส Barcode นี้ได้</small>
                    </div>
                  </div>
                  <!-- หมายเหตุ -->
                  <div class="col-lg-12 mt-3 remark-textarea">
                    <div class="form-group group-remark">
                      <label for="remarkOrderDetail">หมายเหตุ</label>
                      <textarea class="form-control" id="remarkOrderDetail" v-model="remarkOrderDetail" rows="2"
                        maxlength="100"
                        placeholder="ตัวอย่างหมายเหตุ เช่น พัสดุสามารถแตกหักได้ง่าย กรุณาอย่าโยน, หากติดต่อผู้รับไม่ได้ให้ฝากพัสดุไว้ที่นิติ">
                        </textarea>
                      <span class="remark-length">{{ remarkOrderDetail.length }} / 100</span>
                    </div>
                  </div>
                </div>
                <b-alert :show="errorAlertParcel.status" variant="yellow-light" class="mt-4">
                  <h4 v-html="errorAlertParcel.msg"></h4>
                </b-alert>
                <div class="row mt-4" v-if="issetParcelInsurance && !checkDropoffVRich() && !checkDropoffPanPan()">
                  <div class="col-lg-6">
                    <ParcelInsurance ref="parcelInsurance" :data="insurance" :clear="clearInputInsurance"
                      :error="checkErrorParcelInsurance" />
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group mb-0">
                      <div class="row">
                        <div class="col-1 pr-4">
                          <label>พื้นที่: </label>
                        </div>
                        <div class="col">
                          <span class="h4 text-yellow">
                            {{ courierRules.getZoneName(selectedCourier, type) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="row d-flex justify-content-end">
                      <div class="col-lg-6" />
                      <div class="col-12 col-lg-6">
                        <!-- start coupon section -->
                        <div v-if="previewCouponResult && this.main_allow_coupon && this.main_use_walletV2" class="form-group mb-0 d-flex flex-row align-items-center justify-content-between">
                          <label class="m-0">คูปองส่วนลด</label>
                          <div class="text-right display-4 pb-0">
                            <small class="d-inline-flex">
                              <span class="pr-1">
                                - {{ previewCouponResult.total_discount_value | numFormat('0,0.00') }}
                              </span>
                              บาท
                            </small>
                          </div>
                        </div>
                        <div v-if="this.main_use_walletV2" class="form-group mb-0 d-flex flex-row align-items-center justify-content-between pos-border-bottom">
                          <label class="m-0">ตัดเงินในระบบ</label>
                          <div class="text-right display-4 pb-0">
                            <small class="d-inline-flex">
                              <span class="pr-1">
                                {{
                                   (this.walletPrerate ? this.walletPrerate : this.selectedTier ?  Number(this.selectedTier.rate) : 0) +
                                   (this.remote_area.rate ? this.remote_area.rate : 0) +
                                   (this.remote_area.travel_surcharge ? this.remote_area.travel_surcharge : 0) +
                                   (this.remote_area.island_surcharge ? this.remote_area.island_surcharge : 0) +
                                   (this.extra_handling_charge ? this.extra_handling_charge : 0) +
                                   (this.insurance ? this.insurance.listPrice.rate : 0) +
                                   (this.previewCouponResult ? Number(this.previewCouponResult.total_discount_value) * -1 : 0)
                                    | numFormat('0,0.00')
                                }}
                              </span>
                              บาท
                            </small>
                          </div>
                        </div>
                        <!-- end coupon section -->

                        <div class="form-group mb-0 d-flex flex-row align-items-center justify-content-between pos-border-bottom">
                          <label class="m-0">{{ remote_area.rate > 0 || remote_area.travel_surcharge > 0 || remote_area.island_surcharge > 0 || extra_handling_charge > 0 ? 'ราคา' : 'ยอดเรียกเก็บลูกค้า' }}</label>
                          <div class="text-right pb-0"
                            :class="(remote_area.rate > 0 || remote_area.travel_surcharge > 0 || remote_area.island_surcharge > 0 || extra_handling_charge > 0) ? 'display-4' : 'display-3'">
                            <small v-if="(remote_area.rate > 0 || remote_area.travel_surcharge > 0 || remote_area.island_surcharge > 0 || extra_handling_charge > 0)" class="pr-1">
                              {{ showPreRate | numFormat('0,0.00') }}
                            </small>
                            <span v-else class="d-inline-flex pr-1">
                              {{ showPreRate | numFormat('0,0.00') }}
                            </span>
                            <small>บาท</small>
                          </div>
                        </div>
                        <div v-if="this.$THEME.name == 'shippop'" class="form-group mb-0 d-flex flex-row align-items-center justify-content-between">
                          <h5 class="text-danger">สามารถยกเลิกรายการและรับเงินคืนได้ภายใน 30 วันนับจากวันที่ยืนยันรายการ</h5>
                        </div>
                        <div v-if="remote_area.rate > 0"
                          class="form-group mb-0 d-flex flex-row align-items-center justify-content-between">
                          <label class="m-0">พื้นที่ห่างไกล</label>
                          <div class="display-4 text-right pb-0">
                            <small class="d-inline-flex">
                              <span class="pr-1 text-specialarea">
                                +{{ remote_area.rate | numFormat('0,0.00') }}
                              </span>
                              บาท
                            </small>
                          </div>
                        </div>
                        <div v-if="remote_area.travel_surcharge > 0"
                          class="form-group mb-0 d-flex flex-row align-items-center justify-content-between">
                          <label class="m-0">พื้นที่ท่องเที่ยว</label>
                          <div class="display-4 text-right pb-0">
                            <small class="d-inline-flex">
                              <span class="pr-1 text-specialarea">
                                +{{ remote_area.travel_surcharge | numFormat('0,0.00') }}
                              </span>
                              บาท
                            </small>
                          </div>
                        </div>
                        <div v-if="remote_area.island_surcharge > 0"
                          class="form-group mb-0 d-flex flex-row align-items-center justify-content-between">
                          <label class="m-0">พื้นที่หมู่เกาะ</label>
                          <div class="display-4 text-right pb-0">
                            <small class="d-inline-flex">
                              <span class="pr-1 text-specialarea">
                                +{{ remote_area.island_surcharge | numFormat('0,0.00') }}
                              </span>
                              บาท
                            </small>
                          </div>
                        </div>
                        <div v-if="extra_handling_charge > 0"
                          class="form-group mb-0 d-flex flex-row align-items-center justify-content-between">
                          <label class="m-0">Extra Handling Charge</label>
                          <div class="display-4 text-right pb-0">
                            <small class="d-inline-flex">
                              <span class="pr-1 text-specialarea">
                                +{{ extra_handling_charge | numFormat('0,0.00') }}
                              </span>
                              บาท
                            </small>
                          </div>
                        </div>
                        <div
                          v-if="remote_area.rate > 0 || remote_area.travel_surcharge > 0 || remote_area.island_surcharge > 0 || extra_handling_charge > 0"
                          class="form-group mb-0 d-flex flex-row align-items-center justify-content-between">
                          <!-- <label class="m-0">รวม</label> -->
                          <label class="m-0">ยอดเรียกเก็บลูกค้า</label>
                          <div class="display-3 text-right pb-0">
                            <small class="d-inline-flex">
                              <span class="pr-1">
                                {{ showPreRate + remote_area.rate +
                                  (remote_area.travel_surcharge ? remote_area.travel_surcharge : 0) +
                                  (remote_area.island_surcharge ? remote_area.island_surcharge : 0) +
                                  (extra_handling_charge ? extra_handling_charge : 0) | numFormat('0,0.00') }}
                              </span>
                              บาท
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row d-flex justify-content-end" v-else>
                  <div class="col-lg-6">
                    <div class="form-group mb-0">
                      <label>ราคา</label>
                      <div class="display-3 text-right">
                        {{ prerate | numFormat('0,0.00') }}
                        <small>บาท</small>
                      </div>
                    </div>
                  </div>
                </div>
                <b-alert :show="errorCreateOrderByOne.status" variant="yellow-light" class="text-center">
                  <h4 class="text-red">{{ errorCreateOrderByOne.msg }}</h4>
                </b-alert>
                <b-alert :show="(
                  (checkDropoffVRich()
                    || checkDropoffPanPan()
                    || checkDropoffEasyShip()
                    || checkDropoffQuick()
                  )
                  && codAmount > 0
                  && sender.mem_id === 0
                )" variant="yellow-light" class="text-center">
                  <h4 class="text-danger">ลูกค้ายังไม่ได้สมัคร COD กรุณาสมัครใช้งานก่อน <span
                      class="text-link cursor-pointer" @click="openRegisterCOD()"><u>ที่นี่ </u><i
                        class="fas fa-chevron-right"></i></span></h4>
                  <small>
                    หากลูกค้าสมัคร COD แล้ว กรุณากดปุ่มเพื่อตรวจสอบสมาชิก COD อีกครั้ง
                    <button class="btn btn-info btn-sm mx-1" @click="checkVerifyMemberCod()">
                      <i :class="(isLoadingCheckCod) ? 'fas fa-circle-notch fa-spin' : 'fas fa-sync-alt'"></i>
                    </button>
                  </small>
                </b-alert>

                <div class="mt-4 w-100 text-right">
                  <b-button
                    variant="secondary"
                    class="mx-3"
                    @click="closeParcel(),
                      clearInputValidateDimension(),
                      clearInputInsurance(),
                      clearNotificationArea()"
                  >
                    ยกเลิก
                  </b-button>

                  <div class="button-tooltip-container">
                    <b-button
                      id="tooltip-target-1"
                      type="submit"
                      variant="success"
                      @click.prevent="validateShip"
                      :disabled="isShipDisabled"
                      :aria-busy="isLoadingShip || submitAddShipping"
                      :aria-disabled="isShipDisabled"
                    >
                      <i class="fas fa-circle-notch fa-spin" v-if="isLoadingShip || submitAddShipping"></i>
                      {{ buttonLabel }}
                    </b-button>
                    <span v-if="cod_details.isCod && !isCodAgreementAgreed" class="tooltip-text">
                      กรุณายอมรับเงื่อนไขการให้บริการ COD
                    </span>
                  </div>
                </div>
              </template>
            </card>
          </b-modal>

          <!-- Modal คิดเงิน -->

          <ModalCheckBill :checkBill="checkBill" :totalCourierPrice="totalCourierPrice" :totalPriceOrder="total"
            @recheckCutOrderDraft="setFalseRecheck" @confirmCreateOrder="buyTotal"
            :typeMoneyCheckBill="typeMoneyCheckBill" :isHasBookBank="isHasBookBank"
            :filterCheckDropoffLine="filterCheckDropoffLine" @setTypeMoneyCheckBill="setTypeMoneyCheckBill" />

          <!-- Modal บัตรประชาชน -->
          <ModalSender ref="modalSender" :sender="sender" :preBarcode="preBarcode"
            :searchSenderDetails="searchSenderDetails" :errorBirthday="errorBirthday" :errorIdCard="errorIdCard"
            @checkIdNo="checkIdNo" @checkIdCard="checkIdCard($event)" @onSubmitAddress="onSubmitAddress($event, 'sender')"
            @formatDate="formatDate()" @close="close()" />

          <!-- Modal prebarcode -->
          <b-modal centered no-close-on-backdrop no-close-on-esc ref="modal-prebarcode" @hidden="closeParcel"
            id="modal-prebarcode" size="lg" hide-footer @shown="focusMyElement" no-stacking>
            <template slot="modal-title">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-12 d-flex align-items-center">
                    <h3 class="mb-0">ระบบ prebarcode</h3>
                  </div>
                </div>
              </div>
            </template>
            <card shadow type="secondary" class="m--4">
              <template>
                <h6 class="heading-small text-muted mb-4">ข้อมูลพัสดุ</h6>
                <div>
                  <div class="row">
                    <div class="col-lg-6 d-flex align-items-center justify-content-center">
                      <div class="f">
                        <img v-if="iconUrl.status != false" class="card-img-top pl-3 img-mx-250" :src="iconUrl.url"
                          img-alt="Image" />
                        <h3 v-else>{{ iconUrl.courierName }}</h3>
                        <!-- <div>{{selectedCourier.name}}</div> -->
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <AutoBox :listSize="listSize" :size="size" :width.sync="width" :length.sync="length"
                        :height.sync="height" :keyBox.sync="keyBox" :courier_key="selectedCourier.key"
                        @itemPreRate="itemPreRate()" :favoriteDimension="favoriteDimension && !editorder" />
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label><small class="text-danger">*</small> น้ำหนัก {{ checkUntiKG() ? '(กิโลกรัม)' : '(กรัม)'
                        }}</label>
                        <input ref="focusWeight" type="number" @change="calDimensionSpecialArea()"
                          v-model="$data[checkUntiKG() ? 'weightKG' : 'weight']" v-on:keyup="itemPreRate()" min="0"
                          :placeholder="checkUntiKG() ? 'น้ำหนัก (กิโลกรัม)' : 'น้ำหนัก (กรัม)'" class="form-control"
                          :class="{ 'is-invalid': submitAddPrebarcode && (checkUntiKG() ? $v.weightKG.$error : $v.weight.$error) || ratePreError || errorWeight }" />
                        <div v-if="submitAddPrebarcode && (checkUntiKG() ? !$v.weightKG.required : !$v.weight.required)"
                          class="invalid-feedback">กรุณากรอกนำ้หนัก {{ checkUntiKG() ? '(กิโลกรัม)' : '(กรัม)' }}</div>
                        <small v-if="ratePreError" class="text-danger">ไม่สามารถสร้างรายการได้ เนื่องจาก
                          <ul>
                            <li>ไม่พบเรทราคา</li>
                            <li>น้ำหนัก/ขนาดพัสดุ เกินที่ขนส่งกำหนด</li>
                            <li v-if="selectedCourier && checkCourierCondition(selectedCourier, {
                              width: width,
                              length: length,
                              height: height,
                              weight: weight
                            })">รองรับขนาดพัสดุไม่เกิน {{ courierRules[selectedCourier.key].maxWLH }} ซม.</li>
                            <li>ขนส่งไม่เปิดให้บริการในพื้นที่ต้นทาง/ปลายทาง</li>

                          </ul>
                        </small>
                        <small v-if="errorWeight && weight < 1" class="text-danger"><br />กรุณาใส่น้ำหนักมากกว่า 0</small>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div role="group">
                        <label for="input-live">ขนาดพัสดุ (เซนติเมตร)</label>
                        <div class="row">
                          <div class="col boxs">
                            <input type="number" min="1" placeholder="กว้าง" class="form-control" v-model="width"
                              :disabled="lockDimension || favoriteDimension && !editorder" v-on:keyup="itemPreRate()"
                              :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                              :class="{ 'is-invalid': validate.modalParcel.dimension.width.status == false }" />
                            <small v-if="validate.modalParcel.dimension.width.status == false" class="text-danger">{{
                              validate.modalParcel.dimension.width.msg
                            }}</small>
                          </div>
                          <div class="col boxs">
                            <input type="number" min="1" placeholder="ยาว" class="form-control" v-model="length"
                              :disabled="lockDimension || favoriteDimension && !editorder" v-on:keyup="itemPreRate()"
                              :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                              :class="{ 'is-invalid': validate.modalParcel.dimension.length.status == false }" />
                            <small v-if="validate.modalParcel.dimension.length.status == false" class="text-danger">{{
                              validate.modalParcel.dimension.length.msg
                            }}</small>
                          </div>
                          <div class="col">
                            <input type="number" min="1" placeholder="สูง" class="form-control"
                              :disabled="lockDimension || favoriteDimension && !editorder" v-model="height"
                              v-on:keyup="itemPreRate()"
                              :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                              :class="{ 'is-invalid': validate.modalParcel.dimension.height.status == false }" />
                            <small v-if="validate.modalParcel.dimension.height.status == false" class="text-danger">{{
                              validate.modalParcel.dimension.height.msg
                            }}</small>
                          </div>
                          <div class="col-1 d-flex align-items-center pl-0" v-if="!editorder">
                            <span @click="lockDimensionParcel()">
                              <Icon :icon="(favoriteDimension) ? 'mdi-lock' : 'mdi-lock-open-variant'"
                                class="cursor-pointer" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="col-lg-12 remark-textarea p-0">
                        <div class="form-group group-remark">
                          <label for="remarkOrderDetailPrebarcode">หมายเหตุ</label>
                          <textarea class="form-control" id="remarkOrderDetailPrebarcode" v-model="remarkOrderDetail"
                            rows="2" maxlength="100"
                            placeholder="ตัวอย่างหมายเหตุ เช่น พัสดุสามารถแตกหักได้ง่าย กรุณาอย่าโยน, หากติดต่อผู้รับไม่ได้ให้ฝากพัสดุไว้ที่นิติ">
                          </textarea>
                          <span class="remark-length">{{ remarkOrderDetail.length }} / 100</span>
                        </div>
                      </div>
                      <div class="col-lg-12 p-0">
                        <div class="row d-flex justify-content-end">
                          <div class="col-lg-6" />
                          <div class="col-12 col-lg-6">
                            <div class="form-group mb-0 d-flex flex-row align-items-center justify-content-between">
                              <label class="m-0">ราคา</label>
                              <div class="text-right" :class="remote_area.rate > 0 ? 'display-4' : 'display-3'">
                                {{ showPreRate | numFormat('0,0.00') }}
                                <small>บาท</small>
                              </div>
                            </div>
                            <div v-if="remote_area.rate > 0"
                              class="form-group mb-0 d-flex flex-row align-items-center justify-content-between">
                              <label class="m-0">พื้นที่ห่างไกล</label>
                              <div class="display-4 text-right">
                                <small class="d-inline-flex">
                                  <span class="pr-1 text-specialarea">
                                    +{{ remote_area.rate | numFormat('0,0.00') }}
                                  </span>
                                  บาท
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <h6 class="heading-small text-muted mb-4">ข้อมูลปลายทาง</h6>
                <div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label><small class="text-danger">*</small> รหัส Barcode</label>
                        <input type="text" v-model="scanBarcode" placeholder="รหัส Barcode" class="form-control"
                          @change="checkBarcode"
                          :class="{ 'is-invalid': submitAddPrebarcode && $v.scanBarcode.$error || errorBarcode || barcodeError }" />
                        <div v-if="submitAddPrebarcode && !$v.scanBarcode.required" class="invalid-feedback">
                          กรุณากรอกรหัส Barcode</div>
                        <div class="error invalid-feedback" v-if="submitAddPrebarcode && !$v.scanBarcode.minLength">
                          กรุณากรอก"รหัส Barcode"{{ $v.scanBarcode.$params.minLength.min }} หลัก</div>
                        <small v-if="errorBarcode" class="text-danger">กรุณากรอกรหัส Barcode ให้ถูกต้อง</small>
                        <small v-if="barcodeError" class="text-danger">รหัส Barcode ซ้ำ กรุณาใช้รหัส Barcode
                          อื่น</small>
                        <small v-if="barcodeOk" class="text-success">สามารถใช้รหัส Barcode นี้ได้</small>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater><small class="text-danger">*</small> ชื่อผู้รับ</label>
                        <div class="test-error" :class="{ 'is-invalid': submitAddPrebarcode && $v.to.name.$error }">
                          <autocomplete :search="searchRecipientDetails" :get-result-value="getValueRecipientDetails"
                            @submit="onSubmitRecipient" v-on:input="to.name = $event.target.value" ref="toName"
                            :value="to.name" :class="{ 'is-invalid': submitAddShipping && $v.to.name.$error }">
                            <template v-slot:result="{ result, props }">
                              <li v-bind="props">
                                <h6>
                                  ชื่อ:{{ result.name }} เบอร์:{{ result.tel }} ที่อยู่:{{ result.address }}
                                  ตำบล:{{ result.district }}
                                  อำเภอ:{{ result.state }} จังหวัด:{{ result.province }}
                                  รหัสปณ.:{{ result.postcode }}
                                </h6>
                              </li>
                            </template>
                          </autocomplete>

                          <div v-if="submitAddPrebarcode && !$v.to.name.required" class="invalid-feedback">
                            กรุณากรอกชื่อผู้รับ</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label><small class="text-danger">*</small> ที่อยู่</label>
                        <input type="text" placeholder="ที่อยู่" class="form-control" v-model="to.address"
                          :class="{ 'is-invalid': submitAddPrebarcode && $v.to.address.$error }" />
                        <div v-if="submitAddPrebarcode && !$v.to.address.required" class="invalid-feedback">
                          กรุณากรอกที่อยู่</div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> ตำบล/แขวง
                        </label>
                        <AutocompletesAddress :queryInput="to.state" :adsTypes="'sub-district'"
                          :class="{ 'is-invalid': submitAddPrebarcode && $v.to.state.$error }"
                          @input="to.state = $event.target.value" @select:item="onSubmitAddress($event, 'to')">
                        </AutocompletesAddress>
                        <div v-if="submitAddPrebarcode && !$v.to.state.required" class="invalid-th-address">
                          กรุณากรอกตำบล/แขวง</div>
                      </div>
                      <!-- ตำบล/แขวง -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> อำเภอ/เขต
                        </label>
                        <AutocompletesAddress :queryInput="to.district" :adsTypes="'district'"
                          :class="{ 'is-invalid': submitAddPrebarcode && $v.to.district.$error }"
                          @input="to.district = $event.target.value" @select:item="onSubmitAddress($event, 'to')">
                        </AutocompletesAddress>
                        <div v-if="submitAddPrebarcode && !$v.to.district.required" class="invalid-th-address">
                          กรุณากรอกอำเภอ/เขต</div>
                      </div>
                      <!-- อำเภอ/เขต -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> จังหวัด
                        </label>
                        <AutocompletesAddress :queryInput="to.province" :adsTypes="'province'"
                          :class="{ 'is-invalid': submitAddPrebarcode && $v.to.province.$error }"
                          @input="to.province = $event.target.value" @select:item="onSubmitAddress($event, 'to')">
                        </AutocompletesAddress>
                        <div v-if="submitAddPrebarcode && !$v.to.province.required" class="invalid-th-address">
                          กรุณากรอกจังหวัด</div>
                      </div>
                      <!-- จังหวัด -->
                    </div>

                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> รหัสไปรษณีย์
                        </label>
                        <AutocompletesAddress :queryInput="to.postcode" :adsTypes="'postcode'"
                          :class="{ 'is-invalid': submitAddPrebarcode && $v.to.postcode.$error }"
                          @input="to.postcode = $event.target.value" @select:item="onSubmitAddress($event, 'to')"
                          maxlength="5">
                        </AutocompletesAddress>
                        <div v-if="submitAddPrebarcode && !$v.to.postcode.required" class="invalid-th-address">
                          กรุณากรอกรหัสไปรษณีย์</div>
                        <div class="error invalid-th-address" v-if="submitAddPrebarcode && !$v.to.postcode.minLength">
                          กรุณากรอก"รหัสไปรษณีย์" {{ $v.to.postcode.$params.minLength.min }} หลัก</div>
                        <div class="error invalid-th-address" v-if="submitAddPrebarcode && !$v.to.postcode.maxLength">
                          กรุณากรอก"รหัสไปรษณีย์" {{ $v.to.postcode.$params.maxLength.max }} หลัก</div>
                        <div class="error invalid-th-address" v-if="submitAddPrebarcode && !$v.to.postcode.numeric">
                          กรุณากรอกเฉพาะตัวเลข</div>
                      </div>
                      <!-- รหัสไปรษณีย์ -->
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label><small class="text-danger">*</small> เบอร์ผู้รับ</label>
                        <div class="test-error" :class="{ 'is-invalid': submitAddPrebarcode && $v.to.tel.$error }">
                          <autocomplete :search="searchRecipientDetails" :get-result-value="getValueRecipientDetails"
                            @submit="onSubmitRecipient" v-on:input="to.tel = $event.target.value" :value="to.tel"
                            :class="{ 'is-invalid': submitAddPrebarcode && $v.to.tel.$error }">
                            <template v-slot:result="{ result, props }">
                              <li v-bind="props">
                                <h6>
                                  ชื่อ:{{ result.name }} เบอร์:{{ result.tel }} ที่อยู่:{{ result.address }}
                                  อำเภอ:{{ result.state }}
                                  ตำบล:{{ result.district }} จังหวัด:{{ result.province }}
                                  รหัสปณ.:{{ result.postcode }}
                                </h6>
                              </li>
                            </template>
                          </autocomplete>

                          <div v-if="submitAddPrebarcode && !$v.to.tel.required" class="invalid-feedback">
                            กรุณากรอกเบอร์ผู้รับ</div>
                          <div class="error invalid-feedback" v-if="submitAddPrebarcode && !$v.to.tel.minLength">
                            กรุณากรอก"หมายเลขโทรศัพท์"อย่างน้อย {{ $v.to.tel.$params.minLength.min }} หลัก</div>
                          <div class="error invalid-feedback" v-if="submitAddPrebarcode && !$v.to.tel.maxLength">
                            กรุณากรอก"หมายเลขโทรศัพท์"ไม่เกิน {{ $v.to.tel.$params.maxLength.max }} หลัก</div>
                          <div class="error invalid-feedback" v-if="submitAddPrebarcode && !$v.to.tel.numeric">
                            กรุณากรอกเฉพาะตัวเลข</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="remote_area.rate > 0" class="col-12 col-lg-12 notification-area">
                      <div class="background-notification py-2">
                        <ul class="m-0">
                          <li v-if="remote_area.rate > 0" class="text-specialArea text-sm">พื้นที่นี้มีค่าบริการพิเศษ {{
                            remote_area.rate }} บาท เนื่องจากจัดอยู่ในพื้นที่ห่างไกล</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-4 w-100 text-right">
                  <b-button variant="secondary" class="mx-3" @click="$bvModal.hide('modal-prebarcode')"
                    :disabled="addMoreOrder.isDisable">
                    ยกเลิก
                  </b-button>
                  <b-button type="submit" variant="primary" class="w-25" :disabled="rateError"
                    @click="validatePrebarcode">ยืนยัน</b-button>
                </div>
              </template>
            </card>
          </b-modal>

          <b-modal centered no-close-on-backdrop no-close-on-esc hide-footer v-model="courierTime.show"
            @hidden="closeModalCourierTime" body-class="p-0" header-class="p-1">
            <template slot="modal-title">
              <div slot="header" class="bg-white border-0 ml-2">
                <div class="row align-items-center">
                </div>
              </div>
              <div slot="body">
                <div class="col-12 text-center">
                  <h3 class="mb-0">
                    <i class="fas fa-exclamation-circle text-warning fa-lg"></i>
                    <br />
                    ราคาสิ้นสุด {{ expired_date }} น. <br />หากกดรับเงินหลังเวลา {{ expired_date }}
                    น.<br />จะไม่สามารถสร้างรายการได้ ขอบคุณค่ะ
                  </h3>
                </div>
              </div>
            </template>
            <div class="row">
              <div class="col-lg-12 text-center">
                <div class="w-100 py-2">
                  <b-button variant="warning" class="px-6" @click="closeModalCourierTime">
                    ตกลง
                  </b-button>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
        <BaseFillupPos ref="basefillupRef" :tmpCheckPrice="tmpCheckPrice" @clearEditInter="clearEditInter"
          :editInter="editInter" :count="count" @checkDisableCardCourier="checkDisableCardCourier"
          @addCartToLocalStorage="addDraftStorage" :cart="cart" :busy="busy" :basefillupSetting="basefillupSetting"
          :shop_id="shop_id" :listSize="listSize" :sender="sender" :selectedCourier="selectedCourier"
          :posPage="posPage" />
      </slide-y-up-transition>
    </div>
    <footer class="pb-3">
      <div class="container-fluid">
        <div class="row align-items-center justify-content-xl-between">
          <div class="col-xl-6">
            <div class="copyright text-center text-xl-left text-white">
              &copy; {{ year }}
              <a href="/" class="font-weight-bold ml-1 text-white" target="_blank">{{ $THEME.webTitle }}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <ModalNotification :notiShop="noti" @close="(noti.type == 'LOCK') ? reset() : ''" />
    <ModalAlertCredit :alertCredit="alertCredit" />
    <ModelAlertOverdueBalance :alertOverdue="alertOverdue" />
    <ModalCourierTeleport :courierTeleport="courierTeleport" />
    <ModalBannerCourier ref="bannerCourier" :bannerCourier="bannerCourier" />
    <ModalDraft @closeModal="openModalFromKey" @deleteOrderDraft="removeDraftOrder" :modalPOP="modalPOP"
      :draftStorage="draft_storage" @resumeDraftSelect="resumeNewOrder" />
    <ModalResumeDraft @resumeDraft="openModalFromKey" @removeDraft="removeDraftFunc()" @saveDraft="saveDraftFunc()"
      :modalPOP="modalPOP" />
    <NoticeCodInfoModal :modal="noticeCodInfoModal" :onClose="handleCloseNoticeCodInfo" />
  </div>
</template>

<script>
import cartPos from '@/constants/CartPos'
import BaseFillupPos from '@/components/PosFullFillup/BaseFillupPos'
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  numeric,
  helpers
} from "vuelidate/lib/validators"
import CourierComponents from '@/components/custom/pos/CourierComponents'
import ModalResumeDraft from '@/components/Modals/ModalresumeDraft'
import ModalDraft from "@/components/Modals/ModaldraftOrder"
import PosComponents from '@/components/custom/pos/import'
import AutoBox from '../components/AutoBox';
import AutocompletesAddress from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH'
import ModalNotification from '@/components/custom/ModalNotification'
import RadioBox from '@/components/custom/pos/RadioBox'
import CodCourierList from '@/components/custom/pos/CodCourierList'
import TableAddOrders from '@/components/custom/pos/TableAddOrders'
import InterParcelService from '@/components/custom/pos/modal/InterParcelService'
import ModalService from '@/components/custom/pos/modal/ModalService'
import AutocompletesOrigin from '@/components/Autocomplete/Autocompletes'
import ModalCourierTeleport from '@/components/Modals/ModalCourierTeleport'
import ModalInsurance from '@/components/Modals/ModalInsurance'
import ModalAlertRemoteArea from '@/components/custom/pos/modal/ModalAlertRemoteArea'
import NavbarPos from '@/components/custom/pos/NavbarPos'
import InputParcelType from '@/components/custom/pos/InputParcelType'
import ParcelInsurance from '@/components/custom/pos/ParcelInsurance'
import Courier from '@/courier/Courier'
import { SlideYUpTransition } from "vue2-transitions";
import { DataStore } from "vue-thailand-address";
import moment from "moment";
import validatePop from "../plugins/validatePop.js";
import validCourier from "../plugins/validCourierFormat.js";
import { censorCodeDraftOrderAPI, censorCodeBuyTotal } from "../plugins/censorError.js"
import courierRules from '@/constants/CourierRules';
import PREBARCODE_PATTERN from '@/constants/PrebarcodePattern';
import { COURIERS_COD } from '@/constants/CourierCOD'
import {
  swapBarcode,
  checkPersonID,
  printReceipt,
  groupBy,
  switchLockCourier,
  getTypeCart,
  getStepPage
} from "@/plugins/posHelper.js";
import { getLabelHtml, cancelOrderByOne, getLabelHtmlByTracking, checkMemberCod, checkStatusOrder, getSizeBox } from "@/axios/pos.js";
import { checkStatusShop } from "@/axios/noti.js";
import { searchSenderDetails, searchRecipientDetails, focusOutRecipientDetails, getValueRecipientDetails, searchTrackingDropoff } from "@/axios/search.js";
import ModalAlertCredit from '@/components/Modals//ModalAlertCredit'
import ModelAlertOverdueBalance from '@/components/Modals//ModelAlertOverdueBalance'
import ModalShabuEVoucher from '@/components/Modals/ModalShabuEVoucher'
import ModalZendai from '@/components/Modals/ModalZendai'

import ModalCheckBill from '@/components/custom/pos/modal/ModalCheckBill'
import ModalSender from '@/components/custom/pos/modal/ModalSender'
import { fetchWalletBanlancesToLocalStorage } from '@/axios/walletPayment.js';
import setLocalStorage from '@/constants/LocalStorageManagement'
import SearchTracking from '@/components/custom/pos/SearchTracking'
import configPOPTheme from '@/config/POPTheme'
import KerryDropoff from '@/components/custom/pos/modal/KerryDropoff_V2'
import LazadaDropoff from '@/components/custom/pos/modal/LazadaDropoff'
import FlashDropoff from '@/components/custom/pos/modal/FlashDropoff'
// import { deleteShipment , deleteBatch } from "@/axios/kerryDropoff.js"; // KERRY DROPOFF V1
import { setCookie, getCookie } from "@/helpers/util.js";
import { sound } from '@/plugins/soundEffect.js'
import CheckPricePage from '@/components/custom/pos/CheckPricePage'

import ModalBannerCourier from '@/components/Modals/ModalBannerCourier'
import { getBanner } from "@/axios/banner.js";
import { getCourierServiceArea } from "@/axios/courier.js";
import CartComponents from '@/components/custom/pos/CartComponents'
import CodProductList from '@/components/custom/pos/cod/CodProductList'
import NoticeCodInfoModal from '@/components/custom/pos/cod/NoticeCodInfoModal'
import NoticeCodAgreement from '@/components/custom/pos/cod/NoticeCodAgreement'
import { previewCoupon } from '@/axios/coupon.js'
import { debounce } from "debounce"


const API_URL = process.env.VUE_APP_API;
const DROPOFF_SP = 'dropoffShippop'
const KERRY_DROPOFF = 'kerryDropoff'
const LAZADA_DROPOFF = 'lazadaDropoff'
const ORANGE_DROPOFF = 'orangeDropoff'
const FLASH_DROPOFF = 'flashDropoff'
const ACTION_CREATE_ORDER = {
  index: 'index',
  excel: 'create_order_by_import_excel',
  modalParcel: 'model-parcel',
  modalPrebarcode: 'modal-prebarcode'
}
const TYPE_MANUAL = 'manual';
const TYPE_PREBARCODE = 'prebarcode';
const TYPE_EXCEL = 'excel';
const COURIER = new Courier();

export default {
  name: "pos",
  display: "Transition",
  data() {
    return {
      shopDetail: {
        tel: '',
        owner_name: '',
        name: ''
      },
      thaipostData:[],
      showThaipostRemote:true,
      refMemberId: '',
      editInter: {
        status: false,
        check: null,
        item: {},
      },
      tempForVariableCheckOnActionDelete: null,
      basefillupSetting: {
        typeFillup: 'DEFAULT',
        mutedText: '',
      },
      posPage: {
        step: getStepPage.STEP_PAGE_FIRST,
      },
      typeMoneyCheckBill: '',
      isHasBookBank: false,
      showCart: "non-slide",
      selectedCartToken: '',
      recheckCutOrderDraft: false,
      selectChargeableRate: {
        rate: 0,
        price: 0,
        min: 0,
        max: 0,
        size: 0
      },
      recheckDraft: false,
      editOrderDraft: false,
      modalPOP: {
        draftStorage: false,
        resumeDraft: false,
      },
      draft_storage: [],
      notification_area: {
        remote_area: {
          rate: 0,
          travel_surcharge: 0,
          island_surcharge: 0
        },
      },
      checkZone: "",
      courierDetails: null,
      checkCategoryPrice: null,
      dimensionWeight: 0,
      calculateWeight: 0,
      courierRules: courierRules,
      vRich: {
        errorMsg: ''
      },
      quick: {
        errorMsg: ''
      },
      easyShip: {
        errorMsg: ''
      },
      actioned: null,
      firstLoad: true,
      DROPOFF_SP: DROPOFF_SP,
      KERRY_DROPOFF: KERRY_DROPOFF,
      LAZADA_DROPOFF: LAZADA_DROPOFF,
      ORANGE_DROPOFF: ORANGE_DROPOFF,
      FLASH_DROPOFF: FLASH_DROPOFF,
      getStepPage: getStepPage,
      permission: {
        lineBooking: false,
        dropoffShippop: false,
        interParcelService: false,
        dropoffVRich: false,
        dropoffPanPan: false,
        dropoffEasyShip: false,
        kerryDropoff: false,
        lazadaDropoff: false,
        dropoffQuick: false,
        orangeDropoff: false,
        flashDropoff: false
      },
      orderExcel: {
        error: []
      },
      sendCheck: 0,
      temp: true,
      searchSenderDetails: searchSenderDetails,
      searchRecipientDetails: searchRecipientDetails,
      focusOutRecipientDetails: focusOutRecipientDetails,
      getValueRecipientDetails: getValueRecipientDetails,
      currentError: '',
      crossPrice: 0,
      setTime: "",
      iconUrl: {},
      draftSpecialCode: null,
      searchCourier: "",
      selectedCourier: "",
      listPostcodeSpecial: {},
      storesender: new DataStore(),
      storefrom: new DataStore(),
      storeto: new DataStore(),
      storebarcode: new DataStore(),
      year: new Date().getFullYear(),
      showMenu: false,
      userlogin: [],
      createdBy: "",
      couriers: [],
      preBarcode: "",
      scanBarcode: "",
      tracking: "",
      shop_id: "",
      indexid: 1,
      cart: [],
      remarkOrderDetail: "",
      submitAddPrebarcode: false,
      submitAddShipping: false,
      submitAddService: false,
      errorIdCard: false,
      barcodeOk: false,
      errorBirthday: false,
      // errorPassport: false,
      errorBarcode: false,
      barcodeError: false,
      rateError: false,
      ratePreError: false,
      errorWeight: false,
      errorCodAmount: false,
      errorCodProduct: {},
      editOrdersAll: false,
      isToggle: false,
      isLoadingShip: false,
      isLoadingNewBill: false,
      isLoadingVRich: false,
      isLoadingPanPan: false,
      isLoadingEasyShip: false,
      isLoadingQuick: false,
      isLoadingCheckCod: false,
      recheckCOD: false,
      statusOrder: false,
      search: {
        recipient: ""
      },
      interParcelService: {
        data: {
          trackingCode: "",
          fromName: "",
          toName: "",
          weight: "",
          amount: "",
          fee: "",
          remark: ""
        },
        isShow: false
      },
      titleName: "ที่อยู่ร้าน",
      date: "",
      prerate: 0,
      // show: false,
      firstmodal: "modal-idcard",
      // modalmoney: "modal-checkbill",
      modalparcel: "model-parcel",
      modalprebarcode: "modal-prebarcode",
      codCondition: {
        min: 100,
        max: 50000
      },
      noti: {
        show: false,
        type: "",
        created_by: "",
        date_noti: "",
        due_date: "",
        payment_type: "",
        router: false
      },
      productAvoid: {
        show: false,
        key: "insurance",
        isBanner: false
      },
      courierTeleport: {
        show: false,
      },
      courierTime: {
        show: false,
      },
      insuranceService: {
        show: false,
        insurance: null,
      },
      alertCredit: {
        show: false,
        creditPay: 0.00
      },
      alertOverdue: {
        show: false,
      },
      wallet: 0,
      expired_date: "",
      dateNow: "",
      next_two_hour: "",
      shabuEVoucher: {
        show: false,
        shabu: null,
        code: ""
      },
      zendai: {
        show: false,
        zendai: {
          rate: 0
        }
      },
      listSize: {
        defaultSize: [],
        SCGSize: [],
        KRYSSize: [],
      },
      sizeCheckPrice: {
        SCGSize: [],
        KRYSSize: [],
      },
      favoriteDimension: false,
      courierDropoffVRich: {},
      courierDropoffEasyShip: {},
      courierDropoffQuick: {},
      dropoffPanPan: {
        show: false,
        trackingCode: "",
        shippopTrackingCode: "",
        purchaseId: "",
        datetimeCreateOrder: "",
        errorMsg: "",
        courier: {}
      },
      dropoffVRich: {
        show: false,
        trackingCode: "",
        shippopTrackingCode: "",
        purchaseId: "",
        datetimeCreateOrder: ""
      },
      dropoffQuick: {
        show: false,
        trackingCode: "",
        shippopTrackingCode: "",
        purchaseId: "",
        datetimeCreateOrder: ""
      },
      dropoffEasyShip: {
        show: false,
        trackingCode: "",
        notCloseModal: false,
      },
      dropoffLine: {
        bookingId: ""
      },
      kerryDropoff: {
        show: false,
        isLoadingKerryDropoff: false,
        favoriteWeight: false,
        favoriteDimension: false,
        trackingCode: '',
        errorMsg: '',
        size: {
          boxSize: ""
        },
        parcel: {
          weight: '',
          weightKG: '',
          width: '',
          length: '',
          height: '',
          keyBox: '',
        },
        code: ''
      },
      flashDropoff: {
        show: false,
        isLoadingFlashDropoff: false,
        favoriteWeight: false,
        favoriteDimension: false,
        trackingCode: '',
        errorMsg: '',
        code: '',
        size: {
          boxSize: ''
        },
        parcel: {
          weight: '',
          weightKG: '',
          width: '',
          length: '',
          height: '',
          keyBox: ''
        },
        images: [],
        queryId: '',
        action: {
          photo: false,
          dim: false,
          weight: false
        }
      },
      lazadaDropoff: {
        show: false,
        isLoadingLazadaDropoff: false,
        trackingCode: '',
        errorMsg: '',
        code: ''
      },
      bannerCourier: {
        show: false,
        campaigns: [],
        courierCode: '',
        size: {
          width: 800,
          height: 500
        }
      },
      tmpCheckPrice: {
        toINTER: {
          text: '',
          alpha_2_code: '',
          alpha_3_code: '',
          calling_code: '',
          destination_supported: '',
          id: '',
          manufacturer_supported: '',
        },
        isLoading: false,
        isCheckPrice: false,
        categoryCode: 'DOMESTIC',
        courierCode: 'DEFAULT',
        fromAddress: {
          district: '',
          state: '',
          province: '',
          postcode: ''
        },
        toAddress: {
          district: '',
          state: '',
          province: '',
          postcode: ''
        },
        weight: '',
        weightKG: '',
        dimension: {
          width: '',
          length: '',
          height: '',
          size: {
            boxSize: ""
          },
          keyBox: '',
        }
      },
      pickup_type: 'JNTP',
      sameData: "",
      weight: "",
      weightKG: "",
      keyBox: "",
      size: {
        boxSize: ""
      },
      width: "",
      length: "",
      height: "",
      codAmount: "",
      codProducts: [],
      type: "",
      labeltype: "",
      typeOfLabel: "default",
      labeltypeDropoff: "",
      shippop: "",
      editorder: "",
      idorder: "",
      bookingItemId: null,
      lockCardCourier: {
        courier: false,
        prebarcode: false,
        cod: false,
        gen: false,
        dropoffShippop: false,
        dropoffVrich: false,
        dropoffEasyship: false,
        dropoffQuick: false,
        dropoffKerry: false,
        dropoffPanPan: false,
        dropoffLazada: false,
        dropoffLine: false,
        dropoffLAO: false,
        dropoffINTER: false,
        dropoffFlash: false,
        inter: false
      },
      busy: true,
      count: 1,
      orderIdByOne: '',
      errorCreateOrderByOne: {
        status: false,
        msg: '',
      },
      errorAlertParcel: {
        status: false,
        msg: '',
        disableButton: false,
        errorServiceArea: {
          status: false,
          msg: '',
        },
        errorDestination: {
          status: false,
          msg: '',
        }
      },
      addMoreOrder: {
        isShow: false,
        isActive: false,
        order: [],
        typeCourier: "",
        error: {
          status: false,
          msg: null
        }
      },
      dropoffShippopDetails: {
        isShow: false,
        labelSize: this.label,
        parcels: [{
          barcode: "",
          tracking_code: "",
          courier_tracking_code: "",
          weight: "",
          price: "5.00",
          num: 1,
          name: "Thailandpost",
          key: "THP",
          type: DROPOFF_SP,
          option: {
            btnLabel: true,
            loadingIco: false,
            error_input: {
              status: null,
              msg: ""
            }
          }
        }]
      },
      cod_details: {
        isShow: false,
        couriers: [],
        isCod: false,
      },
      shop_setting: {
        how_to_use_cod: false
      },
      validateAddress: {
        to: {
          state: {
            status: false,
            msg: null
          },
          district: {
            status: false,
            msg: null
          },
          province: {
            status: false,
            msg: null
          },
          postcode: {
            status: false,
            msg: null
          },
        },
        from: {
          state: {
            status: false,
            msg: null
          },
          district: {
            status: false,
            msg: null
          },
          province: {
            status: false,
            msg: null
          },
          postcode: {
            status: false,
            msg: null
          },
        }
      },
      validate: {
        modalParcel: {
          checkDimension: {
            status: true,
            msg: ""
          },
          dimension: {
            width: {
              status: true,
              msg: ""
            },
            length: {
              status: true,
              msg: ""
            },
            height: {
              status: true,
              msg: ""
            }
          }
        },
        checkInput: {
          state: true,
          district: true,
          province: true,
          postcode: true
        }
      },
      checkBill: {
        show: false,
        changeMoney: 0,
        receiveMoney: "",
        discountAmount: "",
      },
      remote_area: {
        rate: 0,
        travel_surcharge: 0,
        island_surcharge: 0
      },
      extra_handling_charge: 0,
      from: {
        source: 0,
        address: "",
        district: "",
        latlng: "",
        name: "",
        postcode: "",
        province: "",
        state: "",
        tel: "",
        email: ""
      },
      to: {
        address: "",
        district: "",
        latlng: "",
        name: "",
        postcode: "",
        province: "",
        state: "",
        tel: ""
      },
      sender: {
        id_no: "",
        name: "",
        birthday: "",
        tel: "",
        address: "",
        customer_type: "0",
        state: "",
        district: "",
        postcode: "",
        province: "",
        tax: "",
        identity: false,
        mem_id: 0,
        remark_label: "",
      },
      tmpService: {
        categoryCode: "",
        categoryName: "",
        step: "FIRST",
        code: "",
        name: "",
        rate: "",
        fee: "",
        remark: ""
      },
      label: "a5",
      cod: "",
      fee: {
        name: "",
        rate: "",
        fee: "",
        serviceOther: "",
        remark: ""
      },
      courier_allow: [],
      shubuVoucherAllow: {},
      insurance: {
        error: {
          status: false,
          type: null,
          msg: ""
        },
        id: 0,
        isCheck: false,
        declared_value: "",
        category: "",
        remark: "",
        listRates: [],
        listPrice: {
          cost: 0,
          rate: 0,
          price: 0
        }
      },
      save_address: {
        origin: true,
        destination: true,
      },
      tempUser: null,
      previewCouponResult: null,
      walletPrerate: 0,
      noticeCodInfoModal: {
        open: false
      },
      memberService: {
        memberServiceId: null,
        isAcceptedCodAgreement: false,
        codAgreementUrl: '',
        memberServiceToken: ''
      },
      codAgreementModal: {
        open: false
      }
    }
  },
  validations: {
    weight: { required },
    weightKG: { required },
    codAmount: { required },
    scanBarcode: { required, minLength: minLength(6) },
    sender: {
      id_no: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(30)
      },
      name: { required, maxLength: maxLength(50) },
      tel: {
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(15)
      },
      birthday: {
        required: requiredIf(function (state) {
          return state.birthday.length > 0 && this.$THEME.optionalDOB
        }),
        minLength: minLength(8),
        maxLength: maxLength(10)
      },
      address: { required, maxLength: maxLength(200) },
      district: { required, maxLength: maxLength(50) },
      state: { required, maxLength: maxLength(50) },
      province: { required, maxLength: maxLength(50) },
      postcode: {
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(5)
      },
      tax: { numeric, maxLength: maxLength(50) }
    },
    from: {
      address: { required },
      district: { required },
      name: { required },
      postcode: {
        required,
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(5)
      },
      province: { required },
      state: { required },
      tel: {
        required,
        // numeric,
        isTelValid: helpers.regex('isTelValid', /^[+|0-9][0-9]*$/i),
        minLength: minLength(9),
        maxLength: maxLength(14)
      }
    },
    to: {
      address: { required },
      district: { required },
      name: { required },
      postcode: {
        required,
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(5)
      },
      province: { required },
      state: { required },
      tel: {
        required,
        // numeric,
        isTelValid: helpers.regex('isTelValid', /^[+|0-9][0-9]*$/i),
        minLength: minLength(9),
        maxLength: maxLength(14)
      }
    },
    insurance: {
      declared_value: { required },
      category: { required },
      remark: { required }
    }
  },
  mounted() {
    if (!this.checkThemeQuick()) {
      this.fetchOrderDraft()
    }
    this.defaultLoad();
    if (!getCookie('bannerAvoid') && configPOPTheme.bannerCampaignPosition) {
      fetch('https://ads.shippop.com/api/banner?device=' + (screen.width > 900 ? 'desktop' : 'mobile') + '&position_page=' + configPOPTheme.bannerCampaignPosition)
        .then(response => response.json())
        .then(res => {
          if (res && res.js) {
            eval(res.js)('el-banner');
          }
        })
      setCookie('bannerAvoid', 1, '4hr')
    }
    let now = moment(new Date(Date.now())).format("YYYY-MM-DD HH:mm:ss");
    let next_two_hour = moment().add(2, 'hours').format('YYYY-MM-DD HH:mm:ss');
    this.next_two_hour = next_two_hour;
    this.dateNow = now;
    this.tempUser = JSON.parse(localStorage.getItem("user"))
  },
  components: {
    BaseFillupPos,
    LazadaDropoff,
    CourierComponents,
    CartComponents,
    ModalResumeDraft,
    ModalDraft,
    'CreateOrderByExcel': PosComponents.CreateOrderByExcel,
    'DropoffShippop': PosComponents.DropoffShippop,
    AutoBox,
    AutocompletesOrigin,
    AutocompletesAddress,
    ModalNotification,
    SlideYUpTransition,
    RadioBox,
    CodCourierList,
    TableAddOrders,
    ModalInsurance,
    ModalService,
    ModalAlertRemoteArea,
    InterParcelService,
    NavbarPos,
    InputParcelType,
    ParcelInsurance,
    ModalAlertCredit,
    ModelAlertOverdueBalance,
    ModalCourierTeleport,
    ModalShabuEVoucher,
    ModalZendai,
    ModalCheckBill,
    SearchTracking,
    KerryDropoff,
    ModalSender,
    ModalBannerCourier,
    CheckPricePage,
    FlashDropoff,
    CodProductList,
    NoticeCodInfoModal,
    NoticeCodAgreement,
  },
  async created() {
    await checkStatusShop().then(async res => {
      let status_shop = res.status_shop

      this.noti.created_by = res.created_by
      this.noti.type = status_shop
      this.noti.payment_type = ((res.payment_type) ? res.payment_type : '')

      if (status_shop == 'LOCK') {
        this.noti.show = true
        this.busy = false
      } else if (status_shop == 'DEBT' && res.created_by != 'superadmin') {
        this.noti.date_noti = res.date_noti
        this.noti.show = true
        await this.beforeGetShop();
      } else if (status_shop == 'LOCK_ACCOUNT') {
        this.noti.show = true
        this.noti.due_date = res.due_date
        this.busy = false
      } else {
        await this.beforeGetShop()
      }
      // TODO: remove it after test 1058
      this.hasErrorRefMemId();
    }).catch(async (error) => {
      this.showErrorModal(error);
      await this.beforeGetShop()
    })

    if (!this.checkThemeQuick()) {
      if (!cartPos.cartToken().get()) {
        this.newGenerateCartToken()
      }
      await this.isOpenResumeDraft()
      this.tabActiveCheckDraft()
    }
  },
  methods: {
    changetmpCheckPrice(key) {
      this.tmpCheckPrice.categoryCode = key
    },
    async hasErrorRefMemId(modalOpen) {
      const headers = {
        headers: {
          token: localStorage.getItem("access_token")
        }
      }
      if (this.permission.interParcelService) {
        await this.$http.get(this.$API_URL + '/inter/refmemid', headers).then((res) => {
          if (!res.data.status) {
            this.permission.interParcelService = false
            this.lockCardCourier.dropoffLAO = true
            this.lockCardCourier.dropoffINTER = true
            if (modalOpen) {
              this.showErrorModal("กรุณาติดต่อเซลที่ดูแล เพื่อเปิดใช้งานขนส่งต่างประเทศ")
            }
          }
        })
      }
    },
    clearEditInter() {
      this.editInter = {
        status: false,
        check: null,
        item: {},
      }
    },
    checkCourierCondition(courier, shipment) {
      const width = parseFloat(shipment.width);
      const length = parseFloat(shipment.length);
      const height = parseFloat(shipment.height);
      const weight = parseFloat(shipment.weight);
      const totalSize = width + length + height;
      if (this.courierRules[courier.key].maxWLH < totalSize) {
        return true
      }
    },
    setFalseRecheck(key) {
      this.recheckCutOrderDraft = key
    },
    setTypeMoneyCheckBill(key) {
      this.typeMoneyCheckBill = key
    },
    openCartComponent(key) {
      this.showCart = key
    },
    slideDialog(key) {
      this.showCart = key
      let timeout
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        this.showCart = ""
      }, 350)
    },
    resumeNewOrder(key) {
      this.cart = []
      this.sender = []
      cartPos.cartToken().set(key)
      const getDraftAll = cartPos.draftStorage().get()
      const getSenderAll = cartPos.senderStorage().get()
      const getCartToken = cartPos.cartToken().get()
      const shopCode = this.$USER_LOGIN.get().details.shop_code
      this.cart = (getDraftAll[shopCode] && getDraftAll[shopCode][getCartToken]) ? getDraftAll[shopCode][getCartToken] : []
      this.cart.map((keyCart) => {
        if (keyCart.type == 'ship') {
          if (keyCart.dropoff_type !== 'INTER_BOOK' && keyCart.dropoff_type !== 'LAO_BOOK') {
            const getCourier = this.couriers.find(findKey => findKey.id === keyCart.refer_id)
            this.selectedCourier = getCourier;
            keyCart.courier.rates = groupBy(getCourier.rates, "type")
          }
        }
      })
      this.sender = getSenderAll[shopCode][getCartToken] ? getSenderAll[shopCode][getCartToken] : this.clearSender()
      this.checkDisableCardCourier()
      this.openModalFromKey('draftStorage')
    },
    removeDraftFunc() {
      this.checkOutOrderProduct()
      this.openModalFromKey('resumeDraft')
      this.recheckDraft = false
      this.reStartOrderByOne();
      this.newGenerateCartToken()
      if (!this.filterCheckKerryDropoff || this.idorder || !this.filterCheckFlashDropoff) {
        this.reset();
      }
      this.cart = []
      this.clearSender()
    },
    saveDraftFunc() {
      this.reStartOrderByOne();
      this.newGenerateCartToken()
      if (!this.filterCheckKerryDropoff || this.idorder || !this.filterCheckFlashDropoff) {
        this.reset();
      }
    },
    tabActiveCheckDraft() {
      window.addEventListener('blur', () => {
        this.selectedCartToken = cartPos.cartToken().get()
      });
      window.addEventListener('focus', () => {
        // console.log('this.selectedCourier.rates: ', this.selectedCourier.rates)
        let setTime;
        clearTimeout(setTime);
        const localUser = JSON.parse(localStorage.getItem("user"))

        setTime = setTimeout(() => {
          // this.clearSender()
          this.loadDraftStorage()
          // }
          this.fetchOrderDraft()
          if (localUser.shop_code !== this.tempUser.shop_code) {
            this.reset();
          } else if (this.selectedCartToken && this.selectedCartToken == cartPos.cartToken().get()) {
            // ตระกร้าเดิมไม่เปิด
          } else if (this.selectedCartToken && this.selectedCartToken != cartPos.cartToken().get()) {
            // เปลี่ยนตระกร้า เปลี่ยนคนส่ง
            this.reset();
          } else if (this.cart.length > 0 && !this.recheckCutOrderDraft) {
            // ตอนสลับ tab แล้วมีของในตระกร้าอยู่ && ยังไม่กดรับเงิน
            this.modalPOP.resumeDraft = true
          }

          if (this.cart.length === 0) {
            switchLockCourier(getTypeCart.TYPE_CART_DEFAULT, this.lockCardCourier)
            this.orderIdByOne = ""
            this.reStartOrderByOne()
          }
        }, 500)
      });
    },
    async setOrderDraftFronToken() {
      const getCartToken = cartPos.cartToken().get()
      const getDraftAll = cartPos.draftStorage().get()
      const shopCode = this.$USER_LOGIN.get().details.shop_code
      const getSenderAll = cartPos.senderStorage().get()
      // console.log('wtf: ', (getDraftAll[shopCode] && getDraftAll[shopCode][getCartToken]))
      // console.log('getDraftAll: ', getDraftAll[shopCode][getCartToken])
      this.cart = (getDraftAll[shopCode] && getDraftAll[shopCode][getCartToken]) ? getDraftAll[shopCode][getCartToken] : []
      this.cart.map((keyCart) => {
        // โหลดครั้งแรก เวลาเปิดหน้ามาให้เลือกขนส่งล่าสุด เพื่อใช้เช็ค disable พวก dropoff / prebarcode
        // กรณีมีขนส่งที่เลือกอยู่แล้ว (เปิดหน้าสร้างรายการค้างไว้) ไม่ต้องไปโหลด selectedCourier
        if (keyCart.type == 'ship' && !this.selectedCourier) {
          if (!['INTER_BOOK', 'LAO_BOOK', 'LAZADA_DROPOFF', 'KERRY_DROPOFF', 'FLASH_DROPOFF'].includes(keyCart['dropoff_type'])) {
            console.log('doing or pao')
            const getCourier = this.couriers.find(findKey => findKey.id === keyCart.refer_id)
            this.selectedCourier = getCourier;
            if (getCourier) {
              keyCart.courier.rates = groupBy(getCourier.rates, "type")
            }
          }
          // if ( keyCart.dropoff_type !== 'LAZADA_DROPOFF' && keyCart.dropoff_type !== 'KERRY_DROPOFF') {
          //   const getCourier = this.couriers.find(findKey => findKey.id === keyCart.refer_id)
          //   this.selectedCourier = getCourier;
          //   keyCart.courier.rates = groupBy(getCourier.rates, "type")
          // }
        }

      })
      // count คือ รหัส order ในตะกร้า ห้ามซ้ำกัน ถ้าซ้ำกันตอนแก้ไขจะทำให้เกิดสลับ order
      if (this.cart.length > 0) {
        this.count = (this.cart[this.cart.length - 1].check + 1);
      }
      // this.sender = getSenderAll[shopCode][getCartToken] ? getSenderAll[shopCode][getCartToken] : this.clearSender()
      if (getSenderAll[shopCode] && getSenderAll[shopCode][getCartToken]) {
        this.sender = getSenderAll[shopCode][getCartToken]
      }
      await this.checkDisableCardCourier()
    },
    isOpenResumeDraft() {
      const getCartToken = cartPos.cartToken().get()
      const getDraftAll = cartPos.draftStorage().get()
      const shopCode = this.$USER_LOGIN.get().details.shop_code
      if (getDraftAll[shopCode] && getDraftAll[shopCode][getCartToken]) {
        this.openModalFromKey('resumeDraft')
      }
      this.setOrderDraftFronToken()
    },
    async loadDraftStorage() {
      if (!this.checkThemeQuick()) {
        // let getCartToken = cartPos.cartToken().get()
        const getDraftAll = cartPos.draftStorage().get()
        // const shopCode = this.$USER_LOGIN.get().details.shop_code
        if (Object.keys(getDraftAll).length > 0 && this.recheckCutOrderDraft === false) {
          this.setOrderDraftFronToken()
        }
      }
    },
    async fetchOrderDraft() {
      const getDraftAll = cartPos.draftStorage().get()
      const getSenderAll = cartPos.senderStorage().get()
      const getFirstDate = cartPos.dateFirstDraft().get()
      const shopCode = this.$USER_LOGIN.get().details.shop_code
      let dataArrayTemp = []
      const cartTokenKeys = (getDraftAll != null && getDraftAll[shopCode]) ? Object.keys(getDraftAll[shopCode]) : null
      if (cartTokenKeys != null) {
        await cartTokenKeys.map((keymap) => {
          let tmpItem = {}
          tmpItem["key"] = keymap
          tmpItem["date_created"] = getFirstDate[shopCode][keymap]
          if (getSenderAll[shopCode][keymap])
            tmpItem["name"] = getSenderAll[shopCode][keymap]["name"]
          tmpItem["total_orders"] = getDraftAll[shopCode][keymap].length
          dataArrayTemp.push(tmpItem)
        })
      }
      this.draft_storage = dataArrayTemp
    },
    openModalFromKey(key) {
      this.modalPOP[key] = !this.modalPOP[key]
      if (key === 'resumeDraft') {
        this.recheckDraft = false
      }
    },
    openModalService() {
      this.fee.name = 'อื่นๆ'
      this.$bvModal.show('modal-service-fee')
    },
    openRegisterCOD() {
      this.recheckCOD = true;
      window.open(`/registermember/${this.from.email}`, '_blank')
    },
    tabActiveCheckStatusOrder() {
      window.addEventListener('focus', () => {
        if (this.orderIdByOne == setLocalStorage.orderId().get().order_id) {
          let orderCart = setLocalStorage.orderCart().get().order_cart
          this.cart = (orderCart.hasOwnProperty(this.$USER_LOGIN.get().details.shop_code)) ? orderCart[this.$USER_LOGIN.get().details.shop_code] : [];
        }
        if (this.orderIdByOne && !this.idorder && !this.statusOrder) {
          checkStatusOrder(this.orderIdByOne).then(res => {
            if (res.hasOwnProperty('status') && res.status === 'SUCCESS') {
              this.statusOrder = true
              this.modalConfirmDuplicateOrder();
            }
          });
        }
      });
    },
    tabActiveCheckCOD() {
      window.addEventListener('focus', () => {
        if (this.recheckCOD) {
          this.recheckCOD = false
          this.isLoadingCheckCod = true

          checkMemberCod(this.sender.tel, this.sender.id_no)
            .then(res => {
              this.isLoadingCheckCod = false
              if (!res.status) {
                this.sender.identity = false
              }
              if (res.status === 'is member') {
                this.sender.identity = true
                this.sender.mem_id = res.mem_id
                this.memberService.memberServiceId = res.member_service_id
                this.memberService.codAgreementUrl = res.cod_agreement_url
                this.memberService.isAcceptedCodAgreement = res.is_accepted_cod_agreement
              } else {
                this.sender.identity = false
              }
              //setLocalStorage Update For Sender
              setLocalStorage.sender().set(this.sender)
            }).catch(() => {

            })
        }
      });
    },
    async checkTrackingQuick() {
      this.isLoadingQuick = true;

      this.clearValueValidate();

      let uniqueTrackingQuick = this.cartDropoffQuick.filter(quick => {
        return quick.dropoff_tracking_code === this.dropoffQuick.trackingCode
      })

      if (uniqueTrackingQuick.length > 0) {
        this.quick.errorMsg = `ไม่สามารถสร้างรายการ DROP OFF QUICK ได้ เนื่องจากหมายเลขพัสดุ ${this.dropoffQuick.trackingCode} นี้ ถูกใช้งานไปแล้ว`;
        this.isLoadingQuick = false
        return false
      }

      await searchTrackingDropoff(this.dropoffQuick.trackingCode, 'QUICK_DROPOFF').then(resData => {
        this.isLoadingQuick = false
        this.dropoffQuick.shippopTrackingCode = resData.tracking_code
        this.dropoffQuick.purchaseId = resData.purchase_id
        this.dropoffQuick.datetimeCreateOrder = resData.datetime_order
        if (resData.hasOwnProperty('insurance') && resData.insurance.declared_value > 0) {
          this.insurance.isCheck = true;
          this.insurance.declared_value = resData.insurance.declared_value
          this.$refs.parcelInsurance.getRate();
          this.$refs.inputParcelType.seleted({
            key: resData.insurance.category_key,
            name: resData.insurance.category_name
          }, 'onSeleted')
        }
        sound('positiveBeep')
        this.mapDetailsTrackingDropoff(resData);
      }).catch(e => {
        sound('beepFail')
        this.isLoadingQuick = false
        this.quick.errorMsg = e;
      });
    },
    async checkTrackingPanPan() {
      this.isLoadingPanPan = true;

      this.clearValueValidate()

      let uniqueTrackingPanPan = this.cartDropoffPanPan.filter(panpan => {
        return panpan.dropoff_tracking_code === this.dropoffPanPan.trackingCode
      })

      if (uniqueTrackingPanPan.length > 0) {
        sound('beepFail')
        this.dropoffPanPan.errorMsg = `ไม่สามารถสร้างรายการ PANPAN WORLD ได้ เนื่องจากหมายเลขพัสดุ ${this.dropoffPanPan.trackingCode} นี้ ถูกใช้งานไปแล้ว`;
        this.isLoadingPanPan = false
        return false
      }

      await searchTrackingDropoff(this.dropoffPanPan.trackingCode, 'PANPAN_DROPOFF').then(resData => {
        this.isLoadingPanPan = false
        this.dropoffPanPan.shippopTrackingCode = resData.tracking_code
        this.dropoffPanPan.purchaseId = resData.purchase_id
        this.dropoffPanPan.datetimeCreateOrder = resData.datetime_order
        sound('positiveBeep')
        this.mapDetailsTrackingDropoff(resData);
      }).catch(e => {
        sound('beepFail')
        this.isLoadingPanPan = false
        this.dropoffPanPan.errorMsg = e;
      });
    },
    async checkTrackingVRich() {
      this.isLoadingVRich = true;

      this.clearValueValidate()

      let uniqueTrackingVRich = this.cartDropoffVRich.filter(vrich => {
        return vrich.dropoff_tracking_code === this.dropoffVRich.trackingCode
      })

      if (uniqueTrackingVRich.length > 0) {
        sound('beepFail')
        this.vRich.errorMsg = `ไม่สามารถสร้างรายการ V RICH ได้ เนื่องจากหมายเลขพัสดุ ${this.dropoffVRich.trackingCode} นี้ ถูกใช้งานไปแล้ว`;
        this.isLoadingVRich = false
        return false
      }

      await searchTrackingDropoff(this.dropoffVRich.trackingCode, 'VRICH_DROPOFF').then(resData => {
        this.isLoadingVRich = false
        this.dropoffVRich.shippopTrackingCode = resData.tracking_code
        this.dropoffVRich.purchaseId = resData.purchase_id
        this.dropoffVRich.datetimeCreateOrder = resData.datetime_order
        sound('positiveBeep')
        this.mapDetailsTrackingDropoff(resData);
      }).catch(e => {
        sound('beepFail')
        this.isLoadingVRich = false
        this.vRich.errorMsg = e;
      });

    },
    mapDetailsTrackingDropoff(resData) {
      this.from.address = resData.from.address
      this.from.district = resData.from.city
      this.from.name = resData.from.name
      this.from.postcode = resData.from.postcode
      this.from.province = resData.from.province
      this.from.state = resData.from.district
      this.from.tel = resData.from.phone
      this.from.email = resData.from.email
      this.to.address = resData.to.address
      this.to.district = resData.to.city
      this.to.name = resData.to.name
      this.to.postcode = resData.to.postcode
      this.to.province = resData.to.province
      this.to.state = resData.to.district
      this.to.tel = resData.to.phone
      this.tracking = resData.courier_tracking_code
      this.codAmount = resData.cod_amount
      if (this.codAmount > 0) {
        this.cod_details.isCod = true
      }

      this.checkValidateDropoff();
    },
    checkTrackingEasyShip() {
      this.isLoadingEasyShip = true;
      this.clearValueValidate();
      this.$http
        .get(
          this.$API_URL + "/dropoff/easy-ship/shipment",
          {
            headers: {
              Token: localStorage.getItem("access_token")
            },
            params: {
              tracking_code: this.dropoffEasyShip.trackingCode,
            }
          }
        )
        .then(res => {
          this.isLoadingEasyShip = false

          let checkError = validatePop(res)
          if (!checkError.status) {
            sound('beepFail')
            this.isLoadingEasyShip = false
            this.easyShip.errorMsg = checkError.msg;
            return false
          }
          sound('positiveBeep')
          let resData = res.data.data.data;

          this.from.name = resData.senderInfo.senderName
          this.from.tel = resData.senderInfo.senderMobile
          this.to.address = resData.recipientInfo.recipientAddress
          this.to.district = resData.recipientInfo.recipientAmphur
          this.to.name = resData.recipientInfo.recipientName
          this.to.postcode = resData.recipientInfo.recipientZipcode
          this.to.province = resData.recipientInfo.recipientProvince
          this.to.state = resData.recipientInfo.recipientTambon
          this.to.tel = resData.recipientInfo.recipientMobile

          this.codAmount = resData.codInfo.codAmount

          if (this.codAmount > 0) {
            this.cod_details.isCod = true
          }

          this.checkValidateDropoff();

        })
        .catch(() => {
          sound('beepFail')
          this.isLoadingEasyShip = false;
          this.showErrorModal(
            " พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #033 "
          )
        })
    },
    openModalEVoucher() {
      this.shabuEVoucher.show = true
    },
    defaultLoad() {
      this.getUserlogin()
      this.checkCreateBy()
      if (this.checkThemeQuick()) {
        this.tabActiveCheckCOD()
        this.tabActiveCheckStatusOrder()
      }
      let orderCart = setLocalStorage.orderCart().get().order_cart;
      if (this.checkThemeQuick() && orderCart) {
        this.cart = (orderCart.hasOwnProperty(this.$USER_LOGIN.get().details.shop_code)) ? orderCart[this.$USER_LOGIN.get().details.shop_code] : [];
        if (this.cart.length > 0) {
          this.orderIdByOne = setLocalStorage.orderId().get().order_id
          this.count = (this.cart[this.cart.length - 1].check + 1);
          this.selectedCourier = (this.cartShipping.length > 0 && !this.filterCheckKerryDropoff && !this.filterCheckFlashDropoff) ? this.cartShipping[0].courier : ""
          //   if( this.filterCheckKerryDropoff ){
          //     this.$refs.kerryDropoff.batchId = setLocalStorage.batchNo().get().batch_no
          //   }
          this.checkDisableCardCourier()
        }
      }
      if (this.checkThemeQuick() && setLocalStorage.sender().get().sender) {
        this.sender = setLocalStorage.sender().get().sender
      }
    },
    clearSender() {
      return {
        id_no: "",
        name: "",
        birthday: "",
        tel: "",
        address: "",
        customer_type: "0",
        state: "",
        district: "",
        postcode: "",
        province: "",
        tax: "",
        identity: false,
        mem_id: 0,
        remark_label: "",
      }
    },
    getUserlogin() {
      this.userlogin = JSON.parse(localStorage.getItem("user"))
    },
    checkCreateBy() {
      this.createdBy = this.userlogin.under_by
    },
    closeModalProductAvoid() {
      if (this.firstLoad) {
        this.switchFirstLoad()
        this.productAvoid.isBanner = false
      }
      this.productAvoid.show = false
    },
    switchFirstLoad() {
      this.firstLoad = !this.firstLoad
    },
    async onSubmitAddress(ads, objKey) {
      this.showThaipostRemote = true
      Object.keys(this[objKey]).forEach(key => {
        if (ads[key]) {
          this[objKey][key] = ads[key]
        } else if (key == 'state') {
          this[objKey]['state'] = ads['sub-district']
        }
        else {
          this[objKey][key] = this[objKey][key]
        }
      })

      if (objKey == 'to') {
        this.checkDestinationCourier()
        await this.callCheckProblemCategory()
      }

    },
    calDimensionSpecialArea() {
      let setTime;
      clearTimeout(setTime);
      setTime = setTimeout(() => {
        this.callCheckProblemCategory()
      }, 500)
    },
    async callCheckProblemCategory() {
      // เซ็ตโซนในตัวแปร
      await this.itemPrice()
      console.log('计算价格',this.selectedCourier)
      const courierCode = this.selectedCourier.key
      await this.setCheckZone(courierCode)
      this.courierDetails = await COURIER.setCourier(this.selectedCourier.key).getZone(this.checkZone, this.selectedCourier)

      await this.checkRemoteArea({ remote_area: this.courierDetails.rate_remote_area, travel_surcharge: this.courierDetails.travel_surcharge })
      this.crossPrice = this.courierDetails.cross_price

    },
    onSubmitOriginAutocomp(item) {
      Object.keys(this.from).forEach(key => {
        if (item[key]) {
          this.from[key] = item[key]
        } else {
          this.from[key] = this.from[key]
        }
      })
    },
    async onSubmitRecipient(result) {
      this.to.name = result.name
      this.to.tel = result.tel
      this.to.address = result.address
      this.to.district = result.state
      this.to.state = result.district
      this.to.province = result.province
      this.to.postcode = result.postcode

      this.checkDestinationCourier()
      await this.callCheckProblemCategory()
    },
    addOrderInterParcel() {
      const parcel = this.interParcelService.data
      let formatAddtoCart = {
        key: "SPINTERPAECEL",
        check: this.count++,
        type: "service",
        trackingCode: parcel.trackingCode,
        num: 1,
        name: "shippop inter parcel",
        rate: parcel.amount,
        fee: parcel.fee,
        price: Number(parcel.amount) + Number(parcel.fee),
        weight: parcel.weight,
        from: parcel.fromName,
        to: parcel.toName,
        remark: parcel.remark
      }
      this.cart.push(formatAddtoCart)

      if (this.checkThemeQuick()) {
        this.setLocalStorageOrderCart(this.cart)
      }
    },
    addServiceNew() {
      let service = {
        type: "service",
        num: 1,
        name: this.tmpService.name,
        rate: this.tmpService.rate,
        fee: this.tmpService.fee,
        remark: this.tmpService.remark,
        price: Number(this.tmpService.rate) + Number(this.tmpService.fee),
        check: this.count++,
      }
      this.cart.push(service);
      if (this.checkThemeQuick()) {
        this.setLocalStorageOrderCart(this.cart)
      } else {
        this.addDraftStorage()
      }
    },
    addService() {
      let service = {
        type: "service",
        num: 1,
        name: this.fee.name,
        rate: this.fee.rate,
        fee: this.fee.fee,
        remark: this.fee.remark,
        price: Number(this.fee.rate) + Number(this.fee.fee),
        check: this.count++,
      }
      this.cart.push(service);
      if (this.checkThemeQuick()) {
        this.setLocalStorageOrderCart(this.cart)
      }
    },
    addZendai() {
      let zendai = {
        type: "zendai",
        num: 1,
        name: 'สินค้าร่วมสนับสนุนการทำงานของเส้นด้าย',
        rate: this.zendai.rate,
        fee: '0.00',
        price: Number(this.zendai.rate),
        check: this.count++,
      }
      this.cart.push(zendai);
      this.$refs.zendai.clearZendai()
    },
    confirmCreateKerryDropoff(kerryDropoff) {
      this.cart = this.cart.concat(kerryDropoff);
      this.$refs.kerryDropoff.kerryOrder = [];
      this.kerryDropoff.show = false
      this.kerryDropoff.trackingCode = '';
      this.kerryDropoff.errorMsg = '';

      if (this.checkThemeQuick()) {
        this.setLocalStorageOrderCart(this.cart)
        // setLocalStorage.batchNo().set( this.$refs.kerryDropoff.batchId );
      } else {
        this.addDraftStorage()
      }

      this.checkDisableCardCourier();
    },
    confirmCreateFlashDropoff(flashDropoff) {
      this.cart = this.cart.concat(flashDropoff)
      this.$refs.flashDropoff.flashOrder = []
      this.flashDropoff.show = false
      this.flashDropoff.trackingCode = ''
      this.flashDropoff.errorMsg = ''

      if (this.checkThemeQuick()) {
        this.setLocalStorageOrderCart(this.cart)
      } else {
        this.addDraftStorage()
      }

      this.checkDisableCardCourier()
    },
    confirmCreateLazadaDropoff(lazadaDropoff) {
      this.cart = this.cart.concat(lazadaDropoff)
      this.$refs.lazadaDropoff.lazadaOrder = [];
      this.lazadaDropoff.show = false
      this.lazadaDropoff.trackingCode = '';
      this.lazadaDropoff.errorMsg = '';

      // console.log('lazadaDropoff: ', lazadaDropoff)
      // console.log('before this.cart: ', this.cart)

      if (this.checkThemeQuick()) {
        this.setLocalStorageOrderCart(this.cart)
      } else {
        this.addDraftStorage()
      }

      this.checkDisableCardCourier();
      // console.log('after end this.cart: ', this.cart)

    },
    clearInsurance() {
      this.$refs.insurance.switchModal = 'select'
      this.insuranceService.show = false;
      this.insuranceService.insurance = null;
    },
    clearShabuEVoucher() {
      this.$refs.shabu.switchModal = 'select'
      this.shabuEVoucher.show = false;
      this.shabuEVoucher.shabu = null;
      this.shabuEVoucher.code = '';
    },
    addShabuEVoucher() {
      let shabuEVoucher = {
        type: "eVoucher",
        num: 1,
        name: this.shabuEVoucher.shabu.name,
        rate: this.shabuEVoucher.shabu.rate,
        fee: '0.00',
        price: Number(this.shabuEVoucher.shabu.rate),
        check: this.count++,
        barcode: this.shabuEVoucher.code
      }
      this.cart.push(shabuEVoucher);
      this.clearShabuEVoucher()
    },
    addInsurance() {
      let insurance = {
        type: "insurance",
        num: 1,
        name: this.insuranceService.insurance.name,
        rate: this.insuranceService.insurance.rate,
        fee: '0.00',
        price: Number(this.insuranceService.insurance.rate),
        check: this.count++,
      }
      this.cart.push(insurance);
      this.clearInsurance()
    },
    addDropoffShippopOrder() {
      this.cart.push(...this.dropoffShippopDetails.parcels)
      switchLockCourier(getTypeCart.TYPE_CART_DROPOFF_SHIPPOP, this.lockCardCourier)
    },
    addToCart(product) {
      const matchingProductIndex = this.cart.findIndex(item => {
        return item.id == product.id;
      });
      product.type = "item";
      if (matchingProductIndex > -1) {
        this.cart[matchingProductIndex].num++;
        this.cart[matchingProductIndex].qtytotal =
          this.cart[matchingProductIndex].num *
          this.cart[matchingProductIndex].price;
      } else {
        product.num = 1;
        product.qtytotal = product.price;
        product.check = this.count++;
        this.cart.push(product);
      }
      this.cart.sort((a, b) => {
        return a.id < b.id;
      });

      if (this.checkThemeQuick()) {
        this.setLocalStorageOrderCart(this.cart)
      } else {
        this.addDraftStorage()
      }
    },
    async cancelBeforeRemoveTotal(check, type = 'default') {
      if (this.checkThemeQuick()) {
        let indexOfCart = this.cart.findIndex(item => item.check == check);

        if (this.cart[indexOfCart].order_detail_id) {

          this.busy = true

          cancelOrderByOne(this.orderIdByOne, [this.cart[indexOfCart].order_detail_id]).then(results => {
            if (results.status) {
              const countListFail = results.data.list_fail.length
              this.busy = false

              if (countListFail < 1) {
                this.removeTotal(check, type)
                this.showSuccessModal("ลบรายการเสร็จเรียบร้อยแล้ว")
                return true;
              } else {
                this.showErrorModal(
                  `ไม่สามารถยกเลิกรายการได้ ${results.data.receipt_id}`
                )
                return false;
              }

            }
          })
        } else {
          this.removeTotal(check, type)
        }
      }
    },
    removeOrderInDraft() {
      const shopCode = this.$USER_LOGIN.get().details.shop_code
      const getCartToken = cartPos.cartToken().get()
      let getDraftAllOrder = cartPos.draftStorage().get()

      getDraftAllOrder[shopCode][getCartToken] = this.cart
      cartPos.draftStorage().add(getDraftAllOrder)
    },
    async removeTotal(check, type = 'default') {
      let indexOfCart = this.cart.findIndex(item => item.check == check);

      // KERRY DROPOFF V1

      //   if( this.filterCheckKerryDropoff ){
      //     await deleteShipment(
      //       this.$refs.kerryDropoff.batchId,
      //       this.cart[indexOfCart].dropoff_tracking_code,
      //       this.cart[indexOfCart].consignment_no_ref
      //     ).then(() => {

      //     }).catch(e => {
      //       this.showErrorModal( e );
      //     });
      //   }

      if (type == 'default') {

        this.cart.splice(indexOfCart, 1)

      } else {

        this.cart.splice(check, 1)
      }

      if (this.checkThemeQuick()) {
        this.setLocalStorageOrderCart(this.cart)
      }

      const checktype = this.cart.findIndex(ship => {
        return ship.type === "ship"
      })
      const checkcourier = this.cartShipping.findIndex(ship => {
        return ship.key !== "GEN"
      })
      const checkDropoffShippop = this.cartDropoffShippop.findIndex(ship => {
        return ship.type == DROPOFF_SP
      })
      if (checktype < 0 && checkDropoffShippop < 0 && checkcourier < 0) {
        switchLockCourier(getTypeCart.TYPE_CART_DEFAULT, this.lockCardCourier)
        this.orderIdByOne = ""
        this.reStartOrderByOne()
      }
      this.tempForVariableCheckOnActionDelete = check
      this.removeOrderInDraft()
    },
    setLocalStorageOrderCart(orderCart) {
      setLocalStorage.orderCart().set({ [this.$USER_LOGIN.get().details.shop_code]: orderCart });
    },
    async reStartOrderByOne() {
      if (this.checkThemeQuick()) {
        setLocalStorage.orderCart().remove();
        setLocalStorage.orderId().remove();
        setLocalStorage.batchNo().remove();
        setLocalStorage.sender().remove();
      }
      //KERRY DROPOFF V1

      //   if( this.filterCheckKerryDropoff && !this.idorder || this.$refs.kerryDropoff.batchId && !this.idorder ){
      //     await deleteBatch( this.$refs.kerryDropoff.batchId ).then(() => {
      //       this.$refs.kerryDropoff.batchId = "";
      //       if( this.filterCheckKerryDropoff ){
      //         this.reset();
      //       }
      //     }).catch(e => {
      //       this.showErrorModal( e );
      //     });
      //   }
      if (this.filterCheckKerryDropoff) {
        this.reset();
      }

    },
    reload(item) {
      this.cart.sort((a, b) => {
        return a.id < b.id;
      });
      item.qtytotal = item.price * item.num;
      if (!this.checkThemeQuick()) {
        this.addDraftStorage()
      }
    },
    scrollToError() {
      this.busy = false;
      if (this.currentError.$el) {
        this.currentError = this.currentError.$el
      }
      this.currentError.scrollIntoView({ behavior: "smooth", block: "center" })
    },
    async checkIdCard(event) {
      // console.log('event: ', event)
      this.busy = true
      this.$refs.modalSender.submitAddIdCard = true
      this.$refs.modalSender.$v.sender.$touch();
      if (this.$refs.modalSender.$v.sender.$invalid) {
        for (let k in this.$refs.modalSender.$v.sender.$params) {
          if (this.$refs.modalSender.$v.sender[k].$error) {
            this.currentError = this.$refs.modalSender.$refs['sender_' + k];
            this.scrollToError()
            return false;
          }
        }
      }
      if (
        this.sender.id_no.length == 13 &&
        /^([0-9]{1,})$/.test(this.sender.id_no)
      ) {
        let checkCardId = checkPersonID(this.sender.id_no);
        this.errorIdCard = false;
        if (!checkCardId) {
          this.errorIdCard = true;
          this.currentError = this.$refs.modalSender.$refs.sender_id_no
          this.scrollToError()
          return false;
        }
      }
      if (this.sender.birthday) {
        this.errorBirthday = false;
        let date = this.sender.birthday.split("/");

        if (date.length < 3) {
          this.errorBirthday = true
          this.currentError = this.$refs.modalSender.$refs.sender_birthday
          this.scrollToError()
          return false
        }

        let day = date[0];
        let month = date[1];
        let year = date[2] - 543

        if (isNaN(day) || isNaN(month) || isNaN(year)) {
          this.errorBirthday = true
          this.currentError = this.$refs.modalSender.$refs.sender_birthday
          this.scrollToError()
          return false
        }

        const ceFormatYear = day + '-' + month + '-' + year

        if (moment(ceFormatYear, 'DD-MM-YYYY').isValid() == false) {
          this.errorBirthday = true
          this.currentError = this.$refs.modalSender.$refs.sender_birthday
          this.scrollToError()
          return false;
        }

        let age = moment().format('YYYY') - year

        if (age >= 100 || age < 0) {
          this.errorBirthday = true
          this.currentError = this.$refs.modalSender.$refs.sender_birthday
          this.scrollToError()
          return false
        }

        if (day.length < 2 && month.length < 2) {
          day = "0" + date[0];
          month = "0" + date[1];
        } else if (day.length < 2) {
          day = "0" + date[0];
        } else if (month.length < 2) {
          month = "0" + date[1];
        }

        this.sender.birthday = year + "-" + month + "-" + day;

        // await this.checkVerifyMemberCod();

        // if( event == 'prebarcode'){
        //   this.$refs[this.modalprebarcode].show()
        // }else if( event == DROPOFF_SP ){
        //   this.dropoffShippopDetails.isShow = true
        // } else if (event == 'INTER_PARCEL') {
        //   this.interParcelService.isShow = true
        // }else if( this.cod_details.isCod && this.lockCod == 'lock' ){
        //   this.cod_details.isCod =  false
        //   this.showErrorModal( 'กรุณาสมัครสมาชิก COD ที่หน้าจัดการลูกค้า ***แต่ยังสามารถสร้างรายการที่ไม่ใช่ COD ได้ตามปกติ***' , 'Done')
        // }else{
        //   if (this.sender.name != '') {
        //     this.from.name = this.sender.name
        //     this.from.address = this.sender.address
        //     this.from.state = this.sender.state
        //     this.from.district = this.sender.district
        //     this.from.province = this.sender.province
        //     this.from.postcode = this.sender.postcode
        //     this.from.tel =  this.sender.tel
        //     this.titleName = "ที่อยู่ตามบัตรประชาชน"
        //   }
        //   this.$refs[this.modalparcel].show()
        // }
      }
      await this.checkVerifyMemberCod();
      if (event == 'prebarcode') {
        this.$refs[this.modalprebarcode].show()
      } else if (event == DROPOFF_SP) {
        this.dropoffShippopDetails.isShow = true
      } else if (event == 'INTER_PARCEL') {
        this.interParcelService.isShow = true
      } else if (this.cod_details.isCod && this.lockCardCourier.cod) {
        this.cod_details.isCod = false
        this.showErrorModal('กรุณาสมัครสมาชิก COD ที่หน้าจัดการลูกค้า ***แต่ยังสามารถสร้างรายการที่ไม่ใช่ COD ได้ตามปกติ***', 'Done')
      } else {
        if (this.sender.name != '') {
          this.from.name = this.sender.name
          this.from.address = this.sender.address
          this.from.state = this.sender.state
          this.from.district = this.sender.district
          this.from.province = this.sender.province
          this.from.postcode = this.sender.postcode
          this.from.tel = this.sender.tel
          this.titleName = "ที่อยู่ตามบัตรประชาชน"
        }

        if (event == KERRY_DROPOFF || event == ORANGE_DROPOFF) {
          this.selectedCourier = { key: (event == KERRY_DROPOFF) ? "KRYDS" : "ORNGDS" }
          this.kerryDropoff.code = (event == KERRY_DROPOFF) ? "KRYDS" : "ORNGDS";
          this.kerryDropoff.show = true
        } else if (event === 'LINE_BOOKING') {
          this.$refs.tabCourier.changeStepTabCourier(getStepPage.STEP_LINEBOOKING);
          this.showCart = 'slide'
          this.$refs.modalSender.$refs['modal-idcard'].hide()
        } else if (event === 'INTER_BOOK') {
          this.selectedCourier = { key: "INT" }
          this.basefillupSetting.typeFillup = 'ENGLISH'
          this.basefillupSetting.mutedText = "(กรอกเป็นภาษาอังกฤษเท่านั้น)"
          this.posPage.step = getStepPage.STEP_FULL_FILLUP
          this.$refs.modalSender.$refs['modal-idcard'].hide()
        } else if (event === 'LAO_BOOK') {
          this.basefillupSetting.typeFillup = 'THAI'
          this.basefillupSetting.mutedText = "(กรอกเป็นภาษาไทยเท่านั้น)"
          this.selectedCourier = { key: "LAO" }
          this.posPage.step = getStepPage.STEP_FULL_FILLUP
          this.$refs.modalSender.$refs['modal-idcard'].hide()
        } else if (event === LAZADA_DROPOFF) {
          this.$refs.modalSender.$refs['modal-idcard'].hide()
          this.selectedCourier = { key: (event == LAZADA_DROPOFF) ? "LZDS" : "" }
          this.lazadaDropoff.show = true
        } else if (event === FLASH_DROPOFF) {
          this.selectedCourier = { key: "FLEDS" }
          this.flashDropoff.code = "FLEDS"
          this.flashDropoff.show = true
        } else {
          this.setAction(ACTION_CREATE_ORDER.modalParcel);
          this.$refs[this.modalparcel].show()
        }

      }
      if (!this.checkThemeQuick()) {
        this.addSenderToLocalStorage()
      }
      this.lockCardCourier.cod = false
    },
    async checkVerifyMemberCod() {
      let checkCod = true
      this.isLoadingCheckCod = true

      await checkMemberCod(this.sender.tel, this.sender.id_no).then(res => {
        this.busy = false
        if (!res.status) {
          this.sender.identity = false
        }
        if (res.status === 'is member') {
          this.sender.identity = true
          this.sender.mem_id = res.mem_id
          this.memberService.memberServiceId = res.member_service_id
          this.memberService.codAgreementUrl = res.cod_agreement_url
          this.memberService.isAcceptedCodAgreement = res.is_accepted_cod_agreement
          this.memberService.memberServiceToken = res.member_service_token
        } else {
          this.sender.identity = false
        }

        this.isLoadingCheckCod = false

        //setLocalStorage For Sender
        if (this.checkThemeQuick()) {
          setLocalStorage.sender().set(this.sender)
        }


        if (!this.sender.identity
          || (this.cod_details.isCod && !this.sender.identity)
        ) {
          this.lockCardCourier.cod = true;
        } else {
          this.lockCardCourier.cod = false
        }

      }).catch(() => {
        checkCod = false
        this.busy = false
        this.lockCardCourier.cod = true;
        this.showErrorModal('ไม่สามารถยืนยัน COD ได้กรุณาติดต่อเจ้าหน้าที่ ***แต่ยังสามารถสร้างรายการที่ไม่ใช่ COD ได้ตามปกติ***', 'Done')
      })

      if (!checkCod) {
        this.cod_details.isCod = false
        return false
      }
    },
    handleModalCreateOrder(typeCourier) {

      this.setDimension();

      if (typeCourier) {
        this.setAction(ACTION_CREATE_ORDER.modalPrebarcode)
        this.$refs[this.modalprebarcode].show()
      } else {
        this.setAction(ACTION_CREATE_ORDER.modalParcel)
        this.$refs[this.modalparcel].show()
      }
    },
    async editInterSetUp(item, check) {
      this.editInter.status = true
      this.editInter.check = check
      this.editInter.item = item
      // this.$refs.basefillupRef.setUpEdit()
      this.posPage.step = getStepPage.STEP_FULL_FILLUP
    },
    async editParcel(check) {
      let detail
      let id = check
      if (Array.isArray(check)) {
        id = check[0].check
        detail = check.filter(item => {
          return item.check === id
        })
      } else {
        this.editOrdersAll = true
        detail = await this.cartShipping.filter(item => {
          return item.check === check
        })
      }
      // console.log('details: ', detail)

      if (detail[0].dropoff_type === 'INTER_BOOK') {
        await this.$nextTick(async () => {
          // มั่นใจได้เลยว่า key คือ INT เชื่อตอนสร้างรายการตอนแรกเสมอ (แสดงว่า key จะไม่ถูกเปลี่ยนแน่นวล ถ้าเปลี่ยน ก็มาจาก ตอนกดสร้าง ชัวว)
          this.selectedCourier = { key: "INT" }
          // จริงๆ english อันนี้ควรผูกเข้ากับ courier file นะแต่ ไว้ค่อยละกัน
          this.basefillupSetting.typeFillup = 'ENGLISH'
          this.basefillupSetting.mutedText = "(กรอกเป็นภาษาอังกฤษเท่านั้น)"
          // console.log('this.selectCourier: ', this.selectedCourier)

        })
        this.editInterSetUp(detail[0], check)
        // return แค่ให้มันออกเฉยๆ ได้ไม่ต้อง มีปัญหาอะไร กับข้างล่าง เดะมีปัญหา
        return false
      }

      if (detail[0].dropoff_type === 'LAO_BOOK') {
        await this.$nextTick(async () => {
          this.selectedCourier = { key: "LAO" }
          this.basefillupSetting.typeFillup = 'THAI'
          this.basefillupSetting.mutedText = "(กรอกเป็นภาษาไทยเท่านั้น)"
        })
        this.editInterSetUp(detail[0], check)
        return false
      }

      // if(detail)
      await this.getIcon(detail[0].courier).then(res => {
        this.iconUrl = res
      })
      if (detail[0].cod_amount || detail[0].cod_amount === null) {
        this.cod_details.isCod = true
      }
      this.selectModalEdit(detail[0].courier.prebarcode)
      await this.$nextTick(async () => {
        this.draftSpecialCode = detail[0].special_code
        this.from.name = detail[0].from.name
        this.from.address = detail[0].from.address
        this.from.state = detail[0].from.state
        this.from.district = detail[0].from.district
        this.from.province = detail[0].from.province
        this.from.postcode = detail[0].from.postcode
        this.from.tel = detail[0].from.tel
        this.titleName = "ที่อยู่ตามบัตรประชาชน"
        this.codAmount = detail[0].cod_amount
        this.codProducts = detail[0].cod_products
        this.pickup_type = detail[0].pickup_type
        this.selectedCourier = detail[0].courier;
        if (detail[0].booking_item_id) { // line booking
          this.bookingItemId = detail[0].booking_item_id;
        }

        let loadCourier = this.couriers.find(keyCourier => keyCourier.id === detail[0].refer_id)
        // console.log('loadCourier: ', loadCourier)
        this.selectedCourier.rates = await groupBy(loadCourier.rates, "type")

        this.to.name = detail[0].to.name;
        this.to.tel = detail[0].to.tel;
        this.to.address = detail[0].to.address;
        this.to.district = detail[0].to.state;
        this.to.state = detail[0].to.district;
        this.to.province = detail[0].to.province;
        this.to.postcode = detail[0].to.postcode;
        this.weight = detail[0].parcel.weight;
        this.weightKG = detail[0].parcel.weightKG;
        this.width = detail[0].parcel.width;
        this.length = detail[0].parcel.length;
        this.height = detail[0].parcel.height;
        this.scanBarcode = detail[0].pre_barcode;
        this.editorder = id
        this.prerate = detail[0].price;
        this.walletPrerate = detail[0].rate;
        console.log('🍋🍋🍋🍋🍋')
        this.type = detail[0].ratetype;
        this.tracking = detail[0].pre_tracking;
        this.remarkOrderDetail = detail[0].remarkOrderDetail
        this.size.boxSize = detail[0].parcel.key_size
        this.keyBox = detail[0].parcel.key_size
        detail[0].from.addressType ? this.isToggle = true : this.isToggle = false
        this.setValueInsuranceFromEdit(detail[0].insurance)

        if (this.cod_details.isCod) {
          this.checkCodProduct()
        }
      })

      await this.itemPreRate()
      this.callCheckProblemCategory()
      // if(!this.checkThemeQuick()) {
      //   this.addDraftStorage()
      //   console.log('doing right now')
      // }
    },
    setValueInsuranceFromEdit(value) {
      this.insurance = JSON.parse(JSON.stringify(value))
    },
    clearNotificationArea() {
      this.remote_area.rate = 0;
      this.remote_area.travel_surcharge = 0;
      this.remote_area.island_surcharge = 0;
    },
    clearInputInsurance() {
      this.insurance.id = 0
      this.insurance.declared_value = ""
      this.insurance.category = ""
      this.insurance.isCheck = false
      this.insurance.remark = ""
      for (const key in this.insurance.listPrice) {
        this.insurance.listPrice[key] = 0
      }
      return this.insurance

    },
    selectModalEdit(prebarcode) {
      return new Promise((resolve) => {
        if (prebarcode == 1) {
          this.setAction(ACTION_CREATE_ORDER.modalPrebarcode)
          this.$refs[this.modalprebarcode].show()
        } else {
          this.setAction(ACTION_CREATE_ORDER.modalParcel)
          this.$refs[this.modalparcel].show()
        }
        resolve(true)
      })
    },
    async beforeGetShop() {
      let courierPostcodeDetails = JSON.parse(localStorage.getItem('courier_postcode'))
      // console.log(courierPostcodeDetails)
      let cpd = 0
      if (courierPostcodeDetails) {
        cpd = courierPostcodeDetails.version
      } else {
        cpd = 0
      }
      getSizeBox().then(resSize => {
        this.listSize.defaultSize = resSize.default.size
        this.listSize.KRYSSize = resSize.kerry.size
        this.listSize.SCGSize = resSize.scg.size
        this.sizeCheckPrice.KRYSSize = [...resSize.kerry.size]
        this.sizeCheckPrice.SCGSize = [...resSize.scg.size]
      });
      await this.getShop(cpd)
    },
    setCourierPostcodeDetails(cpd) {
      if (cpd['msg'] == 'get latest version') {
        localStorage.setItem('courier_postcode', JSON.stringify(cpd.data))
      }
      this.listPostcodeSpecial = JSON.parse(localStorage.getItem('courier_postcode'))
    },
    isExpired(expired_date) {
      // check courier dropoff expired
      if (expired_date == null) return false;
      return moment().valueOf() > moment(expired_date).valueOf();
    },
    async getShop(cpd) {
      this.busy = true
      await this.$http
        .get(API_URL + `/shop/${cpd}`, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          let _res = res.data.data
          res.data.data.items.sort((a, b) => {
            return a.pointer_item - b.pointer_item;
          })
          this.setCourierPostcodeDetails(_res.courier_postcode_details)
          // console.log('获取快递公司列表1',_res.couriers)
          this.couriers = _res.couriers;
          // save thaipost
          this.thaipostData = _res.couriers.filter(item => item.key == 'EMST')
          // console.log(this.thaipostData)
          sessionStorage.setItem('rates_backup', JSON.stringify(_res.couriers));
          this.couriers.sort(function (a, b) {
            return new Date(b.favorites_at) - new Date(a.favorites_at);
          });
          if (_res.ref_member_id)
            this.refMemberId = _res.ref_member_id.toString();
          if (this.$THEME.serviceName && this.$THEME.serviceName.kerry_quick) {
            let courierCodeKRYQ = this.couriers.filter(courier => courier.key == "KRYQ" && !this.isExpired(courier.expired_date));
            if (this.checkThemeQuick() && courierCodeKRYQ.length > 0) {
              this.courierDropoffVRich = courierCodeKRYQ[0];
              this.courierDropoffEasyShip = courierCodeKRYQ[0];
              this.courierDropoffQuick = courierCodeKRYQ[0];
              this.dropoffPanPan.courier = courierCodeKRYQ[0];
              this.permission.dropoffQuick = true;
            }
          }

          if (this.$THEME.serviceName && this.$THEME.serviceName.kerry_orange) {
            let courierCodeORNG = this.couriers.filter(courier => courier.key == "ORNG" && !this.isExpired(courier.expired_date));
            if (courierCodeORNG.length > 0) {
              this.courierDropoffEasyShip = courierCodeORNG[0];
            }
          }

          if (this.$THEME.serviceName && this.$THEME.serviceName.kerry) {
            let courierCodeKRYS = this.couriers.filter(courier => courier.key == "KRYS" && !this.isExpired(courier.expired_date));
            if (courierCodeKRYS.length > 0) {
              this.courierDropoffEasyShip = courierCodeKRYS[0];
            }
          }


          // this.from.address = _res.address;
          // this.from.district = _res.district;
          // this.from.name = _res.name;
          // this.from.postcode = _res.postcode;
          // this.from.province = _res.province;
          // this.from.state = _res.state;
          // this.from.tel = _res.tel;
          this.sameData = { name: _res.name, address: _res.address, district: _res.district, state: _res.state, province: _res.province, postcode: _res.postcode, tel: _res.tel }
          this.label = _res.default_label_size;
          this.cod = _res.allow_cod;
          this.shop_id = _res.id;
          this.courier_allow = _res.courier_allow
          this.shubuVoucherAllow = _res.shabu_voucher_allow
          // console.log('res on demand: ', _res)
          this.shopDetail = {
            tel: _res.tel,
            name: _res.name,
            owner_name: _res.owner_name,
            postcode: _res.postcode,
            province: _res.province,
            state: _res.state,
            district: _res.district
          };
          this.permission.dropoffShippop = _res.setting.allow_dropoff_shippop
          this.permission.interParcelService = _res.setting.allow_inter_parcel_service
          this.permission.dropoffVRich = this.$THEME.dropoffVRich;
          this.permission.dropoffPanPan = this.$THEME.dropoffPanPan ? true : (_res.setting.dropoff.hasOwnProperty('PANPAN_DROPOFF')) ? _res.setting.dropoff.PANPAN_DROPOFF.status : false;
          this.checkPermissionDropoffEasyShip()
          this.permission.lazadaDropoff = _res.setting.dropoff.LZDS.status
          this.permission.kerryDropoff = this.$THEME.dropoffKerry ? true : (_res.setting.dropoff.hasOwnProperty('KERRY_DROPOFF')) ? _res.setting.dropoff.KERRY_DROPOFF.status : false;
          this.permission.orangeDropoff = this.$THEME.dropoffOrange ? true : (_res.setting.dropoff.hasOwnProperty('ORANGE_DROPOFF')) ? _res.setting.dropoff.ORANGE_DROPOFF.status : false;
          this.permission.lineBooking = this.$THEME.name === 'shippop' ? true : false;
          this.permission.flashDropoff = _res.setting.dropoff.FLEDS.status ? _res.setting.dropoff.FLEDS.status : false
          this.shop_setting = _res.setting
          this.insurance.listRates = _res.insurance
        })
        .catch((err) => {
          // console.log('#010', err);
          this.showErrorModal(
            " พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #010 "
          );
        }).finally(() => {
          this.busy = false
        });
    },
    checkPermissionDropoffEasyShip() {
      if (
        this.$THEME.dropoffEasyShip
      ) {
        if (this.courierDropoffEasyShip.key && ['KRYS', 'KRYQ', 'ORNG'].includes(this.courierDropoffEasyShip.key)) {
          this.permission.dropoffEasyShip = true
        } else {
          this.permission.dropoffEasyShip = false
        }
      } else {
        this.permission.dropoffEasyShip = false
      }
      return this.permission.dropoffEasyShip
    },
    showCourier(courier) {
      const effect = this.checkEffectiveDate(courier.effective_date)
      const expired = this.checkExpiredDate(courier.expired_date)
      return expired && effect
    },
    checkExpiredDate(expired) {
      if (expired === null) return true
      if (expired <= this.dateNow) return false
      return true
    },
    checkEffectiveDate(effect) {
      if (effect === null) return true
      if (effect > this.dateNow) return false
      return true

    },
    courierModalTime(courier, prebarcode) {
      if (courier.expired_date != null) {
        this.expired_date = courier.expired_date.toString();
        this.dateNow = moment().valueOf()
        if (this.dateNow <= moment(courier.expired_date).valueOf()) {
          if (!getCookie('courier_change_rate') && moment().add(7, 'day').valueOf() >= moment(courier.expired_date).valueOf()) {
            setCookie('courier_change_rate', 1, '1hr')
            this.courierTime.show = true;
          }
          this.openModal(courier, prebarcode);
        } else {
          alert('ราคามีการเปลี่ยนแปลงกรุณาเลือกขนส่งอื่น');
        }
      } else {
        this.openModal(courier, prebarcode);
      }
    },
    closeModalCourierTime() {
      this.courierTime.show = false
    },
    sendErrorToLine(res) {
      this.$http.post(API_URL + "/lineNotify/error", {
        error: res
      },
        {
          headers: {
            "Content-Type": "application/json",
            Token: localStorage.getItem("access_token")
          }
        })
    },
    buyTotal() {
      if (this.sendCheck > 0) {
        return false
      }
      this.sendCheck = 1
      this.busy = true
      const order = []
      let copyCard = JSON.parse(JSON.stringify(this.cart))
      copyCard.forEach(item => {
        if (item.courier) {
          delete item.courier
        }
        if (item.type == "item") {
          item.refer_id = item.id;
        }
        order.push(item)
      })
      this.checkBill.show = false
      let URL = '/v2/order'
      if (this.checkThemeQuick()
        && !this.filterCheckDropoffVRich
        && !this.filterCheckDropoffPanPan
        && !this.filterCheckKerryDropoff
        && !this.filterCheckFlashDropoff
        && !this.filterCheckLazadaDropoff
        && !this.filterCheckDropoffQuick
        && !this.filterOrderIsPrebarcode
      ) {
        URL = '/create-receipt'
      }
      this.$http
        .post(
          API_URL + URL,
          {
            ...((this.orderIdByOne) ? { order_id: this.orderIdByOne } : {}),
            ...((this.filterCheckDropoffVRich) ? {
              dropoff_type: "VRICH_DROPOFF",
              purchase_id: this.dropoffVRich.purchaseId
            } : {}),
            ...((this.filterCheckDropoffPanPan) ? {
              dropoff_type: "PANPAN_DROPOFF",
              purchase_id: this.dropoffPanPan.purchaseId
            } : {}),
            ...((this.filterCheckDropoffQuick) ? {
              dropoff_type: "QUICK_DROPOFF",
              purchase_id: this.dropoffQuick.purchaseId
            } : {}),
            ...((this.filterCheckKerryDropoff) ? {
              dropoff_type: (this.filterCheckKerryDropoff) ? "KERRY_DROPOFF" : "ORANGE_DROPOFF",
              //   batch_no: this.$refs.kerryDropoff.batchId,
              total_package: this.cartShipping.length,
            } : {}),
            ...((this.filterCheckFlashDropoff) ? {
              dropoff_type: "FLASH_DROPOFF",
              total_package: this.cartShipping.length
            } : {}),
            ...((this.filterCheckLazadaDropoff) ? {
              dropoff_type: "LAZADA_DROPOFF",
              total_package: this.cartShipping.length,
            } : {}),
            ...((this.filterCheckEasyShip) ? {
              dropoff_type: "EASYSHIP_DROPOFF",
            } : {}),
            ...((this.filterCheckDropoffLine) ? {
              dropoff_type: "LINE_BOOKING_DROPOFF",
              line_booking_id: this.dropoffLine.bookingId,
              type_checkbill: this.typeMoneyCheckBill
            } : {}),
            ...((this.filterCheckDropoffINTER) ? {
              dropoff_type: "INTER_BOOK",
            } : {}),
            ...((this.filterCheckDropoffLAO) ? {
              dropoff_type: "LAO_BOOK",
            } : {}),
            orders: order,
            cash: this.checkBill.receiveMoney,
            discount: this.checkBill.discountAmount,
            sender: {
              id_no: this.sender.id_no,
              name: this.sender.name,
              birthday: this.sender.birthday,
              tel: this.sender.tel,
              address: this.sender.address,
              state: this.sender.state,
              district: this.sender.district,
              province: this.sender.province,
              postcode: this.sender.postcode,
              customer_type: this.sender.customer_type,
              tax: this.sender.tax,
              mem_id: this.sender.mem_id
            }
          },
          {
            headers: {
              "Content-Type": "application/json",
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          this.recheckCutOrderDraft = true
          let checkError = validatePop(res)
          // console.log('validate pop', checkError)
          if (!checkError.status) {
            if (!censorCodeBuyTotal.includes(res.data.error.code)) {
              this.sendErrorToLine(res)
            }
            this.busy = false

            if (typeof checkError.data != 'undefined' && checkError.data != null) {

              this.setErrorAfterCreateOrder(checkError.data)

            }

            this.showErrorModal(checkError.msg)
            this.sendCheck = 0
            // this.idorder = "0";
            return false

          }
          // console.log('checkError', checkError)
          this.busy = false;
          this.idorder = res.data.data.order.id;
          this.labeltype = res.data.data.order.ship_price;
          if (!this.checkThemeQuick()) {
            this.checkOutOrderProduct();
          }
          printReceipt(res.data.data.receiptHTML);
          this.shippop = res.data.data.order.shippop;
          this.sendCheck = 1

          if (!this.checkThemeQuick()) {
            this.labeltypeDropoff = res.data.data.order.hasDropoffShippop
            this.typeOfLabel = this.labeltypeDropoff ? DROPOFF_SP : 'default'
            if (res.data.data.order.hasDropoffINTER) {
              this.labeltypeDropoff = res.data.data.order.hasDropoffINTER
              this.typeOfLabel = this.labeltypeDropoff ? 'INTER_AND_LAO_BOOK' : ''
            }
            this.$WALLET.available_balance = res.data.data.wallet_info.available_balance
            this.$WALLET.balance = res.data.data.wallet_info.balance
            this.$WALLET.peg_balance = res.data.data.wallet_info.peg_balance
          }

          this.showSuccessModal("ทำรายการเสร็จเรียบร้อยค่ะ กรุณาเปิดบิลใหม่");
          this.reStartOrderByOne();
        })
        .catch((err) => {
          this.busy = false;
          this.idorder = "0"
          this.sendErrorToLine(err)
          this.showErrorModal(
            " พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #011 "
          )
        })
    },
    setErrorAfterCreateOrder(data) {
      data.forEach((value) => {

        const i = value.indexOfParcel
        let msg = value.msg
        this.cart[i].error.status = true
        this.cart[i].error.msg = msg

      })

    },
    async getIcon(courier) {
      let icon = {};
      if (!courier.icon) {
        icon = { status: false, courierName: courier.name, url: null };
      } else {
        let url = "/img/brand/load-error.svg"
        let nameIcon = courier.icon

        if (this.$THEME.name == 'poststation') {
          if (nameIcon == 'EMSXP.png') {
            nameIcon = 'THP.png'
          } else if (nameIcon == 'PRE_EMSXP.png') {
            nameIcon = 'PRE_THP.png'
          }
        }

        const storageRef = this.$firebase.storage().ref(`/icon/${nameIcon}`).getDownloadURL()
        storageRef.then(res => {

          url = res
          this.iconUrl.url = res

        }).catch(() => {
          url = "/img/brand/load-error.svg"
          if ('icon-inter-parcel.png' == nameIcon) {
            url = "/img/brand/load-error.svg"
            this.iconUrl.url = "/img/brand/load-error.svg"
          } else if (['scg-cool.png'].includes(nameIcon)) {
            url = "/img/courier_icons/SCGC.png"
            this.iconUrl.url = "/img/courier_icons/SCGC.png"
          } else if (['scg-frozen.png'].includes(nameIcon)) {
            url = "/img/courier_icons/SCGF.png"
            this.iconUrl.url = "/img/courier_icons/SCGF.png"
          } else if (['scg-express-yamato.png'].includes(nameIcon)) {
            url = "/img/courier_icons/SCG.png"
            this.iconUrl.url = "/img/courier_icons/SCG.png"
          } else if (['fle_nodimension.jpg'].includes(nameIcon)) {
            url = "/img/courier_icons/FLE.png"
            this.iconUrl.url = "/img/courier_icons/FLE.png"
          } else {
            url = "/img/courier_icons/" + nameIcon
            this.iconUrl.url = "/img/courier_icons/" + nameIcon
          }
        })
        icon = { status: true, courierName: courier.name, url: url }
      }

      return icon;
    },
    async openModal(courier, preBarcode) {
      // 打开寄件人或者收件信息弹窗
      // console.log(courier, preBarcode)
      this.busy = true
      if (this.sender.name != '') {
        this.from.name = this.sender.name
        this.from.address = this.sender.address
        this.from.state = this.sender.state
        this.from.district = this.sender.district
        this.from.province = this.sender.province
        this.from.postcode = this.sender.postcode
        this.from.tel = this.sender.tel
        this.titleName = "ที่อยู่ตามบัตรประชาชน"
      }

      if (courier === 'COD') {
        this.cod_details.isShow = true
        this.cod_details.couriers = this.couriers.filter((courier) => {
          return this.showCourier(courier);
        });

      } else if (courier === DROPOFF_SP) {

        this.preBarcode = DROPOFF_SP

        if (this.sender.name == "") {

          this.$refs.modalSender.$refs['modal-idcard'].show()

        } else {

          this.dropoffShippopDetails.isShow = true

        }

      } else if (courier == 'INTER_PARCEL') {
        this.preBarcode = 'INTER_PARCEL'
        if (this.sender.name == "") {

          this.$refs.modalSender.$refs['modal-idcard'].show()

        } else {
          this.interParcelService.isShow = true
        }
      } else if (courier === KERRY_DROPOFF || courier === ORANGE_DROPOFF) {

        this.preBarcode = (courier === KERRY_DROPOFF) ? KERRY_DROPOFF : ORANGE_DROPOFF
        this.selectedCourier = { key: (courier == KERRY_DROPOFF) ? "KRYDS" : "ORNGDS" }
        this.kerryDropoff.code = (courier == KERRY_DROPOFF) ? "KRYDS" : "ORNGDS";

        if (this.sender.name == "") {
          this.$refs.modalSender.$refs['modal-idcard'].show()
        } else {
          this.kerryDropoff.show = true
        }

        this.setDimension();

      } else if (courier === LAZADA_DROPOFF) {
        this.preBarcode = (courier === LAZADA_DROPOFF) ? LAZADA_DROPOFF : ''
        this.selectedCourier = { key: (courier == LAZADA_DROPOFF) ? "LZDS" : '' }
        this.lazadaDropoff.code = (courier == LAZADA_DROPOFF) ? "LZDS" : '';

        if (this.sender.name == "") {
          this.$refs.modalSender.$refs['modal-idcard'].show()
        } else {
          this.lazadaDropoff.show = true
        }

      } else if (courier === "LINE_BOOKING") {
        this.preBarcode = "LINE_BOOKING"
        if (this.sender.name == "") {
          this.$refs.modalSender.$refs['modal-idcard'].show()
        } else {
          this.$refs.tabCourier.changeStepTabCourier(getStepPage.STEP_LINEBOOKING);
          this.showCart = 'slide'
        }
      } else if (courier === "INTER_BOOK") {
        await this.hasErrorRefMemId(true)
        if (!this.lockCardCourier.dropoffINTER) {
          this.preBarcode = "INTER_BOOK"
          if (this.sender.name == "") {
            this.$refs.modalSender.$refs['modal-idcard'].show()
          } else {
            this.selectedCourier = { key: "INT" }
            this.basefillupSetting.typeFillup = 'ENGLISH'
            this.basefillupSetting.mutedText = "(กรอกเป็นภาษาอังกฤษเท่านั้น)"
            this.posPage.step = getStepPage.STEP_FULL_FILLUP
          }
        }
      } else if (courier === "LAO_BOOK") {
        await this.hasErrorRefMemId(true)
        if (!this.lockCardCourier.dropoffLAO) {
          this.preBarcode = "LAO_BOOK"
          if (this.sender.name == "") {
            this.$refs.modalSender.$refs['modal-idcard'].show()
          } else {
            this.selectedCourier = { key: "LAO" }
            this.basefillupSetting.typeFillup = 'THAI'
            this.basefillupSetting.mutedText = "(กรอกเป็นภาษาไทยเท่านั้น)"
            this.posPage.step = getStepPage.STEP_FULL_FILLUP
          }
        }
      } else if (courier === FLASH_DROPOFF) {
        this.preBarcode = FLASH_DROPOFF
        this.selectedCourier = { key: "FLEDS" }
        this.flashDropoff.code = "FLEDS"

        this.showNotiModal(
          courierRules.FLEDS.alertText.text,
          undefined,
          undefined,
          true
        )

        if (this.sender.name == "") {
          this.$refs.modalSender.$refs['modal-idcard'].show()
        } else {
          this.flashDropoff.show = true
        }

        this.setDimension()
      } else {
        if (courierRules.alertBeforeCreateOrderCouriers.includes(courier.key) && !getCookie(`banner_courier_${courier.key}`) && courierRules[courier.key].banner) {
          // console.log(courierRules[courier.key].banner)
          await getBanner(courierRules[courier.key].banner.code).then(res => {
            this.bannerCourier.campaigns = res.campaigns
            this.bannerCourier.size.width = res.size.width
            this.bannerCourier.size.height = res.size.height
            this.bannerCourier.courierCode = courier.key;
            this.bannerCourier.show = true
          }).catch(error => {
            if (error) {
              if (courier.key == "TPSD") {
                this.courierTeleport.show = true
              } else {
                let style = courier.key === "DHL" ? { text: 'text-left' } : {}
                this.showNotiModal(
                  courierRules[courier.key].alertText.text,
                  courierRules[courier.key].alertText.emphasize,
                  style
                )
              }
            }
          })
        }

        if (!this.checkWorkingHours(courier.key)) {
          this.busy = false
          return false
        }

        this.preBarcode = preBarcode;
        this.modalOrders(courier, preBarcode)
      }
      this.busy = false
    },
    betweenHour(hour, start = 0, end = 24) {
      if (hour >= start && hour < end) {
        return true
      } else {
        return false
      }
    },
    checkWorkingHours(courierKey) { // return available status
      if (!courierRules[courierKey])
        return true
      if (!courierRules[courierKey].workingHours)
        return true;
      // for courier working hours
      const now = moment()
      const weekDay = now.day()
      const hour = now.format('HH')
      if (!courierRules[courierKey].workingHours[weekDay]) // วันที่ true คือเปิด ไม่ true คือปิด return false
        return false
      if (courierRules[courierKey].workingHours[weekDay] == 'all')
        return true
      let start = courierRules[courierKey].workingHours[weekDay].start
        ? courierRules[courierKey].workingHours[weekDay].start.hour
        : undefined
      let end = courierRules[courierKey].workingHours[weekDay].end
        ? courierRules[courierKey].workingHours[weekDay].end.hour
        : undefined
      return this.betweenHour(hour, start, end)
    },
    async courierCheckPrice(courier) {
      this.busy = true;
      // console.log('courier: ', courier)
      if (courier.courier_code === "INT") {
        this.selectedCourier = { key: "INT" }
        this.basefillupSetting.typeFillup = 'ENGLISH'
        this.basefillupSetting.mutedText = "(กรอกเป็นภาษาอังกฤษเท่านั้น)"
        if (this.sender.name !== "") {
          this.posPage.step = getStepPage.STEP_FULL_FILLUP
        } else {
          this.posPage.step = getStepPage.STEP_PAGE_FIRST
          this.busy = false
          this.tmpCheckPrice.isCheckPrice = true;
          setTimeout(() => {
            this.courierModalTime("INTER_BOOK");
          }, 600);
        }
        return false
      } else if (courier.courier_code === "LAO") {
        this.basefillupSetting.typeFillup = 'THAI'
        this.basefillupSetting.mutedText = "(กรอกเป็นภาษาไทยเท่านั้น)"
        this.selectedCourier = { key: "LAO" }
        if (this.sender.name !== "") {
          this.posPage.step = getStepPage.STEP_FULL_FILLUP
        } else {
          this.posPage.step = getStepPage.STEP_PAGE_FIRST
          this.busy = false
          this.tmpCheckPrice.isCheckPrice = true;
          setTimeout(() => {
            this.courierModalTime("LAO_BOOK");
          }, 600);
        }
        return false
      }
      let i = this.couriers.findIndex(item => {
        return item.id == courier.courier_id
      });

      if (i > -1) {
        this.posPage.step = getStepPage.STEP_PAGE_FIRST;
        this.tmpCheckPrice.isCheckPrice = true;
        setTimeout(() => {
          this.courierModalTime(this.couriers[i]);
        }, 500);
      }
      this.busy = false;
    },
    setDefaultDataSelectedCourier() {
      this.$nextTick(() => {
        this.weight = this.tmpCheckPrice.weight
        this.width = this.tmpCheckPrice.dimension.width
        this.length = this.tmpCheckPrice.dimension.length
        this.height = this.tmpCheckPrice.dimension.height
        this.size.boxSize = this.tmpCheckPrice.dimension.size.boxSize
        this.keyBox = this.tmpCheckPrice.dimension.size.boxSize
        this.to.district = this.tmpCheckPrice.toAddress.state
        this.to.state = this.tmpCheckPrice.toAddress.district
        this.to.province = this.tmpCheckPrice.toAddress.province
        this.to.postcode = this.tmpCheckPrice.toAddress.postcode
      })
    },
    clearDataTmpCheckPrice() {
      this.$nextTick(() => {
        Object.keys(this.tmpCheckPrice.toAddress).forEach(key => {
          this.tmpCheckPrice.toAddress[key] = '';
        });

        Object.keys(this.tmpCheckPrice.dimension).forEach(key => {
          if (!['size'].includes(key)) {
            this.tmpCheckPrice.dimension[key] = '';
          } else if (key == 'size') {
            this.tmpCheckPrice.dimension[key].boxSize = '';
          }
        });

        this.tmpCheckPrice.weight = ''
      });
    },
    selectThaipost(){
      this.busy = true
      let selectThaipostData = this.thaipostData[0]
      this.modalOrders(selectThaipostData, 'thaipost')
      this.checkDestinationCourier()
      this.callCheckProblemCategory()
    },
    async modalOrders(courier, typeCourier) {
      await this.getIcon(courier).then(res => {
        this.iconUrl = res
      })

      this.selectedCourier = courier
      this.errorWeight = false
      if (this.selectedCourier.rates.length > 0) {

        this.selectedCourier.rates = groupBy(this.selectedCourier.rates, "type")
      }
      if (typeCourier == "prebarcode") {

        this.firstmodal = this.sender.name != "" ? "modal-prebarcode" : "modal-idcard"
        if (this.firstmodal == 'modal-idcard') {
          this.$refs.modalSender.$refs[this.firstmodal].show()
        } else {
          if (!this.lockCardCourier.cod) {
            this.$refs[this.firstmodal].show()
          } else {
            this.showErrorModal('กรุณาสมัครสมาชิก COD ที่หน้าจัดการลูกค้า ***แต่ยังสามารถสร้างรายการที่ไม่ใช่ COD ได้ตามปกติ***', 'Done')
            this.setFalseLockCod()
          }
        }

        this.preBarcode = typeCourier
      } else {

        this.firstmodal = this.sender.name != "" ? "model-parcel" : "modal-idcard"
        await this.$nextTick();
        if (this.firstmodal == 'modal-idcard') {
          this.$refs.modalSender.$refs[this.firstmodal].show()
        } else {
          if (!this.lockCardCourier.cod) {
            this.$refs[this.firstmodal].show()
          } else {
            this.showErrorModal('กรุณาสมัครสมาชิก COD ที่หน้าจัดการลูกค้า ***แต่ยังสามารถสร้างรายการที่ไม่ใช่ COD ได้ตามปกติ***', 'Done')
            this.setFalseLockCod()
          }
        }

      }

      this.setDimension();

      this.setAction(this.firstmodal)

      if (this.tmpCheckPrice.isCheckPrice) {
        await this.setDefaultDataSelectedCourier();
        await this.clearDataTmpCheckPrice()
        this.tmpCheckPrice.isCheckPrice = false
      }
      this.busy = false
    },
    setFalseLockCod() {
      this.lockCardCourier.cod = false
    },
    setDimension() {
      let checkDropoffKerry = ["KRYDS", "ORNGDS"].includes(this.selectedCourier.key);
      let setDimension = this.getDimensionLocalStorage();
      if (setDimension.status) {
        if (checkDropoffKerry) {

          if (setDimension.data.width > 0
            || setDimension.data.length > 0
            || setDimension.data.height > 0
          ) {
            this.kerryDropoff.favoriteDimension = true;
          }
          // console.log(setDimension.data.weight, 'weight')
          if (setDimension.data.weight > 0) {
            this.kerryDropoff.favoriteWeight = true;
          }
          this.kerryDropoff.parcel.width = setDimension.data.width
          this.kerryDropoff.parcel.length = setDimension.data.length
          this.kerryDropoff.parcel.height = setDimension.data.height
          this.kerryDropoff.size.boxSize = setDimension.data.size
          this.kerryDropoff.parcel.weight = (setDimension.data.hasOwnProperty('weight') && ['shippop', 'quickexpress'].includes(this.$THEME.name)) ? setDimension.data.weight : ''
        } else {
          this.favoriteDimension = true;
          this.width = setDimension.data.width
          this.length = setDimension.data.length
          this.height = setDimension.data.height
          this.size.boxSize = setDimension.data.size
          this.keyBox = setDimension.data.size
          this.weight = (setDimension.data.hasOwnProperty('weight')) ? setDimension.data.weight : ''
        }
      } else {
        this.favoriteDimension = false;
        this.kerryDropoff.favoriteDimension = false;
      }
    },
    sameSender() {
      if (this.isToggle == false) {
        this.from.name = this.sender.name
        this.from.address = this.sender.address
        this.from.state = this.sender.state
        this.from.district = this.sender.district
        this.from.province = this.sender.province
        this.from.postcode = this.sender.postcode
        this.from.tel = this.sender.tel
        this.titleName = "ที่อยู่ตามบัตรประชาชน"
      } else {
        this.from.name = this.sameData.name
        this.from.address = this.sameData.address
        this.from.state = this.sameData.state
        this.from.district = this.sameData.district
        this.from.province = this.sameData.province
        this.from.postcode = this.sameData.postcode
        this.from.tel = this.sameData.tel
        this.titleName = "ที่อยู่ร้าน"
      }
    },
    setDefaultOrigin() {
      Object.keys(this.from).forEach(key => {
        if (this.sameData[key]) {
          this.from[key] = this.sameData[key]
        } else {
          this.from[key] = ''
        }
      })
      this.from.source = 0
      this.isToggle = false
    },
    close() {
      Object.keys(this.sender).forEach(key => {
        this.sender[key] = "";
      });
      this.sender.customer_type = "0"
      this.$refs.modalSender.submitAddIdCard = false
      this.errorBirthday = false
      this.cod_details.isCod = false
      this.sender.identity = false
      this.errorIdCard = false
      this.dropoffVRich.show = false
      this.dropoffPanPan.show = false
      this.dropoffEasyShip.show = false
      this.dropoffEasyShip.notCloseModal = false
      if (this.firstmodal == 'modal-idcard') {
        this.$refs.modalSender.$refs[this.firstmodal].hide()
      } else {
        this.$refs[this.firstmodal].hide()
      }
    },
    isFuncBookBank() {
      const header = {
        headers: {
          Token: localStorage.getItem("access_token")
        }
      }
      this.$http.post(this.$API_URL + "/is/bookbank", {}, header).then((res) => {
        this.isHasBookBank = res.data.data
      })
    },
    beforeCheckbill() {
      this.recheckCutOrderDraft = true
      if (this.filterCheckDropoffLine) {
        // call api เช็คว่ามีธนาคารไหม
        this.isFuncBookBank()
      }

      let JNTFindPickup = this.cart.filter(item => {
        return item.key == 'JNT' && item.pickup_type == 'JNTPF'
      })

      const creditPay = this.checkCreditPay(this.totalShipping)

      if (JNTFindPickup.length > 0 && JNTFindPickup.length < 10) {
        this.showNotiModal('ไม่สามารถทำรายการต่อได้ เนื่องจากท่านได้ทำการเลือกขนส่ง J&T Express โดยมีเงื่อนไขการเข้ารับพัสดุ กรุณาสร้างพัสดุขั้นต่ำ 10 ชิ้น ตอนนี้ท่านได้สร้างไปแล้ว ' + JNTFindPickup.length + ' ชิ้น')
      } else if (
        this.$WALLET.status == true
        && this.$WALLET.available_balance < creditPay
        && (!this.checkThemeQuick() || this.filterCheckDropOffVRich)
        && ['PREPAID'].includes(this.noti.payment_type)
        && (this.main_use_walletV2 && this.$WALLET_METADATA.get().verified)
      ) {
        this.checkCreditWallet(creditPay)
      } else {
        this.checkBill.show = true
      }
    },
    checkOutOrderProduct() {
      const shopCode     = this.$USER_LOGIN.get().details.shop_code
      const getCartToken = cartPos.cartToken().get()

      cartPos.removeDraft(shopCode, getCartToken)
    },
    removeDraftOrder(key) {
      const shopCode = this.$USER_LOGIN.get().details.shop_code
      cartPos.removeDraft(shopCode, key)
      this.fetchOrderDraft()

      const getCartToken = cartPos.cartToken().get()
      if (key === getCartToken) {
        this.newGenerateCartToken()
        if (!this.filterCheckKerryDropoff || this.idorder || !this.filterCheckFlashDropoff) {
          this.reset();
        }
        this.cart = []
        this.clearSender()
      }
    },
    async closeParcel() {
      return new Promise(async resolve => {
        if (this.addMoreOrder.isActive) {
          this.addMoreOrder.isShow = true
        } else {
          this.$refs[this.modalparcel].hide()
          this.$refs[this.modalprebarcode].hide()
          this.setDefaultOrigin()
          this.cod_details.isCod = false
        }
        this.dropoffEasyShip.notCloseModal = false
        await this.clearValueOnCloseModalParcel()
        await this.setAction(ACTION_CREATE_ORDER.index)
        return resolve(true)
      })
    },
    async clearValueOnCloseModalParcel() {
      return new Promise(async resolve => {
        this.weight = ""
        this.weightKG = ""
        await Object.keys(this.to).forEach(key => {
          this.to[key] = ""
        })
        this.prerate = 0
        this.walletPrerate = 0
        this.selectedTier = {};
        this.dimensionWeight = 0;
        this.calculateWeight = 0;
        this.extra_handling_charge = 0;
        this.type = ''
        this.scanBarcode = ""
        this.editorder = ""
        this.codAmount = ""
        this.codProducts = []
        this.width = ""
        this.length = ""
        this.height = ""
        this.tracking = ""
        this.size.boxSize = ""
        this.remarkOrderDetail = ""
        this.editOrdersAll = false
        this.barcodeError = false
        this.barcodeOk = false
        this.errorBarcode = false
        this.ratePreError = false
        this.rateError = false
        this.errorWeight = false
        this.submitAddPrebarcode = false
        this.submitAddShipping = false
        this.errorCodAmount = false
        this.errorCodProduct = {}
        this.errorCreateOrderByOne.status = false
        this.errorCreateOrderByOne.msg = ''
        this.errorAlertParcel.status = false
        this.errorAlertParcel.msg = ''
        this.errorAlertParcel.disableButton = false
        this.errorAlertParcel.errorServiceArea.status = false
        this.errorAlertParcel.errorServiceArea.msg = ''
        this.errorAlertParcel.errorDestination.status = false
        this.errorAlertParcel.errorDestination.msg = ''
        this.draftSpecialCode = null
        this.clearValueValidate();
        this.clearValueModalVRish();
        this.clearValueModalQuick();
        this.clearValueModalEasyShip();
        this.clearInputInsurance()
        this.clearNotificationArea()
        return resolve(true)
      })
    },
    checkCodAmount() {
      this.codCondition = COURIERS_COD.condition[this.selectedCourier.key] || COURIERS_COD.condition.default;
      if (this.codAmount < this.codCondition.min
        || this.codAmount > this.codCondition.max) {
        this.errorCodAmount = true
        return false
      } else {
        this.errorCodAmount = false
        return true
      }
    },
    checkCodProduct() {
      if (this.codProducts.length === 0) {
        this.errorCodProduct = {
          0: {
            name: 'กรุณาใส่ชื่อสินค้า',
            category: 'กรุณาเลือกประเภท',
            price: 'กรุณาระบุราคา',
            weight: 'กรุณาระบุน้ำหนัก',
            amount: 'กรุณาระบุจำนวน'
          }
        }

        return false
      }

      for (let i=0; i<this.codProducts.length; i++) {
        const v = this.codProducts[i]
        let tempError = {}

        if (!v.name) {
          tempError['name'] = 'กรุณาใส่ชื่อสินค้า'
        }

        if (!v.category) {
          tempError['category'] = 'กรุณาเลือกประเภท'
        }

        if (typeof v.price !== 'number') {
          tempError['price'] = 'กรุณาระบุราคา'
        }

        if (typeof v.weight !== 'number') {
          tempError['weight'] = 'กรุณาระบุน้ำหนัก'
        }

        if (typeof v.amount !== 'number') {
          tempError['amount'] = 'กรุณาระบุจำนวน'
        }

        if (Object.keys(tempError).length > 0) {
          this.errorCodProduct = {
            ...this.errorCodProduct,
            [i]: { ...tempError }
          }

          return false
        }
      }

      return true
    },
    async validatePrebarcode() {
      this.submitAddPrebarcode = true;
      this.$v.to.$touch();
      this.$v.weight.$touch();
      this.$v.scanBarcode.$touch();

      if (
        this.$v.to.$invalid ||
        this.$v.weight.$invalid ||
        this.$v.scanBarcode.$invalid
      ) {
        this.barcodeOk = false;
        return false;
      }
      if (this.barcodeError === true) {
        this.barcodeOk = false;
        this.barcodeError = true;
        return false;
      }
      if (this.weight <= 0) {
        this.barcodeOk = false;
        this.errorWeight = true;
        return false
      }
      this.errorWeight = false;
      this.errorBarcode = false;
      this.barcodeError = false;
      const checkPrice = await this.checkPrice()
      if (checkPrice.status && checkPrice.status === false) return checkPrice
      const addShip = await this.addShipping(checkPrice, TYPE_PREBARCODE)
      if (addShip !== true) return addShip
      return addShip
    },
    async validateShip() {
      this.submitAddShipping = true
      if (this.checkThemeQuick()) {
        this.isLoadingShip = true
      }
      const validDes = await this.validateDestination()
      if (validDes !== true) {
        if (this.checkDisableInputDropoff()) {
          Object.keys(this.validate.checkInput).forEach(key => {
            this.validate.checkInput[key] = !this.$v.to[key].$error
          })
        }
        this.submitAddShipping = false
        this.isLoadingShip = false
        return false
      }
      this.checkCategoryPrice = await this.checkPrice()
      if (this.checkCategoryPrice.status && this.checkCategoryPrice.status === false) {
        this.isLoadingShip = false
        return this.checkCategoryPrice
      }

      const addShip = await this.addShipping(this.checkCategoryPrice)
      if (addShip !== true) {
        this.isLoadingShip = false
        return addShip
      }
      this.setAction(ACTION_CREATE_ORDER.index)
      if (!this.checkThemeQuick()) {
        this.clearValueOnCloseModalParcel()
      }
      return addShip
    },
    async validateDestination() {
      this.$v.from.$touch()
      this.$v.to.$touch()
      this.$v.weight.$touch()
      this.$v.codAmount.$touch()
      this.$v.insurance.$touch()
      if (this.$v.from.$invalid
        || this.$v.to.$invalid
        || this.$v.weight.$invalid
        // || (this.insurance.isCheck === true && this.$v.insurance.$invalid)
        // || (this.$v.codAmount.$invalid && this.cod_details.isCod)
      ) {
        this.barcodeOk = false
        this.currentError = (this.$v.from.$invalid) ? this.$refs['model-parcel-header'] : this.$refs['model-parcel-destination'];
        if (this.action !== ACTION_CREATE_ORDER.excel) {
          this.scrollToError()
        }
        return this.responseValidateError(this.$v)
      }
      if (this.weight <= 0) {
        this.errorWeight = true
        return this.responseValidateError({ weight: 'weight must be more than 0' })
      }
      if (this.insurance.isCheck === true && this.$v.insurance.$invalid) {
        this.checkErrorSeletedParcelInsurance
        this.checkErrorParcelInsurance

        this.currentError = (this.$v.from.$invalid) ? this.$refs['model-parcel-header'] : this.$refs['model-parcel-destination']
        this.scrollToError()
        return this.responseValidateError({ insuance: 'insurace is require' })
      }
      if (!this.checkCodAmount() && this.cod_details.isCod) {
        return this.responseValidateError({ cod: 'cod is require' })
      }
      if (this.cod_details.isCod && !this.checkCodProduct()) {
        return this.responseValidateError({ cod_products: 'cod products is require' })
      }
      if (this.tracking && this.barcodeError === true) {
        this.barcodeOk = false
        this.barcodeError = true
        return this.responseValidateError({ cod: 'barcode is require' })
      }
      let checkDes = await this.checkDestinationByCourier()
      if (checkDes != true) return this.responseValidateError(checkDes)
      return checkDes
    },
    async checkDestinationByCourier() {
      if (!['FLE', 'FLEF', 'FLEB', 'FLEWP'].includes(this.selectedCourier.key)) {
        return true;
      }
      this.isLoadingShip = true
      let resAdressByFlash = await this.checkAdressByFlash()
      if (resAdressByFlash == null) {
        this.isLoadingShip = false
        return true
      }
      if (resAdressByFlash && resAdressByFlash.code == 'ERR_TEMPORARY_CLOSE_AREA') {
        this.errorAlertParcel.status = true;
        this.errorAlertParcel.msg = resAdressByFlash.msg;
      }
      this.isLoadingShip = false
      // let validateAddressFromFLE = {
      //   srcProvinceName: 'province',
      //   srcCityName: 'district',
      //   srcDistrictName: 'state',
      //   srcPostalCode: 'postcode'
      // }
      let validateAddressToFLE = {
        dstProvinceName: 'province',
        dstCityName: 'district',
        dstDistrictName: 'state',
        dstPostalCode: 'postcode'
      }
      for (let errorAddress in resAdressByFlash) {
        let resMsg = resAdressByFlash[errorAddress][0]
        const error = [
          'srcProvinceName', 'srcCityName', 'srcDistrictName', 'srcPostalCode'
        ].includes(errorAddress)
        try {
          if (error) {
            // this.validateAddress.from[validateAddressFromFLE[errorAddress]].status = true
            // this.validateAddress.from[validateAddressFromFLE[errorAddress]].msg = resMsg

            this.errorCreateOrderByOne.status = true
            if (this.errorCreateOrderByOne.msg) {
              this.errorCreateOrderByOne.msg = `${this.errorCreateOrderByOne.msg}, ${resMsg}`
            } else {
              this.errorCreateOrderByOne.msg = `ต้นทางร้านค้า: ${resMsg}`
            }

          } else {
            if (!['base'].includes(errorAddress)) {
              this.validateAddress.to[validateAddressToFLE[errorAddress]].status = true
              this.validateAddress.to[validateAddressToFLE[errorAddress]].msg = resMsg
            }
          }
        } catch (e) {
          // eslint-disable-next-line
          console.error('error->Pos->checkDestinationByCourier', e)
        }

      }
      this.isLoadingShip = false
      try {
        if (this.action !== ACTION_CREATE_ORDER.excel) {
          this.$refs['model-parcel-header'].scrollIntoView({
            behavior: "smooth", block: "center"
          })
        }
      } catch (e) {
        // eslint-disable-next-line
        console.error('error->Pos->checkDestinationByCourier', e)
      }
      return this.validateAddress
    },
    responseValidateError(data) {
      return {
        status: false,
        error: data
      }
    },
    async checkAdressByFlash() {

      let o_province, o_district, o_state, o_postcode

      if (this.from.source == "1") {

        o_province = this.from.province
        o_district = this.from.district
        o_state = this.from.state
        o_postcode = this.from.postcode

      } else {

        o_province = this.sameData.province
        o_district = this.sameData.district
        o_state = this.sameData.state
        o_postcode = this.sameData.postcode

      }

      let des_province = this.to.province
      let des_district = this.to.district
      let des_state = this.to.state
      let des_postcode = this.to.postcode

      let ret = null

      await this.$http.post(API_URL + "/checkprice", {

        origin_province: o_province,
        origin_district: o_district,
        origin_state: o_state,
        origin_postcode: o_postcode,
        destination_province: des_province,
        destination_district: des_district,
        destination_state: des_state,
        destination_postcode: des_postcode,
        weight: this.weight,
        width: this.width,
        length: this.length,
        height: this.height,
        courier_code: this.selectedCourier.key
      },
        {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let response = res.data

          if (response.status === false) {

            ret = res.data.error

          }


        })

      return ret
    },
    async addShipping(price, type = TYPE_MANUAL) {
      const data = this.setCartParcelTemp(price)
      if (this.editOrdersAll) {
        this.cart.push(data)
        this.cart.splice(this.cart.findIndex(item => item.check == this.editorder), 1)
        this.$refs[this.modalparcel].hide()
        this.$refs[this.modalprebarcode].hide()
        if (!this.checkThemeQuick()) {
          this.addDraftStorage()
        }
        this.editOrdersAll = !this.editOrdersAll
      } else {
        if (this.checkThemeQuick() && type == TYPE_MANUAL && !this.editorder && !this.checkDropoffVRich() && !this.checkDropoffQuick() && !this.checkDropoffPanPan()) {
          this.isLoadingShip = true;

          const creditPay = this.checkCreditPay(data.price)

          if (this.$WALLET.status == true && this.$WALLET.available_balance < creditPay) {
            this.checkCreditWallet(creditPay)
            this.isLoadingShip = false;
            return false;
          }

          this.confirmShippingByOne(data, type)
          return true
        } else if (this.checkDropoffVRich() || this.checkDropoffQuick() || this.checkDropoffPanPan()) {
          this.addCartParcelTemp(data)
          this.confirmShipping()
          this.$refs[this.modalparcel].hide()
        } else {
          this.addMoreOrder.isShow = true
          this.addMoreOrder.isActive = true
          this.addMoreOrder.typeCourier = this.preBarcode
          if (this.editorder) {
            const indexOfAddMoreOrder = this.addMoreOrder.order.findIndex(item => item.check == this.editorder)
            this.$set(this.addMoreOrder.order, indexOfAddMoreOrder, data)
          } else {
            this.addCartParcelTemp(data)
          }
        }

      }
      this.isLoadingShip = false
      // this.busy = false
      this.clearInputInsurance()
      return true
    },
    checkCreditPay(value) {
      const totalRate = this.cartShipping.reduce((acc, cur) => acc + cur.rate, 0)

      return this.main_use_walletV2 ? totalRate : value
    },
    checkCreditWallet(totalPrice) {
      fetchWalletBanlancesToLocalStorage(this.main_use_walletV2).then(res => {
        this.$WALLET.available_balance = res.available_balance
        this.$WALLET.balance = res.balance
        this.$WALLET.peg_balance = res.peg_balance

        if (res.available_balance < totalPrice) {
          this.alertCredit.creditPay = totalPrice;
          this.alertCredit.show = true
        }
      })
    },
    addCartParcelTemp(data) {
      this.addMoreOrder.order.push(data)
    },
    setCartParcelTemp(listPrice = false) {
      let price = listPrice
      if (listPrice === false) {
        price = {
          price: 0,
          rate: 0,
          fee: 0,
          key_size: 0
        }
      }
      return {
        error: {
          status: false,
          data: [],
          msg: null
        },
        ...((this.checkDropoffVRich()) ? {
          dropoff_type: 'VRICH_DROPOFF',
          shippop_tracking_code: this.dropoffVRich.shippopTrackingCode,
          dropoff_tracking_code: this.dropoffVRich.trackingCode,
          datetime_create_order: this.dropoffVRich.datetimeCreateOrder
        } : {}),
        ...((this.checkDropoffPanPan()) ? {
          dropoff_type: 'PANPAN_DROPOFF',
          shippop_tracking_code: this.dropoffPanPan.shippopTrackingCode,
          dropoff_tracking_code: this.dropoffPanPan.trackingCode,
          datetime_create_order: this.dropoffPanPan.datetimeCreateOrder
        } : {}),
        ...((this.checkDropoffEasyShip()) ? {
          dropoff_type: 'EASYSHIP_DROPOFF',
          dropoff_tracking_code: this.dropoffEasyShip.trackingCode
        } : {}),
        ...((this.checkDropoffQuick()) ? {
          dropoff_type: 'QUICK_DROPOFF',
          shippop_tracking_code: this.dropoffQuick.shippopTrackingCode,
          dropoff_tracking_code: this.dropoffQuick.trackingCode,
          datetime_create_order: this.dropoffQuick.datetimeCreateOrder
        } : {}),
        insurance: JSON.parse(JSON.stringify(this.insurance)),
        save_address: JSON.parse(JSON.stringify(this.save_address)),
        check: this.count++,
        type: "ship",
        remarkOrderDetail: this.remarkOrderDetail,
        ratetype: this.type,
        courier: this.selectedCourier,
        name: this.selectedCourier.name,
        key: this.selectedCourier.key,
        pickup_type: this.pickup_type,
        num: 1,
        special_code: price.special_code ? price.special_code : null,
        price: +price.price,
        pre_tracking: this.tracking ? this.tracking : null,
        cod_amount: this.codAmount,
        cod_products: this.codProducts.filter((v) => v.hasOwnProperty('name') && v.name),
        rate: price.rate,
        fee: price.fee,
        rate_remote_area: this.remote_area.rate,
        travel_surcharge: this.remote_area.travel_surcharge,
        island_surcharge: this.remote_area.island_surcharge,
        extra_handling_charge: this.extra_handling_charge,
        fuel_surcharge: price.fuel_surcharge,
        cross_price: this.crossPrice,
        rate_id: this.selectedTier ? this.selectedTier.id : null,
        parcel: {
          weight: this.weight,
          width: this.width,
          length: this.length,
          height: this.height,
          key_size: price.key_size,
          weightKG: this.weightKG,
        },
        barcode: "",
        pre_barcode: this.scanBarcode,
        refer_id: this.selectedCourier.id,
        from: {
          source: this.from.source,
          address: this.from.address,
          district: this.from.district,
          latlng: this.from.latlng,
          name: this.from.name,
          postcode: this.from.postcode,
          province: this.from.province,
          state: this.from.state,
          tel: this.from.tel,
          addressType: this.isToggle

        },
        to: {
          address: this.to.address,
          district: this.to.state,
          latlng: this.to.latlng,
          name: this.to.name,
          postcode: this.to.postcode,
          province: this.to.province,
          state: this.to.district,
          tel: this.to.tel
        }
      }
    },
    hasRemoteArea() {
      return (this.remote_area.island_surcharge > 0 || this.remote_area.travel_surcharge > 0 || this.remote_area.rate > 0 || this.crossPrice > 0)
        && this.action !== ACTION_CREATE_ORDER.excel
    },
    confirmShippingByOne(data, type = TYPE_MANUAL) {
      const order = []
      let copyCard = JSON.parse(JSON.stringify(data))
      if (copyCard.courier) {
        delete copyCard.courier
      }
      if (copyCard.type == "item") {
        copyCard.refer_id = copyCard.id;
      }

      order.push(copyCard)

      this.$http
        .post(
          API_URL + "/draft/order",
          {
            ...((this.orderIdByOne) ? { order_id: this.orderIdByOne } : {}),
            orders: order,
            sender: {
              id_no: this.sender.id_no,
              name: this.sender.name,
              birthday: this.sender.birthday,
              tel: this.sender.tel,
              address: this.sender.address,
              state: this.sender.state,
              district: this.sender.district,
              province: this.sender.province,
              postcode: this.sender.postcode,
              customer_type: this.sender.customer_type,
              tax: this.sender.tax,
              mem_id: this.sender.mem_id
            }
          },
          {
            headers: {
              "Content-Type": "application/json",
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let checkError = validatePop(res)
          if (!checkError.status) {
            if (!censorCodeDraftOrderAPI.includes(res.data.error.code)) {
              this.sendErrorToLine(res)
            }
            this.busy = false
            this.isLoadingShip = false

            if (typeof checkError.data != 'undefined' && checkError.data != null && checkError.data.length > 0) {
              this.errorCreateOrderByOne.status = true;
              this.errorCreateOrderByOne.msg = checkError.data[0].msg
            } else {
              if (type == TYPE_EXCEL) {
                this.showErrorModal(checkError.msg);
              } else {
                this.errorCreateOrderByOne.status = true;
                this.errorCreateOrderByOne.msg = checkError.msg
              }
            }

            return false

          }
          let resData = res.data.data;
          this.orderIdByOne = resData.order_id;

          this.$set(data, 'order_detail_id', resData.order[0].order_detail_id)
          this.$set(data, 'tracking_code', resData.order[0].barcode)

          if (type == TYPE_MANUAL) {
            this.cart.push(data)
          }

          this.setLocalStorageOrderCart(this.cart)
          setLocalStorage.orderId().set(this.orderIdByOne);
          this.$WALLET.available_balance = res.data.data.wallet_info.available_balance
          this.$WALLET.balance = res.data.data.wallet_info.balance
          this.$WALLET.peg_balance = res.data.data.wallet_info.peg_balance
          let label = this.$router.resolve({
            name: 'customlabel',
            params: {
              type: 'orderByOne',
              orderId: this.orderIdByOne,
              detailId: data.order_detail_id,
              label: this.label
            }
          })
          window.open(label.href, '_blank')

          this.checkDisableCardCourier();
          this.clearValueModalParcel()
          this.clearValueOnCloseModalParcel();
          this.isLoadingShip = false;
          this.busy = false;
          if (!this.checkNotCloseModal()) {
            this.$refs[this.modalparcel].hide()
          } else {
            this.dropoffEasyShip.trackingCode = '';
          }

          this.$refs[this.modalprebarcode].hide()
          // สำรองไว้ เผื่อของใหม่หาย
          // getLabelHtml( this.orderIdByOne , this.label , data.order_detail_id ).then( res => {
          //   printReceipt( res , 500 );
          //   this.checkDisableCardCourier();
          //   this.clearValueModalParcel()
          //   this.clearValueOnCloseModalParcel();
          //   this.isLoadingShip = false;
          //   this.busy = false;
          //   this.$refs[this.modalparcel].hide()
          //   this.$refs[this.modalprebarcode].hide()
          // })
        })
        .catch(() => {
          this.isLoadingShip = false;
          this.busy = false;
          this.showErrorModal(
            " พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #011 "
          )
        })
    },
    async printLabel(order_detail_id) {
      const label = await getLabelHtml(this.orderIdByOne, this.label, order_detail_id)
      const win = window.open("", '_blank');
      win.document.write(label)
    },
    printLabelDropoff(trackingCodeSP, typeDropoff) {
      const win = window.open("", '_blank');
      getLabelHtmlByTracking(this.label, trackingCodeSP, typeDropoff).then(res => {
        win.document.write(res.html);
      })
    },
    switchPrintLabel(order) {
      if (order.order_detail_id) {
        let label = this.$router.resolve({
          name: 'customlabel',
          params: {
            type: 'orderByOne',
            orderId: this.orderIdByOne,
            detailId: order.order_detail_id,
            label: this.label
          }
        })
        window.open(label.href, '_blank')
      } else if (order.hasOwnProperty('dropoff_type') && (order.dropoff_type == 'VRICH_DROPOFF' || order.dropoff_type == 'QUICK_DROPOFF')) {
        this.printLabelDropoff(order.shippop_tracking_code, order.dropoff_type)
      } else {
        this.busy = true
        this.confirmShippingByOne(order, 'excel')
      }
    },
    checkBeforeRemoveTotal(check) {
      if (this.checkThemeQuick()) {
        this.cancelBeforeRemoveTotal(check)
      } else {
        this.removeTotal(check)
      }
    },
    addSenderToLocalStorage() {
      let newSender = {}
      let newFirstDate = {}
      let getFirstDate = cartPos.dateFirstDraft().get()
      const shopCode = this.$USER_LOGIN.get().details.shop_code
      const getCartToken = cartPos.cartToken().get()
      const getDraftAllOrder = cartPos.draftStorage().get()
      let getSenderAll = cartPos.senderStorage().get()

      newSender[getCartToken] = JSON.parse(JSON.stringify(this.sender))
      newFirstDate[getCartToken] = moment().format("DD-MM-YYYY HH:mm")

      if (getFirstDate) {
        // วันที่สร้างรายการชิ้นแรกของ Draft นั้น
        if (!getFirstDate[shopCode]) {
          getFirstDate[shopCode] = {}
        }
        getFirstDate[shopCode][getCartToken] = moment().format("DD-MM-YYYY HH:mm")
      }
      if (getSenderAll) {
        if (!getSenderAll[shopCode]) {
          getSenderAll[shopCode] = {}
        }
        getSenderAll[shopCode][getCartToken] = newSender[getCartToken]
      }
      if (getDraftAllOrder) {
        if (!getDraftAllOrder[shopCode]) {
          getDraftAllOrder[shopCode] = {}
        }
        getDraftAllOrder[shopCode][getCartToken] = []
      }

      cartPos.senderStorage().add(getSenderAll ? getSenderAll : { [shopCode]: newSender })
      cartPos.draftStorage().add(getDraftAllOrder)
      cartPos.dateFirstDraft().add(getFirstDate ? getFirstDate : { [shopCode]: newFirstDate })
      this.fetchOrderDraft()
    },
    addDraftStorage() {
      const getCartToken = cartPos.cartToken().get()
      let newCart = {}
      let newOrders = []

      const cartModifyObject = JSON.parse(JSON.stringify(this.cart))
      cartModifyObject.map((mainVal) => {
        if (mainVal.courier)
          delete mainVal.courier.rates
        newOrders.push(mainVal)
      })

      newCart[getCartToken] = newOrders
      // newSender[getCartToken] = JSON.parse(JSON.stringify(this.sender))
      // newFirstDate[getCartToken] = moment().format("DD-MM-YYYY HH:mm")

      let getDraftAllOrder = cartPos.draftStorage().get()
      getDraftAllOrder = getDraftAllOrder ? getDraftAllOrder : {}
      // let getSenderAll = cartPos.senderStorage().get()
      // let getFirstDate = cartPos.dateFirstDraft().get()
      const shopCode = this.$USER_LOGIN.get().details.shop_code
      if (getDraftAllOrder && !getDraftAllOrder[shopCode]) {
        getDraftAllOrder[shopCode] = {}
      }
      if (!getDraftAllOrder || !getDraftAllOrder[shopCode].hasOwnProperty(getCartToken)) {
        // เฉพาะครั้งแรกที่ยังไม่เคยมี localstorage draft
        if (getDraftAllOrder) {
          getDraftAllOrder[shopCode][getCartToken] = newOrders
        }
        // if (getSenderAll) {
        //   if (!getSenderAll[shopCode]) {
        //     getSenderAll[shopCode] = {}
        //   }
        //   getSenderAll[`shopCode`][getCartToken] = newSender[getCartToken]
        // }
        cartPos.draftStorage().add(getDraftAllOrder ? getDraftAllOrder : { [shopCode]: newCart })
        // cartPos.senderStorage().add(getSenderAll ? getSenderAll : { [shopCode]: newSender })
        // cartPos.dateFirstDraft().add(getFirstDate ? getFirstDate : { [shopCode]: newFirstDate })
      } else {
        getDraftAllOrder[shopCode][getCartToken] = newOrders
        cartPos.draftStorage().add(getDraftAllOrder)
        // getSenderAll[shopCode][getCartToken] = newSender[getCartToken]
        // cartPos.senderStorage().add(getSenderAll)
      }
      this.fetchOrderDraft()
    },
    confirmShipping() {
      if ((this.addMoreOrder.order.length + this.cart.length) > 100) {
        this.addMoreOrder.error.status = true;
        this.addMoreOrder.error.msg = 'ทำรายการเกินจำนวนออเดอร์ที่กำหนด กรุณาสร้างรายการทีละ 100 รายการ'
        return false;
      }
      this.addMoreOrder.error.status = false
      this.addMoreOrder.error.msg = null
      this.addMoreOrder.isShow = false
      this.addMoreOrder.isActive = false
      this.cart.push(...this.addMoreOrder.order)
      if (this.checkThemeQuick()) {
        this.setLocalStorageOrderCart(this.cart)
      }
      if (this.addMoreOrder.order[0].hasOwnProperty('dropoff_type') && (this.addMoreOrder.order[0].dropoff_type == 'VRICH_DROPOFF' || this.addMoreOrder.order[0].dropoff_type == 'QUICK_DROPOFF')) {
        this.clearValueOnCloseModalParcel()
      }
      this.checkDisableCardCourier();
      this.addMoreOrder.order = []
      if (!this.checkThemeQuick()) {
        this.addDraftStorage()
      }
      this.clearValueModalParcel()
    },
    switchTypeCart() {
      let typeCart = null;

      if (this.filterCheckDropoffVRich) {
        typeCart = getTypeCart.TYPE_CART_DROPOFF_VRICH
      }
      else if (this.filterCheckDropoffQuick) {
        typeCart = getTypeCart.TYPE_CART_DROPOFF_QUICK
      }
      else if (this.filterCheckKerryDropoff) {
        typeCart = getTypeCart.TYPE_CART_DROPOFF_KERRY
      }
      else if (this.filterCheckFlashDropoff) {
        typeCart = getTypeCart.TYPE_CART_DROPOFF_FLASH
      }
      else if (this.filterCheckLazadaDropoff) {
        typeCart = getTypeCart.TYPE_CART_DROPOFF_LAZADA
      }
      else if (this.filterCheckDropoffLine) {
        typeCart = getTypeCart.TYPE_CART_DROPOFF_LINE
      }
      else if (this.filterCheckDropoffINTER) {
        typeCart = getTypeCart.TYPE_CART_DROPOFF_INTER
      }
      else if (this.filterCheckDropoffLAO) {
        typeCart = getTypeCart.TYPE_CART_DROPOFF_LAO
      }
      else if (
        this.selectedCourier.prebarcode == 0
        && this.selectedCourier.shippop == 1
      ) {
        typeCart = getTypeCart.TYPE_CART_COURIER
      } else if (
        this.selectedCourier.prebarcode == 1
        && this.selectedCourier.shippop == 1
      ) {
        typeCart = getTypeCart.TYPE_CART_PREBARCODE
      }

      return typeCart;
    },
    checkDisableCardCourier() {
      this.cart.forEach((item) => {
        if (item.type == "ship") {
          let typeCart = this.switchTypeCart();
          switchLockCourier(typeCart, this.lockCardCourier);
        }
      })
    },
    clearValueModalParcel() {
      Object.keys(this.to).forEach(key => {
        this.to[key] = "";
      })
      this.setDefaultOrigin()
      this.cod_details.isCod = false
      this.editorder = ""
      this.scanBarcode = ""
      this.weight = ""
      this.weightKG = ""
      this.codAmount = ""
      this.width = ""
      this.length = ""
      this.height = ""
      this.tracking = ""
      this.keyBox = ""
      this.size.boxSize = ""
      this.rateError = false
      this.clearValueModalVRish();
      this.clearValueModalPanPan();
      this.clearValueModalQuick();
      this.clearValueModalEasyShip();
      this.submitAddPrebarcode = false
      this.submitAddShipping = false
      // this.$refs[this.modalparcel].hide();
      // this.$refs[this.modalprebarcode].hide();
    },
    clearValueModalVRish() {
      if (this.checkDropoffVRich()) {
        this.dropoffVRich.show = false
        this.dropoffVRich.trackingCode = ""
        this.dropoffVRich.shippopTrackingCode = ""
      }
    },
    clearValueModalPanPan() {
      if (this.checkDropoffPanPan()) {
        this.dropoffPanPan.show = false
        this.dropoffPanPan.trackingCode = ""
        this.dropoffPanPan.shippopTrackingCode = ""
      }
    },
    clearValueModalEasyShip() {
      if (this.checkDropoffEasyShip() && !this.checkNotCloseModal()) {
        this.dropoffEasyShip.show = false
        this.dropoffEasyShip.trackingCode = ""
      } else if (this.checkDropoffEasyShip() && this.checkNotCloseModal()) {
        this.setDimension()
      }
    },
    clearValueModalQuick() {
      if (this.checkDropoffQuick()) {
        this.dropoffQuick.show = false
        this.dropoffQuick.trackingCode = ""
        this.dropoffQuick.shippopTrackingCode = ""
      }
    },
    clearValueValidate() {
      Object.keys(this.validate.checkInput).forEach(key => {
        this.validate.checkInput[key] = true;
      })
    },
    checkValidateDropoff() {
      if (this.checkDisableInputDropoff()) {
        Object.keys(this.validate.checkInput).forEach(key => {
          this.validate.checkInput[key] = (this.to[key]) ? true : false
        })
      }

      this.focusWeightParcel();
    },
    async itemPreRate(type = 'logdefault') {
      this.busy = true

      if (this.checkUntiKG()) {
        this.weight = this.weightKG * 1000;
      }
      this.calculateWeight = this.weight;
      const price = await this.itemPrice()
      this.busy = false
      this.errorWeight = false
      this.rateError = false
      this.ratePreError = false
      this.extra_handling_charge = price.extra_handling_charge
      if (!this.weight || this.weight == 0) {
        this.errorWeight = true;
        this.prerate = 0
        this.walletPrerate = 0
        this.selectedTier = {};
      } else if (price.status === false && price.type == 'weight') {
        // console.log('weight error')
        this.rateError = true;
        this.ratePreError = true;
        this.errorWeight = true;
      } else if (price.status === false && price.type == 'dimension') {
        // console.log('dimension error')
        this.rateError = true;
        this.prerate = 0
        this.walletPrerate = 0
        this.selectedTier = {};
        return false
      } else {
        this.prerate = +price.price + price.fuel_surcharge;
        this.walletPrerate = +price.rate
        this.selectedTier = price.selectedTier;
        this.errorWeight = false;
        this.rateError = false;
        this.ratePreError = false;
      }
    },
    onChangeParcelDetails() {
      return [ACTION_CREATE_ORDER.modalParcel, ACTION_CREATE_ORDER.modalPrebarcode]
        .includes(this.action)
    },
    changePostcode(postcode) {
      if (postcode.toString().length == 5 && this.onChangeParcelDetails()) {
        this.checkDestinationCourier()
        if (this.weight > 0) {
          this.itemPreRate()
        }
      }
    },
    changeProvince(event) {
      if (this.weight > 0 && this.to.postcode > 5 && event && this.onChangeParcelDetails()) {
        this.itemPreRate()
      }
    },
    clearInputValidateDimension() {
      this.validate = {
        modalParcel: {
          checkDimension: {
            status: true,
            msg: ""
          },
          dimension: {
            width: {
              status: true,
              msg: ""
            },
            length: {
              status: true,
              msg: ""
            },
            height: {
              status: true,
              msg: ""
            }
          }
        },
        checkInput: {
          state: true,
          district: true,
          province: true,
          postcode: true
        }
      }
    },
    async createOrderByExcel(data) {
      this.addMoreOrder.isActive = true
      await this.closeParcel()
      this.busy = true
      this.checkErrorCreateOrderByExcel = data.status
      await this.setAction(ACTION_CREATE_ORDER.excel)
      for (const item of data.data) {
        try {
          await this.autoCheckPrice(item)
        } catch (err) {
          let _order = this.addMoreOrder.order
          const lastIndexItem = _order.length - 1
          _order[lastIndexItem].error.status = true
          _order[lastIndexItem].error.data.push(err.error)
        }
      }
      this.addMoreOrder.isShow = true
      this.addMoreOrder.isActive = true
      this.addMoreOrder.typeCourier = this.preBarcode
      await this.clearValueOnCloseModalParcel()
      this.busy = false
    },
    async setAction(event) {
      return new Promise(resolve => {
        this.action = event
        return resolve(this.action)
      })
    },
    setDestinations(item) {
      const key = Object.keys(item)
      this.to.name = item[key[0]]
      this.to.tel = item[key[1]]
      this.to.address = item[key[2]]
      this.to.state = item[key[3]]
      this.to.district = item[key[4]]
      this.to.province = item[key[5]]
      this.to.postcode = item[key[6]]
      this.weight = this.checkUntiKG() ? (item[key[7]] * 1000) : item[key[7]];

      if (this.checkUntiKG()) {
        this.weightKG = item[key[7]];
      }

      this.width = item[key[8]]
      this.length = item[key[9]]
      this.height = item[key[10]]
      if (this.cod_details.isCod) {
        const cod = isNaN(item[key[11]]) ? null : item[key[11]]
        this.codAmount = cod
      }

      const lastIndex = key.findIndex((k) => k === 'หมายเหตุ')
      this.remarkOrderDetail = item[key[lastIndex]]
      const codInfoValue = item[key[lastIndex - 1]].trim()

      if (codInfoValue.length > 0) {
        const pattern = /^(\S+\/\S+\/\d+(\.\d+)?\/\S+\/\S+\/\d+(\.\d+)?\/\d+)(,\S+\/\S+\/\d+(\.\d+)?\/\S+\/\S+\/\d+(\.\d+)?\/\d+)*$/

        if (!pattern.test(codInfoValue)) {
          this.codProducts = []
          return
        }

        const splitByComma = codInfoValue.trim().split(',')
        const values = splitByComma.map((d) => d.split('/'))

        this.codProducts = values.map((d) => ({
          name: d[0],
          category: d[1],
          price: Number(d[2]),
          size: d[3] || '-',
          color: d[4] || '-',
          weight: Number(d[5]),
          amount: Number(d[6])
        }))
      } else {
          this.codProducts = []
      }

      const regex = new RegExp(/ขนาดพัสดุ/)

      if (regex.test(key[lastIndex - 2])) {
        this.keyBox = item[key[lastIndex - 2]]
      }
    },
    async autoCheckPrice(item) {
      return new Promise(async (resolve, reject) => {
        this.setDestinations(item)

        const addCart = this.setCartParcelTemp()
        this.addCartParcelTemp(addCart)
        const checkDes = await this.validateDestination()
        if (checkDes.status === false)
          return reject(checkDes)

        const checkPrice = await this.checkPrice()
        if (checkPrice.hasOwnProperty('status') && checkPrice.status === false)
          return reject(checkPrice)

        let _order = this.addMoreOrder.order
        const lastIndexItem = _order.length - 1
        this.addMoreOrder.order.splice(lastIndexItem, 1)
        const addShip = await this.addShipping(checkPrice, TYPE_EXCEL)
        if (addShip !== true) return reject(addShip)

        return resolve(addCart)
      })
    },
    async checkPrice() {
      const TYPR_DIM = 'dimension'
      const price = await this.itemPrice()
      if (price.status === false) {
        this.ratePreError = true
        this.rateError = true
        this.errorWeight = false
        this.isLoadingShip = false
        return this.responseValidateError({
          ratePreError: this.ratePreError,
          rateError: this.rateError,
          errorWeight: this.errorWeight,
          isLoadingShip: this.isLoadingShip
        })
      }
      if (price.status === false && price.type === TYPR_DIM) {
        this.isLoadingShip = false
        return this.responseValidateError(price)
      }
      await this.checkRemoteArea({
        ...price,
        remote_area: price.remote_area || 0,
        travel_surcharge: price.travel_surcharge || 0,
        island_surcharge: price.island_surcharge || 0
      })
      this.crossPrice = price.cross_price
      if (!this.checkThemeQuick())
        this.isLoadingShip = false
      return price
    },
    async checkRemoteArea(price) {
      let remoteArea = price.remote_area;
      let travelSurcharge = price.travel_surcharge;
      let islandSurcharge = price.island_surcharge;
      this.remote_area.rate = 0;
      this.remote_area.travel_surcharge = 0;
      this.remote_area.island_surcharge = 0;

      if (
        !courierRules.extraCouriers.includes(this.selectedCourier.key)
        && remoteArea < 1
      ) {
        this.remote_area.rate = remoteArea
        return remoteArea
      }

      let addressRemote = [
        this.to.state, this.to.district, this.to.province, this.to.postcode
      ].join(' ')
      this.isLoadingShip = true;

      await COURIER.setCourier(this.selectedCourier.key)
        .checkRemoteAreaByCorrectorDest(addressRemote, {
          weight: (this.weight > this.dimensionWeight) ? this.weight : this.dimensionWeight,
          price: price,
          remote_area: this.remote_area,
          pickup_type: this.pickup_type
        })
        .then(res => {
          // console.log('res area: ', res)
          if (!this.selectedCourier['remoteAreaOrigin']) { //
            this.isLoadingShip = false;
          }
          if (res) {
            // DEFAULT ALL COURIER
            this.remote_area.rate = remoteArea ? remoteArea : 0;
            this.remote_area.travel_surcharge = travelSurcharge ? travelSurcharge : 0;
            this.remote_area.island_surcharge = islandSurcharge ? islandSurcharge : 0;
            if ([
              'NJV', 'SPXP', 'BEST',
              'FLE', 'FLEF', 'FLEB', 'FLEWP',
              'MSE', 'MSEC', 'MSEF', 'SPE', 'SPEC',
              'KRYS', 'KRYQ', 'ORNG',
              'THP', 'EMST', 'EMSXP', 'ECP', 'JNT',
              'SHF', 'EMSF'
            ].includes(this.selectedCourier.key)) {
              this.remote_area.rate = remoteArea?res.isRemote:0;
              this.remote_area.travel_surcharge = res.isTravelArea;
              this.remote_area.island_surcharge = res.isIsland;
            }
          } else {
            this.remote_area.rate = 0
            this.remote_area.travel_surcharge = 0
            this.remote_area.island_surcharge = 0;
          }
        })
      if (this.selectedCourier.key == 'CJLX' && this.remote_area.rate <= 0) {
        let addressRemoteOrigin = (this.from.source == '1')
          ? [this.from.state, this.from.district, this.from.province, this.from.postcode].join(' ')
          : [
            this.sameData.state, this.sameData.district, this.sameData.province, this.sameData.postcode
          ].join(' ')
        let postcodeOrigin = (this.from.source == '1')
          ? this.from.postcode
          : this.sameData.postcode
        this.isLoadingShip = true;
        await COURIER.setCourier(this.selectedCourier.key)
          .checkRemoteAreaByCorrectorOrigin(addressRemoteOrigin, postcodeOrigin)
          .then(res => {
            this.isLoadingShip = false;
            this.remote_area.rate = res
          })
      }
      if (['DHL'].includes(this.selectedCourier.key)) {
        let addressRemoteOrigin = (this.from.source == '1')
          ? [this.from.state, this.from.district, this.from.province, this.from.postcode].join(' ') :
          [this.sameData.state, this.sameData.district, this.sameData.province, this.sameData.postcode].join(' ')
        let postcodeOrigin = (this.from.source == '1') ? this.from.postcode : this.sameData.postcode;
        this.isLoadingShip = true;
        await COURIER.setCourier(this.selectedCourier.key).checkRemoteAreaByCorrectorOrigin(addressRemoteOrigin, postcodeOrigin).then(res => {
          this.isLoadingShip = false;
          this.remote_area.rate += res
        })
      }
      return this.remote_area.rate
    },
    setCheckZone(courierCode) {
      let sameDatapostcode = this.sameData.postcode
      if (this.from.source == '1') {
        sameDatapostcode = this.from.postcode
      }
      this.checkZone = {
        fromPostcode: sameDatapostcode,
        toPostcode: this.to.postcode,
        province: {
          to: this.to.province,
          from: this.from.province,
        },
        district: {
          to: this.to.district,
          from: this.from.district
        }
      }
      this.checkZone.listSpecialCode = this.getStashSpecialCode()
      this.checkZone.specialCode = this.draftSpecialCode
      this.checkZone.courierPromotion = this.selectedCourier.courier_promotions ? true : false

      console.log('🍠 ', this.to)
      console.log('🍠 ', this.from)
      console.log(this.checkZone)

      switch (courierCode) {
        case 'FLE':
        case 'FLEF':
        case 'FLEB':
        case 'FLEWP':
        case 'KRYS':
        case 'ORNG':
        case 'KRYQ':
        case 'SPXP':
        case 'SCG':
        case 'SCGC':
        case 'SCGF':
        case 'SHF':
          this.checkZone.courierRates = this.selectedCourier.rates
          this.checkZone.province = {
            sameData: this.sameData.province,
            to: this.to.province,
            from: this.from.province
          }
          this.checkZone.sameData = this.sameData,
            this.checkZone.source = this.from.source,
            this.checkZone.weight = this.weight,
            this.checkZone.culculateSize = this.culculateSize
          this.checkZone.to = this.to;
          this.checkZone.from = this.from;
          this.checkZone.senderTel = this.sender.tel;
          this.checkZone.parcel = {
            weight: this.weight,
            width: this.width,
            length: this.length,
            height: this.height,
            key_size: this.keyBox
          };
          break;
        case 'MSE':
        case 'MSEC':
        case 'MSEF':
        case 'SPE':
        case 'SPEC':
          this.checkZone.courierRates = this.selectedCourier.rates
          this.checkZone.province = {
            sameData: this.sameData.province,
            to: this.to.province,
            from: this.from.province,
          }
          this.checkZone.source = this.from.source,
            this.checkZone.weight = this.weight,
            this.checkZone.culculateSize = this.culculateSize
          break
        case 'JNT':
          this.checkZone.province.from = this.shopDetail.province
          this.checkZone.district.from = this.shopDetail.district
          break;
        case 'BEST':
          this.checkZone.weight = Number(this.weight)
          this.checkZone.dimensionWeight = Number(this.dimensionWeight)
          break;
      }
      // console.log('setZone: ', this.selectedCourier)
    },
    async itemPrice() {
      this.clearInputValidateDimension()
      let key_size = this.keyBox
      let isSkipDimension = false
      const courierCode = this.selectedCourier.key
      // console.log('length selectedCourier: ', Object.keys(this.selectedCourier.rates).length)
      if (this.selectedCourier && Object.keys(this.selectedCourier.rates).length === 0) {
        const rates_backup = JSON.parse(sessionStorage.getItem('rates_backup'))
        const courierRef = rates_backup.find(res => res.id === this.selectedCourier.id)
        this.selectedCourier.rates = await groupBy(courierRef.rates, "type")
        this.couriers.find((res) => {
          if (res.id === this.selectedCourier.id) {
            res.rates = this.selectedCourier.rates
          }
        })
        // console.log('doing new of couriers: ', this.couriers)
        // console.log('doning set new: ', this.selectedCourier)
      }
      await this.setCheckZone(courierCode)

      // แจ้งเตือนขนส่ง scg พื้นที่พิเศษ
      const listCourier = this.listPostcodeSpecial[courierCode];
      if (['SCG', 'SCGC', 'SCGF'].includes(courierCode) && (listCourier && listCourier.specialarea.postcode.includes(this.checkZone.toPostcode))) {
        this.errorAlertParcel.status = true;
        this.checkZone.parcel = {
          weight: this.weight,
          width: this.width,
          length: this.length,
          height: this.height,
          key_size: key_size
        };
        let msg = [];

        msg.push('<span class="text-red">*</span> รับน้ำหนักสูงสุด 20 กิโลกรัม<br><span class="text-red">*</span> งดรับสินค้าประเภท ต้นไม้ แอลกอฮอล์ และ ของเหลวทุกชนิด')

        this.errorAlertParcel.msg = msg.join(' ');
        if (this.weight > 20000) {
          this.errorAlertParcel.disableButton = true;
        } else {
          this.errorAlertParcel.disableButton = false;
        }
      } else {
        this.errorAlertParcel.status = false;
        this.errorAlertParcel.msg = '';

        if (!this.errorAlertParcel.errorServiceArea.status) {
          this.errorAlertParcel.disableButton = false;
        }
      }

      this.courierDetails = await COURIER.setCourier(courierCode).getZone(this.checkZone, this.selectedCourier)
      let special_code = null
      console.log('⭐️ courierCode ', courierCode)
      console.log('⭐️ this.checkZone ', this.checkZone)
      console.log('⭐️ this.selectedCourier ', this.selectedCourier)
      console.log('🥝🥝🥝🥝🥝')
      this.type = this.courierDetails.rate_type

      let selected_rate = this.selectedCourier.rates[this.type]

      if ('special_code' in this.courierDetails && this.courierDetails.special_code) {
        selected_rate = this.selectedCourier.courier_promotions[this.type]
        special_code = this.courierDetails.special_code
      }
      if (this.type < 0) {
        return {
          status: false,
          type: 'weight'
        }
      }
      const weight = +this.weight
      let index = -1
      let courierRates = selected_rate
      let overWeightCharge = 0;
      let size = {
        width: this.width,
        length: this.length,
        height: this.height
      }

      let checkWeight = {
        weight: weight,
        index: index,
        size: size,
        keySize: key_size, //for SCG, SCGC, SCGF
        sizeCheckPrice: this.sizeCheckPrice,
        ...((['SCG', 'SCGC', 'SCGF'].includes(courierCode)) ? { fuelPrefix: this.courierDetails.fuel_prefix } : {})
      }
      if (courierRules.lockDimensionCouriers.includes(courierCode)) {
        // console.log('courier lock dim')
        if (['SCGC', 'SCGF'].includes(courierCode)) {
          if (weight > 20000) return { status: false, type: 'weight' }
        }

        let resWeight = await COURIER.setCourier(courierCode).checkWeight(
          courierRates,
          checkWeight
        )
        if (courierCode == 'SCG') {
          if (resWeight.findType == undefined) {
            return { status: false, type: 'weight' }
          } else {
            this.keyBox = resWeight.findType.size
            key_size = resWeight.findType.size
          }
        }

        // ใช้แก้ไขขนส่ง Kerry , SCGC , SCGF ระบุขนาดไม่ตรงกับ Size
        // console.log('rules dim size', courierRules.changeDimensionBySize, courierCode)
        if (courierRules.changeDimensionBySize.includes(courierCode) && resWeight.keySize) {
          // console.log('courier use key size')
          this.keyBox = resWeight.keySize
          key_size = resWeight.keySize
        }

        if (resWeight.fuelSurcharge) {
          this.courierDetails.fuel_surcharge = resWeight.fuelSurcharge
        }

        index = resWeight.index
      } else {
        let resWeight = await COURIER.setCourier(courierCode).checkWeight(
          courierRates,
          checkWeight,
          this.validate.modalParcel
        )
        this.calculateWeight = checkWeight;
        index = resWeight.index
        if (courierCode === 'FLE') {
          // วิธีคำนวณราคา Flash Express สำหรับขนาดแต่ละด้านไม่เกิน 42 cm ด้านยาวสุด ไม่เกิน 6 จะไม่คิดขนาดคิดเฉพาะน้ำหนัก
          isSkipDimension = this.flashSkipDimension(size, weight)
        }

        if (index > -1) {
          if (((courierRates[index].dimension && courierRates[index].dimension != 0)
            || (courierRules[courierCode] && courierRules[courierCode].dimensionRatio))
            && !isSkipDimension
          ) {

            let resDimension = COURIER.setCourier(courierCode).checkDimension(
              courierRates,
              {
                index: index,
                size: size,
                weight: weight
              },
              this.validate.modalParcel
            )
            index = resDimension.data.index

            this.dimensionWeight = resDimension.data.dimensionWeight
            // console.log('index dim', index, this.dimensionWeight, this.weight)
            if (this.dimensionWeight > this.weight || courierRules[courierCode].useDimensionWeightOnly) {
              this.calculateWeight = this.dimensionWeight;
            }
            const maxTier = courierRates[courierRates.length - 1];

            if (
              courierRules[courierCode].allowOverDimensionWeight &&
              this.dimensionWeight > maxTier.max && (
                !courierRules[courierCode].maxDimensionWeight ||
                (this.dimensionWeight <= courierRules[courierCode].maxDimensionWeight)
              )
            ) {
              overWeightCharge = this.dimensionWeight - parseInt(maxTier.max);
              overWeightCharge = Math.ceil(overWeightCharge / 1000) * courierRules[courierCode].dimensionWeightPrice;
              index = courierRates.length - 1
            } else if (resDimension.status == false) {
              return {
                status: false,
                type: 'dimension'
              }
            }
          }
        }
      }
      if (index <= -1) {
        this.prerate = 0
        this.selectedTier = {};
        return {
          status: false,
          type: 'weight'
        }
      }

      this.selectedTier = courierRates[index];
      // console.log('courierRates selected =>', index, courierRates)
      let travelSurcharge = 0;
      let islandSurcharge = 0;
      let extraHandlingCharge = 0;
      if (['FLE', 'FLEF', 'FLEWP'].includes(courierCode) && this.courierDetails.travel_surcharge) {
        travelSurcharge = COURIER.setCourier(courierCode).calculateExtraTravel(courierRates[index]);
        this.remote_area.travel_surcharge = travelSurcharge;
      }
      if (courierRules.extraHandlingCharge.includes(courierCode)) {
        extraHandlingCharge = COURIER.setCourier(courierCode).calculateExtraHandlingCharge({
          weight: this.weight,
          width: this.width,
          length: this.length,
          height: this.height
        });
      }
      travelSurcharge = (this.courierDetails.travel_surcharge < travelSurcharge) ? travelSurcharge : this.courierDetails.travel_surcharge;
      islandSurcharge = (this.courierDetails.island_surcharge < islandSurcharge) ? islandSurcharge : this.courierDetails.island_surcharge;

      // coupon
      if (this.main_allow_coupon && this.main_use_walletV2) {
        const shopCode = this.$USER_LOGIN.get().details.shop_code
        await this.handlePreviewCoupon({
          key: this.selectedCourier.key,
          weight,
          width: this.width,
          length: this.length,
          height: this.height,
          rate_id: this.selectedTier.id,
          edit: this.editorder
        }, shopCode, this)
      }

      return {
        price: parseFloat(courierRates[index].price) + overWeightCharge,
        rate: parseFloat(courierRates[index].rate) + overWeightCharge,
        fee: courierRates[index].fee,
        selectedTier: courierRates[index],
        remote_area: this.courierDetails.rate_remote_area,
        travel_surcharge: travelSurcharge || 0,
        island_surcharge: islandSurcharge,
        extra_handling_charge: extraHandlingCharge || 0,
        cross_price: this.courierDetails.cross_price,
        fuel_surcharge: this.courierDetails.fuel_surcharge || 0,
        key_size: key_size,
        special_code: special_code
      }
    },
    handlePreviewCoupon: debounce(async (currentParcel, shopCode, _this) => {
      // coupon
      const cartToken = cartPos.cartToken().get()
      const previousList = cartPos.draftStorage().get()

      if (!previousList || !cartToken) {
        return
      }

      const prev = previousList[shopCode][cartToken] || []

      await previewCoupon(currentParcel, prev).then((res) => {
        if (res.coupon_code) {
          _this.previewCouponResult = {
            total_discount_value: res.total_discount_value
          }
        } else {
          _this.previewCouponResult = null
        }
      }).catch(() => {
        _this.previewCouponResult = null
      })
    }, 800),
    getStashSpecialCode() {
      let stash = []

      if (this.cartShipping.length > 0) {
        for (const index in this.cartShipping) {
          let _cart = this.cartShipping[index]
          if (_cart.special_code && !stash.includes(_cart.special_code)) {
            stash.push(_cart.special_code)
          }
        }
      }

      if (this.addMoreOrder.order.length > 0) {
        for (const index in this.addMoreOrder.order) {
          let _tmp = this.addMoreOrder.order[index]
          if (_tmp.special_code && !stash.includes(_tmp.special_code)) {
            stash.push(_tmp.special_code)
          }
        }
      }
      return stash
    },
    flashSkipDimension(sizes, weight) {
      // condition detail => https://shippop.atlassian.net/browse/POP-185
      let overMax42 = false;
      let underEqual6 = false;
      Object.keys(sizes).forEach((s) => {
        if (!sizes[s]) return false
        if (sizes[s] <= 6) {
          underEqual6 = true
        } else if (sizes[s] > 42) {
          overMax42 = true
        }
      })
      return !overMax42 && underEqual6 && weight < 3000
    },
    async checkDestinationCourier() {
      if (this.to.postcode.length < 5) {
        return false
      }

      if (courierRules.courierServiceArea.includes(this.selectedCourier.key)) {
        this.isLoadingShip = true;
        let courierServiceArea = await getCourierServiceArea(this.to.postcode, this.selectedCourier.key)
        this.errorAlertParcel.disableButton = false;
        this.isLoadingShip = false;

        if (courierServiceArea.serviceDelay.status || courierServiceArea.serviceFreeze.status) {
          this.errorAlertParcel.errorServiceArea.status = true;
          if (courierServiceArea.serviceDelay.status) {
            this.errorAlertParcel.errorServiceArea.msg = `<span class="text-yellow">* ${courierServiceArea.serviceDelay.notice}</span>`
          } else if (courierServiceArea.serviceFreeze.status) {
            this.errorAlertParcel.errorServiceArea.msg = `<span class="text-red">* ${courierServiceArea.serviceFreeze.notice}</span>`
            this.errorAlertParcel.disableButton = true;
          }
        } else {
          this.errorAlertParcel.errorServiceArea.status = false;
          this.errorAlertParcel.errorServiceArea.msg = '';
        }
      }

      if (!['SCG', 'SCGC', 'SCGF'].includes(this.selectedCourier.key)) {
        return false
      }

      let listCourier = this.listPostcodeSpecial[this.selectedCourier.key];
      if (listCourier && (listCourier.specialarea.postcode.includes(this.to.postcode)
        || listCourier.lastmile3pl.postcode.includes(this.to.postcode))
      ) {
        this.errorAlertParcel.errorDestination.status = true;

        let msg = ['<span class="text-red">*</span> ปลายทางต่างจังหวัด ระยะเวลาจัดส่ง 2-4 วัน (ไม่นับวันหยุดราชการ และ วันหยุดนักขัตฤกษ์)'];
        if (listCourier.lastmile3pl.postcode.includes(this.to.postcode)) {
          msg.push('จัดส่งโดย 3 Party Logistics')
        }

        this.errorAlertParcel.errorDestination.msg = msg.join(' ');
      } else {
        this.errorAlertParcel.errorDestination.status = false;
        this.errorAlertParcel.errorDestination.msg = '';
      }
    },
    modalConfirmDuplicateOrder() {
      let msgAlert = 'ไม่สามารถทำรายการได้ เนื่องจากใบเสร็จนี้ถูกรับเงินไปแล้ว'
      this.$bvModal
        .msgBoxOk(`${msgAlert} `, {
          title: "แจ้งเตือน",
          size: "sm",
          buttonSize: "sm",
          okVariant: "warning",
          okTitle: "ยืนยัน",
          contentClass: "modal-confirm-alert",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true
        }).then(value => {
          if (value) {
            this.reStartOrderByOne();
            this.reset();
          }
        })
    },
    modalConfirmReset() {
      let msgAlert = 'คุณต้องการจะเปิดบิลใหม่';

      if (this.$THEME.btnCancelBill && !this.idorder && this.cart.length) {
        msgAlert = 'รายการที่คุณมีอยู่ขณะนี้จะถูกยกเลิก คุณแน่ใจที่จะยกเลิกรายการทั้งหมด ?'
      }

      this.$bvModal
        .msgBoxConfirm(`${msgAlert} `, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant: (this.$THEME.btnCancelBill && !this.idorder && this.cart.length) ? "danger" : "success",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            if (this.checkThemeQuick() && !this.idorder) {
              this.isLoadingNewBill = true;
              let orderDetailId = [];

              this.cart.forEach(order => {
                if (order.type === 'ship' && order.key !== 'GEN') {
                  orderDetailId.push(order.order_detail_id)
                }
              })

              cancelOrderByOne(this.orderIdByOne, orderDetailId).then(results => {
                if (results.status) {
                  const countListFail = results.data.list_fail.length
                  if (countListFail > 1) {
                    this.isLoadingNewBill = false;
                    this.showErrorModal(
                      `ไม่สามารถยกเลิกรายการได้ ${results.data.receipt_id}`
                    )
                    return false;
                  }
                  this.reStartOrderByOne();
                  this.reset();
                } else if (results == 'newbill') {
                  this.reStartOrderByOne();

                  if (!this.filterCheckKerryDropoff) {
                    this.reset();
                  }

                } else {
                  if (results.error.code == 'ORDER_ID_NOT_FOUND') {
                    this.reStartOrderByOne();
                    this.reset();
                  }
                }
              })
            } else {
              this.recheckCutOrderDraft = false
              this.reStartOrderByOne();
              this.newGenerateCartToken()
              if (!this.filterCheckKerryDropoff || this.idorder || !this.filterCheckFlashDropoff) {
                this.reset();
              }
              this.fetchOrderDraft()
            }
          }
        })
    },
    newGenerateCartToken() {
      return cartPos.cartToken().new()
    },
    reset() {
      location.reload();
    },
    formatDate() {
      this.errorBirthday = false
      let v = this.sender.birthday;
      if (v.match(/^\d{2}$/) !== null) {
        this.sender.birthday = v + "/";
      } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
        this.sender.birthday = v + "/";
      }
    },
    checkIdNo() {
      this.sender.id_no = swapBarcode(this.sender.id_no);
    },
    checkBarcode() {
      if (this.scanBarcode) {
        this.scanBarcode = swapBarcode(this.scanBarcode);
        let validateBarcode = PREBARCODE_PATTERN[this.selectedCourier.key].test(this.scanBarcode)
        if (validateBarcode === false || this.checkBarcodeInPurchase(this.scanBarcode, 'pre_barcode') >= 0) {
          this.barcodeOk = false;
          this.errorBarcode = true;
          this.scanBarcode = "";
          return false;
        }
        this.getBarcode(this.scanBarcode)
      }
      if (this.tracking) {
        this.tracking = swapBarcode(this.tracking);
        let validateTracking = validCourier(this.shop_id, this.selectedCourier.id, this.tracking);
        if (validateTracking === false || this.checkBarcodeInPurchase(this.tracking, 'pre_tracking') >= 0) {
          this.barcodeOk = false;
          this.errorBarcode = true;
          this.tracking = ""
          this.scanBarcode = "";
          return false;
        }
        this.getBarcode(this.tracking)
      }
    },
    checkBarcodeInPurchase(barcode = '', type = '') {
      if (this.cart.length > 0) {
        return this.cart.findIndex(parcel => {
          if (parcel[type] !== 'undefined') {
            return parcel[type] == barcode
          } else {
            return -1
          }
        })
      }
      if (this.addMoreOrder.order.length > 0) {
        return this.addMoreOrder.order.findIndex(parcel => {
          if (parcel[type] !== 'undefined') {
            return parcel[type] == barcode
          } else {
            return -1
          }
        })
      }
      return -1
    },
    getBarcode(scancode) {
      this.$http
        .get(API_URL + "/check/" + scancode, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          if (res.data.status == false) {
            this.barcodeOk = false;
            this.barcodeError = true;
            this.scanBarcode = "";
            this.tracking = "";
          } else {
            this.barcodeError = false;
            this.errorBarcode = false;
            this.barcodeOk = true;
            if (this.scanBarcode) {
              this.$nextTick(() => this.$refs.toName.$refs.input.focus())
            }
          }
        })
        .catch(() => {
          this.showErrorModal(
            "ไม่สามารถเช็คเลข Prebarcode ได้ กรุณาลองใหม่อีกครั้ง"
          );
        });
    },
    focusMyElement() {
      this.$refs.focusWeight.focus()
    },
    focusWeightParcel() {
      this.$refs.focusWeightParcel.focus()
    },
    lockDimensionParcel() {
      let dimension = {
        width: this.width,
        length: this.length,
        height: this.height,
        size: this.size.boxSize
      }

      let keyCourier = this.selectedCourier.key;

      if (this.checkDropoffEasyShip()) {
        keyCourier = `EASYSHIP`
      } else if (this.checkDropoffVRich()) {
        keyCourier = `VRICH`
      } else if (this.checkDropoffPanPan()) {
        keyCourier = `PANPAN`
      }

      let key = `${keyCourier}_${this.shop_id}`
      let setDimension = this.getDimensionLocalStorage()

      if (setDimension.status) {
        setLocalStorage.dimension().remove(key);
        this.favoriteDimension = false;
        return false;
      }

      if (courierRules.lockWeightCouriers.includes(this.selectedCourier.key)) {
        dimension.weight = this.weight;
      }

      if (dimension.width > 0 || dimension.length > 0 || dimension.height > 0) {
        setLocalStorage.dimension().set(key, dimension);
        this.favoriteDimension = true;
      }
    },
    getDimensionLocalStorage() {
      let keyCourier = this.selectedCourier.key;

      if (this.checkDropoffEasyShip()) {
        keyCourier = `EASYSHIP`
      } else if (this.checkDropoffVRich()) {
        keyCourier = `VRICH`
      } else if (this.checkDropoffPanPan()) {
        keyCourier = `PANPAN`
      }

      let key = `${keyCourier}_${this.shop_id}`;
      let checkDimension = setLocalStorage.dimension().get(key);
      return (checkDimension[key])
        ? { status: true, data: checkDimension[key] }
        : { status: false }
    },
    showNotiModal(msgBody, msgColor = '', setStyle = {}, isInnerHtml = false) {

      const h = this.$createElement
      let style = {
        text: (setStyle.text ? setStyle.text : 'text-center') + ' mt-2',
        emphasize: (setStyle.emphasize
          ? setStyle.emphasize
          : 'text-center text-danger') + ' mb-0'
      }
      if (isInnerHtml) {
        this.$bvModal.msgBoxOk(
          h('div',
            [
              h('div', {
                class: ['d-flex justify-content-center']
              }, [h('i', {
                class: ['fa fa-exclamation-circle text-warning'],
                style: 'font-size:90px;'
              }
              )
              ]
              ),
              h('h4', { class: [style.text], domProps: { innerHTML: [msgBody[0]] } }),
              h('h4', { class: [style.text], domProps: { innerHTML: [msgBody[1]] } }),
              h('h4', { class: [style.text], domProps: { innerHTML: [msgBody[2]] } }),
              h('h4', { class: [style.emphasize] }, [msgColor])
            ]
          ), {
          title: h('div', { domProps: { innerHTML: '<h3 style="color:black;">ข้อความแจ้งเตือน</h3>' } }),
          size: "sm",
          buttonSize: "sm",
          okVariant: "warning",
          okTitle: "ยืนยัน",
          contentClass: "modal-warning",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
      } else if (typeof msgBody === 'object') {
        this.$bvModal.msgBoxOk(
          h('div',
            [
              h('div', {
                class: ['d-flex justify-content-center']
              }, [h('i', {
                class: ['fa fa-exclamation-circle text-warning'],
                style: 'font-size:90px;'
              }
              )
              ]
              ),
              h('h4', { class: [style.text] }, [msgBody[0]]),
              h('h4', { class: [style.text] }, [msgBody[1]]),
              h('h4', { class: [style.text] }, [msgBody[2]]),
              h('h4', { class: [style.text] }, [msgBody[3]]),
              h('h4', { class: [style.text] }, [msgBody[4]]),
              h('h4', { class: [style.emphasize] }, [msgColor])
            ]
          ), {
          title: h('div', { domProps: { innerHTML: '<h3 style="color:black;">ข้อความแจ้งเตือน</h3>' } }),
          size: "sm",
          buttonSize: "sm",
          okVariant: "warning",
          okTitle: "ยืนยัน",
          contentClass: "modal-warning",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
      } else
        this.$bvModal.msgBoxOk(
          h('div',
            [
              h('div', {
                class: ['d-flex justify-content-center']
              }, [h('i', {
                class: ['fa fa-exclamation-circle text-warning'],
                style: 'font-size:90px;'
              }
              )
              ]
              ),
              h('h4', { class: ['text-center mt-2'] }, [msgBody]),
              h('h4', { class: ['text-center text-danger mb-0'] }, [msgColor])
            ]
          ), {
          title: h('div', { domProps: { innerHTML: '<h3 style="color:black;">ข้อความแจ้งเตือน</h3>' } }),
          size: "sm",
          buttonSize: "sm",
          okVariant: "warning",
          okTitle: "ยืนยัน",
          contentClass: "modal-warning",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
    },
    checkThemeQuick() {
      return this.$THEME.name == 'quickexpress';
    },
    checkUntiKG() {
      return this.$THEME.unitKG;
    },
    checkNotCloseModal() {
      return this.dropoffEasyShip.notCloseModal == true;
    },
    checkDropoffVRich() {
      return this.dropoffVRich.show == true;
    },
    checkDropoffPanPan() {
      return this.dropoffPanPan.show == true;
    },
    checkDropoffEasyShip() {
      return this.dropoffEasyShip.show == true;
    },
    checkDropoffQuick() {
      return this.dropoffQuick.show == true;
    },
    checkDisableInputDropoff() {
      return this.checkDropoffVRich()
        || this.checkDropoffQuick()
        || this.checkDropoffEasyShip()
        || this.checkDropoffPanPan()
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    showErrorModal(msgBody, msgTitle = 'ลองอีกครั้ง') {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: msgTitle,
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    updateCodProducts(newValues) {
      this.codProducts = newValues
    },
    handleOpenNoticeCodInfo() {
      this.noticeCodInfoModal.open = true
    },
    handleCloseNoticeCodInfo() {
      this.noticeCodInfoModal.open = false
    },
    handleOpenCodAgreementModal() {
      this.codAgreementModal.open = true
    },
    handleCloseCodAgreementModal() {
      this.codAgreementModal.open = false
    },
  },
  computed: {
    isDropoffSelected() {
      return (
        this.checkDropoffVRich() ||
        this.checkDropoffPanPan() ||
        this.checkDropoffEasyShip() ||
        this.checkDropoffQuick()
      )
    },
    isShipDisabled() {
      const isGuest = this.sender && this.sender.mem_id === 0
      const isCodWithoutAgreement = (this.cod_details && this.cod_details.isCod) && !this.isCodAgreementAgreed

      return (
        this.isLoadingShip ||
        this.rateError ||
        (this.errorAlertParcel && this.errorAlertParcel.disableButton) ||
        (this.isDropoffSelected && Number(this.codAmount) > 0 && isGuest) ||
        this.submitAddShipping ||
        isCodWithoutAgreement
      )
    },
    buttonLabel() {
      const isQuickTheme = typeof this.checkThemeQuick === 'function' ? this.checkThemeQuick() : false
      const isEditing = this.editorder
      const isDropoffForLabel = this.checkDropoffVRich() || this.checkDropoffPanPan() || this.checkDropoffQuick()

      return isQuickTheme && !isEditing && !isDropoffForLabel ? 'พิมพ์ใบปะหน้า' : 'ยืนยัน'
    },
    checkErrorCreateOrderByExcel: {
      get() {
        return this.orderExcel.error
      },
      set(value) {
        if (value === true || value.status === true) {
          return this.orderExcel.error = []
        }
        let res = {
          header: null,
          body: null
        }
        const typeInvalidExcel = 'invaid_format'
        const typeInvalidLengthExcel = 'invaid_length'
        value.error.forEach(error => {
          if (error.type === typeInvalidExcel) {
            res.header = 'รูปแบบไฟล์ไม่ถูกต้อง'
            res.body = error.msg
          } else if (error.type === typeInvalidLengthExcel) {
            res.header = 'ทำรายการเกินจำนวนออเดอร์ที่กำหนด'
            res.body = error.msg
          }
          this.orderExcel.error.push(res)
        })
      }
    },
    action: {
      get() {
        return this.actioned
      },
      set(val) {
        this.actioned = val
      }
    },
    isVisibleShabuVoucher() {
      if (this.shubuVoucherAllow.hasOwnProperty('SHABU')) {
        let shopShabuAllow = this.shubuVoucherAllow.SHABU.SHOP.find((id) => {
          return this.shop_id == id
        })
        if (shopShabuAllow) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    issetParcelInsurance() {
      return this.insurance.listRates.length > 0
    },
    checkErrorParcelInsurance() {
      let res = {
        status: true,
        data: []
      }
      if ((this.insurance.isCheck && this.submitAddShipping) || (this.insurance.isCheck && this.$v.insurance.declared_value.$error)) {
        res.data.push('กรุณากรอก มูลค่าสินค้า')
      } else if (this.insurance.isCheck && this.insurance.error.status) {
        res.data.push(this.insurance.error.msg)
      } else {
        res.status = false
        res.data = []
      }
      return res
    },
    checkErrorSeletedParcelInsurance() {
      let res = {
        status: true,
        data: []
      }

      if ((this.insurance.isCheck && this.submitAddShipping) || (this.insurance.isCheck && this.$v.insurance.remark.$error)) {
        res.data.push('กรุณาเลือกประเภทสินค้า')
      } else {
        res.status = false
        res.data = []
      }

      return res
    },
    showPreRate() {
      return Number(+this.prerate) + (+(this.insurance ? this.insurance.listPrice.price : 0))
    },
    // total คิดเงิน
    total() {
      return this.cart.reduce((total, product) => {
        let remote_area = 0
        let crossPrice = 0
        let fuelSurcharge = 0;
        let travel_surcharge = 0;
        let island_surcharge = 0;
        let service_price_inter = 0;
        let extra_handling_charge = 0;
        if (product.rate_remote_area) {
          remote_area = product.rate_remote_area
        }
        if (product.travel_surcharge) {
          travel_surcharge = product.travel_surcharge
        }
        if (product.island_surcharge) {
          island_surcharge = product.island_surcharge
        }
        if (product.cross_price) {
          crossPrice = product.cross_price
        }
        if (product.extra_handling_charge) {
          extra_handling_charge = product.extra_handling_charge
        }
        if (product.fuel_surcharge) {
          fuelSurcharge = product.fuel_surcharge
        }
        if (product.service_price_inter) {
          service_price_inter = product.service_price_inter
        }
        return total + (Number(product.num) * Number(product.price)) + Number(service_price_inter) + Number(remote_area) + Number(travel_surcharge) + Number(island_surcharge)
          + Number(extra_handling_charge) + Number(crossPrice) + Number(fuelSurcharge) + Number(product.insurance ? product.insurance.listPrice.price : 0)
      }, 0);
    },
    totalCourierPrice() {
      return this.cartShipping.reduce((total, itemShip) => {
        let fuelSurcharge = 0
        if (itemShip.fuel_surcharge) {
          fuelSurcharge = itemShip.fuel_surcharge
        }
        return total + (Number(itemShip.num) * Number(itemShip.price)) + Number(fuelSurcharge) + Number(itemShip.insurance ? itemShip.insurance.listPrice.price : 0)
      }, 0);
    },
    totalShipping() {
      return this.cartShipping.reduce((total, itemShip) => {
        let remote_area = 0
        let travel_surcharge = 0
        let island_surcharge = 0
        let extra_handling_charge = 0
        let crossPrice = 0
        let fuelSurcharge = 0
        if (itemShip.rate_remote_area) {
          remote_area = itemShip.rate_remote_area
        }
        if (itemShip.travel_surcharge) {
          travel_surcharge = itemShip.travel_surcharge
        }
        if (itemShip.island_surcharge) {
          island_surcharge = itemShip.island_surcharge
        }
        if (itemShip.extra_handling_charge) {
          extra_handling_charge = itemShip.extra_handling_charge
        }
        if (itemShip.cross_price) {
          crossPrice = itemShip.cross_price
        }
        if (itemShip.fuel_surcharge) {
          fuelSurcharge = itemShip.fuel_surcharge
        }
        return total + (Number(itemShip.num) * Number(itemShip.price)) + Number(remote_area) +
          Number(travel_surcharge) + Number(island_surcharge) + Number(extra_handling_charge) +
          + Number(crossPrice) + Number(fuelSurcharge) + Number(itemShip.insurance ? itemShip.insurance.listPrice.price : 0)
      }, 0);
    },
    culculateSize() {
      return [this.width, this.length, this.height].reduce((sum, num) => {
        return sum + Number(num)
      }, 0)
    },
    cartShipping() {
      return this.cart.filter(item => {
        return item.type === "ship";
      });
    },
    cartDropoffShippop() {
      return this.cart.filter(item => {
        return item.type === DROPOFF_SP;
      })
    },
    cartKerryDropoff() {
      return this.cartShipping.filter(order => {
        return order.hasOwnProperty('dropoff_type') && (order.dropoff_type == 'KERRY_DROPOFF' || order.dropoff_type == 'ORANGE_DROPOFF');
      });
    },
    cartFlashDropoff() {
      return this.cartShipping.filter(order => {
        return order.hasOwnProperty('dropoff_type') && (order.dropoff_type == 'FLASH_DROPOFF')
      })
    },
    cartLazadaDropoff() {
      return this.cartShipping.filter(order => {
        return order.hasOwnProperty('dropoff_type') && (order.dropoff_type == 'LAZADA_DROPOFF');
      });
    },
    cartDropoffVRich() {
      if (this.checkThemeQuick()) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'VRICH_DROPOFF';
        });
      }
      return false;
    },
    cartDropoffPanPan() {
      if (this.checkThemeQuick()) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'PANPAN_DROPOFF';
        });
      }
      return false;
    },
    cartDropoffQuick() {
      if (this.checkThemeQuick()) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'QUICK_DROPOFF';
        });
      }
      return false;
    },
    // courierFilter() {
    //   return this.couriers.filter(item => {
    //     return item.title
    //       .toLowerCase()
    //       .includes(this.searchCourier.toLowerCase());
    //   });
    // },
    identityTxtCod() {
      let msg = 'สามารถใช้ COD ได้'
      if (!this.sender.identity) {
        msg = 'ไม่สามารถใช้ COD ได้'
      }
      return msg
    },
    lockDimension() {
      let res = false
      if (courierRules.lockDimensionCouriers.includes(this.selectedCourier.key)) {
        res = true
      }
      return res
    },
    lockWeight() {
      let res = false
      if (courierRules.lockWeightCouriers.includes(this.selectedCourier.key)) {
        res = true
      }
      return res
    },
    cloneAddressTo() {
      return JSON.parse(JSON.stringify(this.to))
    },
    cloneAddressFrom() {
      return JSON.parse(JSON.stringify(this.from))
    },
    checkDateEVoucher() {
      if (new Date().getTime() < new Date('2022-01-01 00:00:00').getTime()) {
        return true
      }
      return false
    },
    filterOrderIsPrebarcode() {
      return this.cartShipping.filter((order) => {
        return order.hasOwnProperty('courier') && order.courier.prebarcode
      }).length > 0;
    },
    filterCheckOrderDetailId() {
      if (this.checkThemeQuick()) {
        return this.cartShipping.filter((order) => {
          return !order.hasOwnProperty('order_detail_id') && (order.hasOwnProperty('courier') && !order.courier.prebarcode)
        }).length > 0;
      }

      return false;
    },
    filterCheckDropoffVRich() {
      if (this.checkThemeQuick()) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'VRICH_DROPOFF';
        }).length > 0;
      }

      return false;
    },
    filterCheckDropoffPanPan() {
      if (this.checkThemeQuick()) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'PANPAN_DROPOFF';
        }).length > 0;
      }

      return false;
    },
    filterCheckDropoffQuick() {
      if (this.permission.dropoffQuick) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'QUICK_DROPOFF';
        }).length > 0;
      }

      return false;
    },
    filterCheckKerryDropoff() {
      if (this.$THEME.dropoffKerry || this.permission.kerryDropoff || this.permission.orangeDropoff) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && ['KERRY_DROPOFF', 'ORANGE_DROPOFF'].includes(order.dropoff_type);
        }).length > 0;
      }
      return false;
    },
    filterCheckFlashDropoff() {
      if (this.permission.flashDropoff) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && ['FLASH_DROPOFF'].includes(order.dropoff_type)
        }).length > 0
      }

      return false
    },
    filterCheckLazadaDropoff() {
      // console.log('this.permission.lazadaDropoff')
      if (this.permission.lazadaDropoff) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && ['LAZADA_DROPOFF'].includes(order.dropoff_type);
        }).length > 0;
      }
      return false;
    },
    filterCheckEasyShip() {
      if (this.checkPermissionDropoffEasyShip()) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'EASYSHIP_DROPOFF'
        }).length > 0;
      }
      return false
    },
    filterCheckDropoffLine() {
      if (this.permission.lineBooking) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'LINE_BOOKING_DROPOFF';
        }).length > 0;
      }
      return false;
    },
    filterCheckDropoffINTER() {
      if (this.permission.interParcelService) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'INTER_BOOK';
        }).length > 0
      }
      return false;
    },
    filterCheckDropoffLAO() {
      if (this.permission.interParcelService) {
        return this.cartShipping.filter((order) => {
          return order.hasOwnProperty('dropoff_type') && order.dropoff_type == 'LAO_BOOK';
        }).length > 0
      }
      return false;
    },
    isCodAgreementAgreed() {
      return this.memberService.isAcceptedCodAgreement
    }
  },
  watch: {
    'busy': function () {
      let prod = this.productAvoid
      if (!this.busy && this.firstLoad) {
        prod.show = true
        prod.isBanner = true
        prod.key = 'banner'
      }
    },
    cloneAddressTo: function (oldVal, newVal) {

      if (this.selectedCourier.key == "FLE") {

        for (let key in oldVal) {
          if (oldVal[key] != newVal[key] && this.validateAddress.to[key] && this.validateAddress.to[key].status) {

            this.validateAddress.to[key].status = false
            this.validateAddress.to[key].msg = null

          }
        }

      }

    },
    cloneAddressFrom: function (oldVal, newVal) {

      if (this.selectedCourier.key == "FLE") {

        for (let key in oldVal) {

          if (oldVal[key] != newVal[key] &&
            this.validateAddress.from[key] &&
            (this.validateAddress.from[key].status || this.errorCreateOrderByOne.status)
          ) {

            this.validateAddress.from[key].status = false
            this.validateAddress.from[key].msg = null

            this.errorCreateOrderByOne.status = false
            this.errorCreateOrderByOne.msg = null

          }
        }
      }
    },
    'to.postcode': function (postcode) {
      this.changePostcode(postcode)
    },
    'from.postcode': function (postcode) {
      this.changePostcode(postcode)
    },
    'from.source': function () {
      this.itemPreRate()
    },
    'from.province': function (event) {
      this.changeProvince(event)
    },
    'to.province': function (event) {
      this.changeProvince(event)

    },

  }
};
</script>
<style lang="scss" scoped>
.max-width-fix {
  max-width: 3% !important;
}
.button-tooltip-container {
  position: relative;
  display: inline-block;
}

.button-tooltip-container .tooltip-text {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: -35px; /* Position tooltip above the button */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s;
}

.button-tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
